import { useSelector } from "react-redux";
import { Routes, Route, Navigate, RoutesProps } from "react-router-dom";
import { RootState } from "../config/Store";
import Main from "../Main";
import { UserState } from "../reducers/AuthReducer";
import Loader from "../components/Loader/Loader";
import DashboardSkeleton from "../components/Skeleton/DashboardSkeleton";
import ArchivedGoalsSkeleton from "../screens/DataEntryOperator/Goals/GoalsSkeleton";
import { MasterCompanyMasterSkeleton, ArchivedBusinessAccreditationSkeleton, ArchivedBranchesSkeleton } from "../screens/Admin/Masters/MasterSkeletons"; // Masters route fallbacks
import InsuranceSkeleton from "../screens/DataEntryOperator/Insurance/InsuranceSkeleton";
import ExpensesDetailsSkeleton from "../screens/DataEntryOperator/Expenses/ExpensesDetailsSkeleton";
import { HealthPageSkeleton, AddressPageSkeleton, IncomePageSkeleton, ExpensesPageSkeleton, ArchivedAddressPageSkeleton, ArchivedIncomePageSkeleton } from "../screens/DataEntryOperator/Information/InfoSkeletons";
import React from "react";
import { Suspense } from "react";
import ProtectedRoute from "./ProtectedRoute";
import RequireRole from "../components/RequireRole/RequireRole";
import { HR_ROLES, HR_APPROVER_ROLES } from "../utility/RoleService";
import Goals from "../screens/DataEntryOperator/Goals/Goals";
import Documents from "../screens/Documents/Documents";
import FixedReturnandRetirementProducts from "../screens/SuperAdmin/ProductMaster/ProductParameter/FixedReturnandRetirementProducts/FixedReturnandRetirementProducts";
import AddFixedReturnandRetirementProducts from "../screens/SuperAdmin/ProductMaster/ProductParameter/FixedReturnandRetirementProducts/AddFixedReturnandRetirementProducts";
import ArchivedFixedReturnandRetirementProducts from "../screens/SuperAdmin/ProductMaster/ProductParameter/FixedReturnandRetirementProducts/ArchivedFixedReturnandRetirementProducts";
import Agreement from "../screens/Admin/MisReport/Agreement/Agreement";
import AddAgreement from "../screens/Admin/MisReport/Agreement/AddAgreement";
import ArchivedAgreement from "../screens/Admin/MisReport/Agreement/ArchivedAgreement";
import AgreementUploadDocument from "../screens/Admin/MisReport/Agreement/AgreementUploadDocument";
import AgreementReport from "../screens/SuperAdmin/MisReport/AgreementReport";
import MomSubmitted from "../screens/DataEntryOperator/Action/MomSubmitted";






const lazyRetry = function (componentImport: any) {
  return new Promise<any>((resolve, reject) => {
    componentImport().then((component: any) => {
      resolve(component);
    }).catch((error: any) => {
      reject(error); // there was an error
    });
  });
};

const SmallCaseSdkBlankPage = React.lazy(() => lazyRetry(() => import("../components/SpringMoney/Transactions/SmallCaseSdkBlankPage")));
const Login = React.lazy(() => lazyRetry(() => import("../screens/Login/Login")));
const ForgetPassword = React.lazy(() => import("../screens/Login/ForgetPassword/ForgetPassword"));
const SetPassword = React.lazy(() => import("../screens/Login/SetPassword"));

const Alerts = React.lazy(() => import("../screens/DataEntryOperator/Alerts"));
const MyProfile = React.lazy(() => import("../screens/DataEntryOperator/MyProfile"));
const ChangePassword = React.lazy(() => import("../screens/DataEntryOperator/ChangePassword"))
// Step Wizard

const Otp = React.lazy(() => import("../screens/Login/Otp"));
const Welcome = React.lazy(() => import("../screens/NewRegistration/Welcome"));
const SelfInfo = React.lazy(() => import("../screens/NewRegistration/SelfInfo"));
const SpouseInfo = React.lazy(() => import("../screens/NewRegistration/SpouseInfo"));
const Members = React.lazy(() => import("../screens/NewRegistration/Members"));
const AddMember = React.lazy(() => import("../screens/NewRegistration/AddMember"));
const MembersList = React.lazy(() => import("../screens/NewRegistration/MembersList"));

// DATA ENTRY OPERATOR
const Review = React.lazy(() => import("../screens/DataEntryOperator/Review/Review"));
const ReviewCompleted = React.lazy(() => import("../screens/DataEntryOperator/Review/ReviewCompleted"));
const ReviewDetails = React.lazy(() => import("../screens/DataEntryOperator/Review/ReviewDetails"));
const ReviewCancelled = React.lazy(() => import("../screens/DataEntryOperator/Review/ReviewCancelled"));
const ReviewCalendar = React.lazy(() => import("../screens/DataEntryOperator/Review/ReviewCalendar"));

// 1) Dashboard Module
const DashBoard = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/Dashboard"));
const NewRiskProfile = React.lazy(() => import("../screens/Dashboard/RiskProfile/NewRiskProfile"));
const NewRiskProfileQue = React.lazy(() => import("../screens/Dashboard/RiskProfile/NewRiskProfileQue"));
const NewRiskProfileQueManual = React.lazy(() => import("../screens/Dashboard/RiskProfile/NewRiskProfileQueManual"));
const NewRiskProfileQueSystem = React.lazy(() => import("../screens/Dashboard/RiskProfile/NewRiskProfileQueSystem"));
const NewRiskProfileDeclaimer = React.lazy(() => import("../screens/Dashboard/RiskProfile/NewRiskProfileDeclaimer"));
const NewRiskProfileOverride = React.lazy(() => import("../screens/Dashboard/RiskProfile/NewRiskProfileOverride"));
const OverrideDisclaimer = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/RiskProfile/OverrideResult"));
const RiskProfilHistory = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/RiskProfile/RiskProfileHistory"));
const RiskProfileInviteLanding = React.lazy(() => import("../screens/RiskProfileInvite/RiskProfileInviteLanding"));
const RiskProfileInviteDone = React.lazy(() => import("../screens/RiskProfileInvite/RiskProfileInviteDone"));
const RiskProfileLinkList = React.lazy(() => import("../screens/Admin/Accouting/Operation/RiskProfileLink/RiskProfileLink"));
//Establisment Menu
const Establishment = React.lazy(() => import("../screens/DataEntryOperator/Information/Establishment/AddEstablishmentDetails"));

// 2) Information Module
const Family = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/Family"));
const EditFamilyMember = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/EditFamilyMember"));
const AddFamilyMember = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/AddFamilyMember"));
const ArchivedFamily = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/ArchivedFamily"));

const AddBankAccount = React.lazy(() => import("../screens/DataEntryOperator/Information/Accounts/AddBankAccount"));
const AddDmatAccount = React.lazy(() => import("../screens/DataEntryOperator/Information/Accounts/AddDmatAccount"));
const AddMfCard = React.lazy(() => import("../screens/DataEntryOperator/Information/Accounts/AddMfCard"));
const AccountMandates = React.lazy(() => import("../screens/DataEntryOperator/Information/Accounts/AccountMandates/AccountMandates"));
const AddAccountMandates = React.lazy(() => import("../screens/DataEntryOperator/Information/Accounts/AccountMandates/AddAccountMandates"))
const ArchivedAccountMandates = React.lazy(() => import("../screens/DataEntryOperator/Information/Accounts/AccountMandates/ArchivedAccountMandates"));
const BankAccounts = React.lazy(() => import("../screens/DataEntryOperator/Information/Accounts/BankAccounts"));
const Income = React.lazy(() => import("../screens/DataEntryOperator/Information/Income/Income"));
const AddIncome = React.lazy(() => import("../screens/DataEntryOperator/Information/Income/AddIncome"));
const IncomeArchived = React.lazy(() => import("../screens/DataEntryOperator/Information/Income/ArchivedIncome"));

const Loans = React.lazy(() => import("../screens/DataEntryOperator/Information/Loans/Loans"));
const AddLoan = React.lazy(() => import("../screens/DataEntryOperator/Information/Loans/AddLoan"));
const LoansArchived = React.lazy(() => import("../screens/DataEntryOperator/Information/Loans/LoansArchived"));
const LoansAmortization = React.lazy(() => import("../screens/DataEntryOperator/Information/Loans/LoansAmortization"));
const ImportAmotizationLoan = React.lazy(() => import("../screens/DataEntryOperator/Information/Loans/ImportAmotiztionLoan"));
const GenerateAmotizationLoan = React.lazy(() => import("../screens/DataEntryOperator/Information/Loans/GenerateAmotizationLoan"));

const Address = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/Address"));
const AddAddress = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/AddAddress"));
const AddressArchivedList = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/AddressArchivedList"));

const PhysicalAssetHousehold = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsHousehold/PhysicalAssetsHousehold"));
const AddPhysicalAssetsHousehold = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsHousehold/AddPhysicalAssetsHousehold"));
const PhysicalAssetHouseholdArchivedList = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsVehicle/PhysicalAssetHouseholdArchivedList"));
const MultipleAddHouseHold = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsHousehold/MultipleAddHouseHold"));

const HealthLifestyle = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/HealthLifestyle"));
const AddHealthLifestyle = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/AddHealthLifestyle"));

const Occupation = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/Occupation"));
const EditOccupation = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/EditOccupation"));
const OccupationArchived = React.lazy(() => import("../screens/DataEntryOperator/Information/Personal/OccupationArchived"));

const Insurance = React.lazy(() => import("../screens/DataEntryOperator/Insurance/Insurance"));
const AddInsurance = React.lazy(() => import("../screens/DataEntryOperator/Insurance/AddInsurance"));
const InsuranceRiders = React.lazy(() => import("../screens/DataEntryOperator/Insurance/InsuranceRiders"));
const ArchivedInsurance = React.lazy(() => import("../screens/DataEntryOperator/Insurance/ArchivedInsurance"));
const FutureInsurance = React.lazy(() => import("../screens/DataEntryOperator/Insurance/FutureInsurance"));
const AddMoneyBackPayout = React.lazy(() => import("../screens/DataEntryOperator/Insurance/AddMoneyBackPayout"));

const Vehicles = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsVehicle/PhysicalAssetsVehicles"));
const PhysicalAssetsVehicle = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsVehicle/PhysicalAssetsVehicles"));
const AddPhysicalAssetsVehicle = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsVehicle/AddPhysicalAssetsVehicles"));
const PhysicalAssetsVehicleArchived = React.lazy(() => import("../screens/DataEntryOperator/Information/PhysicalAssets/PhysicalAssetsVehicle/PhysicalAssetVehicleArchivedList"));

//Header 

const ArchivedDocument = React.lazy(() => import("../screens/DataEntryOperator/Header/Document/ArchivedDocument"));
const AddDocument = React.lazy(() => import("../screens/DataEntryOperator/Header/Document/AddDocument"));
const MyDocuments = React.lazy(() => import("../screens/DataEntryOperator/Header/Document/MyDocuments"));
const Discrepanices = React.lazy(() => import("../screens/DataEntryOperator/Header/Discrepancies/Discrepancies"));


// 3) Portfolio
const Portfolio = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/Porfolio"));
const PpfAccount = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/PpfAccount"));
const AddPpfAccount = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddPpfAccount"));
const PpfArchivedAccounts = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/PpfArchivedAccount"));


const AddEpfDetails = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddEpfDetails"));
const AddEpfPassbookEntry = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddEpfPassbookEntry"));
const NpsDetails = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/NpsDetails"));

const AddNpsDetails = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddNpsDetails"));
const NpsDetailArchieved = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/NpsDetailArchived"));
const AddPpfPassbookEntry = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddPpfPassbookEntry"));
const AddSuperannuationDetails = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddSuperannuationDetails"));
const SuperAnnutationArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SuperannutationArchived"));
const BondsAndDebenturesArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/BondsAndDebentureArchived"));
const BondsAndDebentures = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/BondsAndDebentures"));
const AddBondAndDebentures = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddBondAndDebentures"));
const BullionInvestments = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/BullionInvestments"));
const EditBullionInvestments = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/EditBullionInvestments"));
const BullionInvestmentsArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/BullionInvestmentArchived"));
const ArcheivedBullionSip = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/ArcheivedBullionSip"));
const AddBullionSip = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddBullionSip"));
const CashEquivalents = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/CashEquivalents"));
const EpfAccount = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/EpfAccount"));
const EpfArchieved = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/EpfArchieved"));
const EpfPassbook = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/EpfPassbook"));
const AddFixedReturn = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddFixedReturn"));
const FixedReturn = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/FixedReturn"));
const FixedReturnArchieved = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/FixedReturnArchieved"));
const FixedReturnInterestRecords = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/FixedReturnInterestRecords"));
const FixedReturnInterestRecordsArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/FixedReturnIntrestRecordArchived"));
const FixedReturnPassbook = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/FixedReturnPassbook"));
const InsurancePortfolio = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/InsurancePortfolio"));

const MutualFunds = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/MutualFunds"));
const MutualFundsTransactions = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/MutualFundsTransactions"));
const MutualFundsArchivedList = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/MutualFundsArchivedList"));
const MutualFundsTransactionsArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/MutualFundsTransactionsArchived"));
const SystematicInvestmentArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SystematicInvestmentArchived"));
const SystematicInvestmentFuture = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SystematicInvestmentFuture"));
const AddSipStpSwp = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddSipStpSwp"));

const PpfPassbook = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/PpfPassbook"));
const RealEstateProperties = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/RealEstateProperties"));
const AddRealEstate = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddRealEstateProperties"));
const RealEstateArchivedAccounts = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/RealEstateArchived"));


const ShareETF = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/ShareETF"));
const ShareEtfTransactions = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SahreEtfTransactions"));
const ShareETFHoldingArchivedList = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/ShareETFHoldingArchivedList"));
const ShareEtfTransactionsArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SahreEtfTransactionsArchived"));
const ChangeDmat = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/ChangeDmat"));
const UpdateShareEtfTransaction = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/UpdateShareEtfTransaction"));
const AddShareEpfSip = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddShareEpfSip"));
const ArcheivedShareSip = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/ArcheivedSharesSip"));

const SsyAddAccount = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SsyAddAccount"));
const SsyAccount = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SsyAccount"));
const SsyArchivedAccounts = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SsyArchivedAccount"));
const SsyPassbook = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SsyPassbook"));
const AddSsyPassbookEntry = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AddSsyPassbookEntry"));


const SuperannuationAcc = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/SuperannuationAcc"));
const UpdateMutualFundTransaction = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/UpdateMutualFundTransaction"));

// 4) Goals Module
// const Goals = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/Goals/Goals"));
const AddGoal = React.lazy(() => import("../screens/DataEntryOperator/Goals/AddGoal"));
const ArcheivedGoals = React.lazy(() => import("../screens/DataEntryOperator/Goals/ArcheivedGoals"));

// 5) Expense Module
const Expenses = React.lazy(() => import("../screens/DataEntryOperator/Expenses/Expenses"));
const ExpensesDetails = React.lazy(() => import("../screens/DataEntryOperator/Expenses/ExpensesDetails"));
const ExpensesMinimum = React.lazy(() => import("../screens/DataEntryOperator/Expenses/ExpensesMinimum"));
const ExpensesDetailsSave = React.lazy(() => import("../screens/DataEntryOperator/Expenses/ExpensesDetailsSave"));

// 6) Action
const Actions = React.lazy(() => import("../screens/DataEntryOperator/Action/Actions"));
const AddAction = React.lazy(() => import("../screens/DataEntryOperator/Action/AddAction"));
const MyTask = React.lazy(() => import("../screens/DataEntryOperator/Action/MyTask"));
const ArchivedAssignTask = React.lazy(() => import("../screens/DataEntryOperator/Action/ArchivedAssignTask"));
const Recurring = React.lazy(() => import("../screens/DataEntryOperator/Action/Recurring"));
const Hibernated = React.lazy(() => import("../screens/DataEntryOperator/Action/Hibernated"));
const ArchivedMyTask = React.lazy(() => import("../screens/DataEntryOperator/Action/ArchivedMyTask"));
const DocumentTracker = React.lazy(() => import("../screens/DataEntryOperator/Action/DocumentTracker"));
const AddDocumentTracker = React.lazy(() => import("../screens/DataEntryOperator/Action/AddDocumentTracker"));
const ArchivedRecurring = React.lazy(() => import("../screens/DataEntryOperator/Action/ArchivedRecurring"));
const EditTask = React.lazy(() => import("../screens/DataEntryOperator/Action/EditAction"));
const AssignTask = React.lazy(() => import("../screens/DataEntryOperator/Action/AssignTask"));
const FintechTask = React.lazy(() => import("../screens/DataEntryOperator/Action/FintechTask"));
const FintechAssignTask = React.lazy(() => import("../screens/DataEntryOperator/Action/FintechAssignTask"));
const FintechMyTask = React.lazy(() => import("../screens/DataEntryOperator/Action/FintechMyTask"));
const InternalFintechMyTask = React.lazy(() => import("../screens/DataEntryOperator/Action/InternalFintechMyTask"));
const ArchivedFintechTask = React.lazy(() => import("../screens/DataEntryOperator/Action/ArchivedFintechTask"));
const ArchivedFintechAssignTask = React.lazy(() => import("../screens/DataEntryOperator/Action/ArchivedFintechAssignTask"));
const InternalArchivedFintechTask = React.lazy(() => import("../screens/DataEntryOperator/Action/InternalArchivedFintechTask"));
const AddFintechTask = React.lazy(() => import("../screens/DataEntryOperator/Action/AddFintechTask"));
const AddFintechAssignTask = React.lazy(() => import("../screens/DataEntryOperator/Action/AddFintechAssignTask"));
const Manager = React.lazy(() => import("../screens/DataEntryOperator/Action/Manager"));
const MomSentForReview = React.lazy(() => import("../screens/DataEntryOperator/Action/MomSentForReview"));
const ReassignManager = React.lazy(() => import("../screens/DataEntryOperator/Action/ReassignManager"));
const UnassignedManager = React.lazy(() => import("../screens/DataEntryOperator/Action/UnassignedManager"));
const ReceivedForReview = React.lazy(() => import("../screens/DataEntryOperator/Action/ReceivedForReview"));
const ClientActionTask = React.lazy(() => import("../screens/DataEntryOperator/Action/ClientActionTask"));
const AddRecurring = React.lazy(() => import("../screens/DataEntryOperator/Action/AddRecurring"));
const ArchivedDocumentTracker = React.lazy(() => import("../screens/DataEntryOperator/Action/ArchivedDocumentTracker"));
const ClientTask = React.lazy(() => import("../screens/DataEntryOperator/Action/ClientTask"));
const RaiseAdviceRequest = React.lazy(() => import("../screens/DataEntryOperator/Action/RaiseAdviceRequest"));
const AddClientAdviceRequest = React.lazy(() => import("../screens/DataEntryOperator/Action/AddClientAdviceRequest/AddClientAdviceRequest"));
const ArcheivedClientAdviceRequest = React.lazy(() => import("../screens/DataEntryOperator/Action/ArcheivedClientAdviceRequest"));
const EditLumSumInvestment = React.lazy(() => import("../screens/DataEntryOperator/Action/AddClientAdviceRequest/TabLumSumInvestment"));
const EditSipInvestment = React.lazy(() => import("../screens/DataEntryOperator/Action/AddClientAdviceRequest/TabSipInvestment"));
const EditRedemption = React.lazy(() => import("../screens/DataEntryOperator/Action/AddClientAdviceRequest/TabRedemption"));
const EditSipCancellation = React.lazy(() => import("../screens/DataEntryOperator/Action/AddClientAdviceRequest/TabSIPCancellation"));
const EditSipPause = React.lazy(() => import("../screens/DataEntryOperator/Action/AddClientAdviceRequest/TabSIPPaused"));


//Planing
const LifeInsuranceReq = React.lazy(() => import("../screens/DataEntryOperator/Planing/LifeInsuranceReq"));
const RetirementPlan = React.lazy(() => import("../screens/DataEntryOperator/Planing/RetirementPlan"));
const LifeInsuranceExpenses = React.lazy(() => import("../screens/DataEntryOperator/Planing/LifeInsuranceExpenses"));


// 7) MIS Report
const MisReport = React.lazy(() => import("../screens/DataEntryOperator/Action/MisReport"));
const ClientInvestorReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/ClientInvestorReport"));
const Reports = React.lazy(() => import("../screens/DataEntryOperator/Reports/Reports"));
const TransactionReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/FolioLedger"));//TransactionReport
const CapitalGainReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/CapitalGainReport"));
const NotionalCapitalGainReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/NotionalCapitalGainReport"));
const InvoicesReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/InvoicesReport"));
const Tax = React.lazy(() => import("../screens/DataEntryOperator/Reports/Tax"));
const PaidInvoicesReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/PaidInvoicesReport"));
const TaxCalculationReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/TaxCalculationReport"));
const TaxCalculationReportOldRegim = React.lazy(() => import("../screens/DataEntryOperator/Reports/TaxCalculationReportOldRegim"));
const HoldingReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/HoldingReportNew"));//HoldingReport
const ReportExpectedCashFlow = React.lazy(() => import("../screens/DataEntryOperator/Reports/ReportExpectedFutureCashFlow"));
const ArchivedSubscribedServices = React.lazy(() => import("../screens/Admin/MisReport/ArchivedSubscribedServices"));
const InsuranceRenewal = React.lazy(() => import("../screens/Admin/MisReport/InsuranceRenewal"));
const MaturityInvestments = React.lazy(() => import("../screens/Admin/MisReport/MaturityInvestments"));
const InvestmentAccount = React.lazy(() => import("../screens/Admin/MisReport/InvestmentsAccount"));
const ShareIsin = React.lazy(() => import("../screens/Admin/MisReport/SharesIsin"));
const RiskProfileMisReport = React.lazy(() => import("../screens/Admin/MisReport/RiskProfile"));
const SystematicsPlansAllClients = React.lazy(() => import("../screens/Admin/MisReport/SystematicsPlansAllClients"));
const AdviceLogBook = React.lazy(() => import("../screens/Admin/MisReport/AdviceLogBook"));
const AdviceLogBookManual = React.lazy(() => import("../screens/Admin/MisReport/AdviceLogBookReady"));
const AdviceLogBookAdd = React.lazy(() => import("../screens/Admin/MisReport/AdviceLogBookAdd"));
const AdviceLogBookBulkImport = React.lazy(() => import("../screens/Admin/MisReport/AdviceLogBookBulkImport"));
const BulkData = React.lazy(() => import("../screens/Admin/MisReport/BulkData/BulkData"));
const AdviceLogBookArchived = React.lazy(() => import("../screens/Admin/MisReport/AdviceLogBookArchived"));
const ActionPlanLog = React.lazy(() => import("../screens/Admin/MisReport/ActionPlanLog"));
const AdviceTransaction = React.lazy(() => import("../screens/Admin/MisReport/AdviceTransaction"));
const MfTransactionReportAllClient = React.lazy(() => import("../screens/Admin/MisReport/MfTransactionReportAllClient"));
const MfHoldingClientWise = React.lazy(() => import("../screens/Admin/MisReport/MfHoldingClientWise"));
const ShareHoldingClientWise = React.lazy(() => import("../screens/Admin/MisReport/ShareHoldingClientWise"));
const MutualFundHolding = React.lazy(() => import("../screens/Admin/MisReport/MFHolding"));
const MFHoldingsSchemeWise = React.lazy(() => import("../screens/Admin/MisReport/MFHolding"));
const SharesHoldingCompanyWise = React.lazy(() => import("../screens/Admin/MisReport/SharesHoldingCompanyWise "))
const ShareTransactionReportAllClient = React.lazy(() => import("../screens/Admin/MisReport/SahreTransactionReportAllClient"));
const SystematicInvestments = React.lazy(() => import("../screens/Admin/MisReport/SystematicInvestment"));
const AdminHoldingReport = React.lazy(() => import("../screens/Admin/MisReport/AdminHoldingReport"));
const AuAReport = React.lazy(() => import("../screens/Admin/MisReport/AuAReport"));
const AuAReportGrid = React.lazy(() => import("../screens/Admin/MisReport/AuAReportGrid"));
const AuAReportComplaints = React.lazy(() => import("../screens/Admin/MisReport/AuAReportComplaints"));
const ClientTaxPlanningNewRegime = React.lazy(() => import("../screens/DataEntryOperator/Reports/Client/TaxCalculationReport"));
const ClientTaxPlanningOldRegime = React.lazy(() => import("../screens/DataEntryOperator/Reports/Client/TaxCalculationReportOldRegim"));
const Returns = React.lazy(() => import("../screens/Admin/MisReport/Returns"));
const RegularVsDirect = React.lazy(() => import("../screens/Admin/MisReport/RegularVsDirect"));
// const HoldingReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/HoldingReportNew"));//HoldingReport
const PortfolioValuationReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/PortfolioValuationReport"));
const SendBulkReportByEmail = React.lazy(() => import("../screens/Admin/MisReport/SendBulkReportByEmail"));
const ClientTransactionReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/ClientTransactionReport"));
const ClientCapitalGainReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/ClientCapitalGainReport"));
// const SendBulkReportByEmail = React.lazy(() => import("../screens/Admin/MisReport/SendBulkReportByEmail"));
const Brokerage = React.lazy(() => import("../screens/Admin/MisReport/Brokerage"));
const AdminBrokerage = React.lazy(() => import("../screens/Admin/MisReport/AdminBrokerage"));
const AddBrokerage = React.lazy(() => import("../screens/Admin/MisReport/AddBrokerage"));
const BrokerageReconciliationReport = React.lazy(() => import("../screens/Admin/MisReport/BrokerageReconciliationReport"));
const BrokerageHistoryReport = React.lazy(() => import("../screens/Admin/MisReport/BrokerageHistoryReport"));
const AUMReport = React.lazy(() => import("../screens/DataEntryOperator/Reports/AUMReport"));
const NavHistory = React.lazy(() => import("../screens/DataEntryOperator/Reports/NavHistory"));
const LongTermRedemptionAvailable = React.lazy(() => import("../screens/DataEntryOperator/Reports/LongTermRedemptionAvailable"));
const CashflowWithReturns = React.lazy(() => import("../screens/Admin/MisReport/CashflowWithReturns"));
const BrokerageSummaryReport = React.lazy(() => import("../screens/Admin/MisReport/BrokerageSummaryReport"));
const MonthlyBrokerageReport = React.lazy(() => import("../screens/Admin/MisReport/MonthlyBrokerageReport"));

// ADMIN 


// Dashboard ViewDetails

const SubmitDataViewDetails = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminDashboardViewDetailsPages/SubmitDataViewDetails"));
const DiscardedSubmitDataViewDetails = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminDashboardViewDetailsPages/DiscardedSubmitDataViewDetails"));
const EditSubmitDataForPlanning = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminDashboardViewDetailsPages/EditSubmitDataForPlanning"));
const AuaAssetViewDetails = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AuaAsset/AuaAssetViewDetails"));
const AdminAseetUnderManagementViewDetail = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminAssetUnderManagementViewDetails/AdminAssetUnderManagementViewDetail"));
const AdminAuaAseetsShares = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminAuaAseetsShares/AdminAuaAssetsSharesViewDetails"));
const AdminClientPortfolioViewDetail = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminClientPortfolioViewDetail/AdminClientPortfolioViewDetail"));
const AdminLockedAccountsViewDetails = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminLockedAccountsViewDetails/AdminLockedAccountsViewDetails"));
const AdminSipBookViewDetail = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminSipBookViewDetail/AdminSipBookViewDetail"));
const AdminExpiringSystematicPlansViewDetails = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/ExpiringSystematicPlans/AdminExpiringSystematicPlansViewDetails"));
const ClientNotes = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/ClientNotes"));
const AdminDashBoardAssetPendingViewDetails = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminDashBoardAssetPending/AdminDashBoardAssetPendingViewDetails"));
const AdminDashBoardGoalsPendingViewDetails = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminDashBoardAssetPending/AdminDashBoardGoalsPendingViewDetails"));
const AdminAumViewDetail = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/AdminAssetUnderManagementViewDetails/AdminAumViewDetail"));


// 1) Accouting

const ExpenseVoucher = React.lazy(() => import("../screens/Admin/Accouting/ExpenseVoucher/ExpenseVoucher"));
const AddExpenseVouchers = React.lazy(() => import("../screens/Admin/Accouting/ExpenseVoucher/AddExpenseVouchers"));
const UploadInvoiceBill = React.lazy(() => import("../screens/Admin/Accouting/ExpenseVoucher/UploadInvoiceBill"));
const FeeMandates = React.lazy(() => import("../screens/Admin/Accouting/FeeMandates/FeeMandates"));
const AddFeeMandates = React.lazy(() => import("../screens/Admin/Accouting/FeeMandates/AddFeeMandates"));
const ArchivedFeeMandates = React.lazy(() => import("../screens/Admin/Accouting/FeeMandates/ArchivedFeeMandates"));
const MisFeeMandates = React.lazy(() => import("../screens/Admin/MisReport/MisFeeMandates"));

const ExportToExcel = React.lazy(() => import("../screens/Admin/Accouting/ExpenseVoucher/ExporttoExcel"));
const VendorSuppliers = React.lazy(() => import("../screens/Admin/Accouting/VendorSupplier/VendorSupplier"));
const AddVendorSupplier = React.lazy(() => import("../screens/Admin/Accouting/VendorSupplier/AddVendorSupplier"));
const ArchivedVendorsSuppliers = React.lazy(() => import("../screens/Admin/Accouting/VendorSupplier/ArchivedVendorsSuppliers"));
const DescriptionMaster = React.lazy(() => import("../screens/Admin/Accouting/DescriptionMaster/DescriptionMaster"));
const AddDescriptionMaster = React.lazy(() => import("../screens/Admin/Accouting/DescriptionMaster/AddDescriptionMaster"));
const ArchivedDescriptionMaster = React.lazy(() => import("../screens/Admin/Accouting/DescriptionMaster/ArchivedDescriptionMaster"));
const AuaCalculation = React.lazy(() => import("../screens/Admin/Accouting/AuaCalculation/AuaCalculation"));
const ClientInvoiceAddress = React.lazy(() => import("../screens/Admin/Accouting/ClientInvoiceAddress/ClientInvoiceAddress"));
const EditClientInvoiceAddress = React.lazy(() => import("../screens/Admin/Accouting/ClientInvoiceAddress/EditClientInvoiceAddress"));
const Invoice = React.lazy(() => import("../screens/Admin/Invoices/Invoices"));
const AddInvoice = React.lazy(() => import("../screens/Admin/Invoices/AddInvoice"));
const FixedRecurring = React.lazy(() => import("../screens/Admin/Invoices/FixedRecurringInvoices"));
const AddFixedRecurringInvoice = React.lazy(() => import("../screens/Admin/Invoices/AddFixedRecurringInvoice"));
const ArchivedFixedRecurringInvoice = React.lazy(() => import("../screens/Admin/Invoices/ArchivedFixedRecurringInvoice"));
const ViewInvoice = React.lazy(() => import("../screens/Admin/Invoices/ViewInvoice"))
const ExportIncomeToExcel = React.lazy(() => import("../screens/Admin/Invoices/ExportIncomeToExcel"));


const CompnayBankAccount = React.lazy(() => import("../screens/Admin/Accouting/CompanyBankAccount/Accounting/CompnayBankAccount"));
const CompBankAccountPassbook = React.lazy(() => import("../screens/Admin/Accouting/CompanyBankAccount/Accounting/CompBankAccountPassbook"));
const AddCompBankPassbookEntry = React.lazy(() => import("../screens/Admin/Accouting/CompanyBankAccount/Accounting/AddCompBankPassbookEntry"));
const AddCompanyBankAccount = React.lazy(() => import("../screens/Admin/Accouting/CompanyBankAccount/Accounting/AddCompanyAccount"));
const ImportBankPassbookDetails = React.lazy(() => import("../screens/Admin/Accouting/CompanyBankAccount/ImportBankPassbookDetail"));
const ArchivedCompanyBankAccount = React.lazy(() => import("../screens/Admin/Accouting/CompanyBankAccount/Accounting/ArchivedCompanyBankAccount"));

const PaymentDetails = React.lazy(() => import("../screens/Admin/Accouting/PaymentDetails/PaymentDetails"));
const AddPaymentDetails = React.lazy(() => import("../screens/Admin/Accouting/PaymentDetails/AddPaymentDetails"));
const FuturePaymentDetails = React.lazy(() => import("../screens/Admin/Accouting/PaymentDetails/FuturePaymentDetails"));
const ArchivedPaymentDetails = React.lazy(() => import("../screens/Admin/Accouting/PaymentDetails/ArchivedPaymentDetails"));

const InsurancePayoutDetails = React.lazy(() => import("../screens/InsurancePayoutDetails"));
const ArchivedRiders = React.lazy(() => import("../screens/SuperAdmin/ProductMaster/Insurance/Riders/ArchivedRiders"));


const MinutesOfMeeting = React.lazy(() => import("../screens/DataEntryOperator/Action/MinutesOfMeeting"));
const AddMoM = React.lazy(() => import("../screens/Admin/AddMoM"));
// const ClientMinutesOfMeeting = React.lazy(() => import( "../screens/DataEntryOperator/Action/ClientMinutesOfMeeting"));
const SubmittedClients = React.lazy(() => import("../screens/DataEntryOperator/Action/MomSubmitted"));
const ArchivedMOM = React.lazy(() => import("../screens/DataEntryOperator/Action/ArchivedMOM"));
const ViewMoM = React.lazy(() => import("../screens/DataEntryOperator/Action/ViewMoM"));

const AdviceRequest = React.lazy(() => import("../screens/DataEntryOperator/Action/AdviceRequest"));
const AddAdviceRequest = React.lazy(() => import("../screens/DataEntryOperator/Action/AddAdviceRequest"));
// const AdminDashboard = React.lazy(() => import("../screens/Admin/AdminDashboard"));

// Financial Plaing 
const FanancialPlaning = React.lazy(() => import("../screens/Admin/FinancialPlanning/FanancialPlaning"));
const LifeInsurance = React.lazy(() => import("../screens/Admin/FinancialPlanning/LifeInsurance"));
const RetirementPlanning = React.lazy(() => import("../screens/Admin/FinancialPlanning/RetirementPlanning"));
const HouseholdersInsurance = React.lazy(() => import("../screens/Admin/FinancialPlanning/HouseholdersInsurance"));
const VehicleInsurance = React.lazy(() => import("../screens/Admin/FinancialPlanning/VehicleInsurance"));
const AccidentInsurance = React.lazy(() => import("../screens/Admin/FinancialPlanning/AccidentInsurance"));
const HealthcareContingencyFund = React.lazy(() => import("../screens/Admin/FinancialPlanning/HealthcareContingencyFund"));
const Contingency = React.lazy(() => import("../screens/Admin/FinancialPlanning/Contingency"));
const HealthInsurance = React.lazy(() => import("../screens/Admin/FinancialPlanning/HealthInsurance"));

const LumpSumCalculation = React.lazy(() => import("../screens/Admin/FinancialPlanning/LumpSumCalculation"));
const TaxPlanning = React.lazy(() => import("../screens/Admin/FinancialPlanning/TaxPlanning"));
const TaxPlanningNewRegimeSelf = React.lazy(() => import("../screens/Admin/FinancialPlanning/TaxPlanningNewRegimeSelf"));
const TaxPlanningOldRegimeSelf = React.lazy(() => import("../screens/Admin/FinancialPlanning/TaxPlanningOldRegimeSelf"));
const TaxPlanningNewRegimeSpouse = React.lazy(() => import("../screens/Admin/FinancialPlanning/TaxPlanningNewRegimeSpouse"));
const TaxPlanningOldRegimeSpouse = React.lazy(() => import("../screens/Admin/FinancialPlanning/TaxPlanningOldRegimeSpouse"));
const AssetMapping = React.lazy(() => import("../screens/Admin/FinancialPlanning/AssetMapping"));
const FpClientPortfolio = React.lazy(() => import("../screens/Admin/FinancialPlanning/ClientPortfolio/FpClientPortfolio"));
const ClientPortfolioPassbook = React.lazy(() => import("../screens/Admin/FinancialPlanning/ClientPortfolio/ClientPortfolioPassbook"));
const TaxPlans = React.lazy(() => import("../screens/Admin/FinancialPlanning/TaxPlans/TaxPlans"));
const ProactiveAdvices = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvices"));
const ProactiveAdvicesCancellation = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesCancellation"));
const ProactiveAdvicesInvestments = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesInvestments"));
const ProactiveAdvicesSwitchs = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesSwitch"));
const ProactiveAdvicesStps = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesStp"));
const ProactiveAdvicesSwps = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesSwp"));
const ProactiveAdvicesInvestmentsEdit = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesInvestmentsEdit"));
const ProactiveAdvicesRedemption = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesRedemption"));
const ProactiveAdvicesBulkRedemption = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveAdvicesBulkRedemption"));
const ProactiveAdvicesBulkInvestment = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveAdvicesBulkInvestment"));
const ProactiveRequestBulkInvestmentSentForApproval = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveRequestBulkInvestmentSentForApproval"));
const ProactiveRequestBulkInvestmentCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveRequestBulkInvestmentCompleted"));
const ProactiveRequestBulkInvestmentDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveRequestBulkInvestmentDeleted"));
const ProactiveRequestBulkInvestmentApprovalDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveRequestBulkInvestmentApprovalDeleted"));
const ProactiveRequestBulkRedemptionApprovalDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveRequestBulkRedemptionApprovalDeleted"));
const ProactiveAdvicesInvestment = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesInvestmentManage"));
const ProactiveAdvicesSwitch = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesSwitchManage"));
const ProactiveAdvicesSwitchSendForApproval = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestSwitchSentForApproval"));
const ProactiveAdvicesSwitchCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestSwitchCompleted"));
const ProactiveAdvicesSwitchDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestSwitchDeleted"));
const ProactiveAdvicesStp = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesStpManage"));
const ProactiveAdvicesStpSentForApproval = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesStpSentForApproval"));
const ProactiveAdvicesStpCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesStpCompleted"));
const ProactiveAdviceStpArchived = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceStpArchived"));
const ProactiveAdvicesSwp = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesSwpManage"));
const ProactiveAdvicesSwpSendForApproval = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesSwpSendForApproval"));
const ProactiveAdvicesSwpCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestSwpCompleted"));
const ProactiveAdviceRequestSwpDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestSwpDeleted"));
const ProactiveAdvicesRedemptionSendForApproval = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestSentForApproval"));
const ProactiveBulkAdvicesRedemptionSendForApproval = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveBulkAdviceRequestSentForApproval"));
const ProactiveBulkAdvicesRedemptionCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveBulkAdviceRequestCompleted"));
const ProactiveBulkAdvicesRedemptionDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveBulkAdviceRequestDeleted"));
const ProactiveAdvicesInvestmentSendForApproval = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestInvestmentSentForApproval"));
const ProactiveAdvicesRedemptionCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestCompleted"));
const ProactiveAdvicesInvestmentCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestInvestmentCompleted"));
const ProactiveAdvicesRedemptionDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestDeleted"));
const ProactiveAdvicesInvestmentDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdviceRequestInvestmentDeleted"));
// Shares/ETFs Portfolio Rebalancing (Advisory)
const RebalancingManage = React.lazy(() => import("../screens/Admin/FinancialPlanning/PortfolioRebalancing/RebalancingManage"));
const RebalancingSentForApproval = React.lazy(() => import("../screens/Admin/FinancialPlanning/PortfolioRebalancing/RebalancingSentForApproval"));
const RebalancingCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/PortfolioRebalancing/RebalancingCompleted"));
const RebalancingDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/PortfolioRebalancing/RebalancingDeleted"));
const RebalancingRequestAdd = React.lazy(() => import("../screens/Admin/FinancialPlanning/PortfolioRebalancing/RebalancingRequestAdd"));
const ProactiveAdvicesActiveSplit = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesActiveSplit"));
const ProactiveAdvicesCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesCompleted"));
const ProactiveAdvicesDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveAdvicesDeleted"));
const FinancialPlanLoans = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlanLoans"));
// const CapitalAllocationInsurance = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/CapitalAllocationInsurance"));
const SipCalculation = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/SipCalculation"));
const GoalStp = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/GoalStp"));
const GoalSwp = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/GoalSwp"));
const GoalSwitch = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/GoalSwitch"));
const GoalComments = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/GoalComments"));
const InvestmentComments = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/InvestmentComments"));
const Investment = React.lazy(() => import("../screens/Admin/FinancialPlanning/CapitalAllocation/Investment"));
const ImmediateCashFlowPlan = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/ImmediateCashFlowPlan"));
const AnnualSpendings = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/AnnualSpendings"));
const EstatePlanning = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/EstatePlanning"));
const ProposedActionPlan = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/ProposedActionPlan"));
const EvaluationReport = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/EvaluationReport"));
const DisclaimersDisclosures = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/DisclaimersDisclosures"));
const SignOff = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/SignOff"));
const ClosePlan = React.lazy(() => import("../screens/Admin/FinancialPlanning/Summary/ClosePlan"));
const StartPlanning = React.lazy(() => import("../screens/Admin/FinancialPlanning/StartPlanning"));

// Client Advice Request Head side Manage page, Lumpsum, Redemption
const ManageAdviceRequest = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/ManageAdviceRequest"));
const ManageAdviceRequestSentForApproval = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/ManageAdviceRequestSentForApproval"));
const ManageAdviceRequestDeleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/ManageAdviceRequestDeleted"));
const ManageAdviceRequestCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/ManageAdviceRequestCompleted"));

// Client Redemption Transaction
const ManageRedemptionPurpose = React.lazy(() => import("../screens/Admin/FinancialPlanning/RedemptionTransaction/ManageRedemptionPurpose"));
const ManageRedemptionPurposeShare = React.lazy(() => import("../screens/Admin/FinancialPlanning/RedemptionTransaction/ManageRedemptionPurposeShare"));
const ManageRedemptionPurposeHistoricalData = React.lazy(() => import("../screens/Admin/FinancialPlanning/RedemptionTransaction/ManageRedemptionPurposeHistoricalData"));
const ManageRedemptionPurposeHistoricalDataShare = React.lazy(() => import("../screens/Admin/FinancialPlanning/RedemptionTransaction/ManageRedemptionPurposeHistoricalDataShare"));
const ManageRedemptionPurposeCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/RedemptionTransaction/ManageRedemptionPurposeCompleted"));
const ManageRedemptionPurposeShareCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/RedemptionTransaction/ManageRedemptionPurposeShareCompleted"));

// Client Redemption Transaction
const ManageInvestmentPurpose = React.lazy(() => import("../screens/Admin/FinancialPlanning/InvestmentPurpose/ManageInvestmentPurpose"));
const ManageInvestmentPurposeShare = React.lazy(() => import("../screens/Admin/FinancialPlanning/InvestmentPurpose/ManageInvestmentPurposeShare"));
const ManageInvestmentPurposeHistoricalData = React.lazy(() => import("../screens/Admin/FinancialPlanning/InvestmentPurpose/ManageInvestmentPurposeHistoricalData"));
const ManageInvestmentPurposeHistoricalDataShare = React.lazy(() => import("../screens/Admin/FinancialPlanning/InvestmentPurpose/ManageInvestmentPurposeHistoricalDataShare"));
const ManageInvestmentPurposeCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/InvestmentPurpose/ManageInvestmentPurposeCompleted"));
const ManageInvestmentPurposeShareCompleted = React.lazy(() => import("../screens/Admin/FinancialPlanning/InvestmentPurpose/ManageInvestmentPurposeShareCompleted"));

const LumpsumAdviceRequest = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/LumpsumAdviceRequest"));
const SipCancellationAdviceRequest = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/SipCancellationAdviceRequest"));
const SipPauseAdviceRequest = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/SipPauseAdviceRequest"));
const RedemptionAdviceRequest = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/RedemptionAdviceRequest"));
const ProactiveRedemptionAdviceRequestAdd = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveRedemptionAdviceRequest-Add"));
const ProactiveBulkInvestmentAdviceRequestAdd = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveBulkInvestmentAdviceRequestAdd"));
const ProactiveBulkRedemptionAdviceRequestAdd = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveBulkRedemptionAdviceRequest-Add"));
const ProactiveBulkRedemptionAdviceRequestEdit = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveBulkAdvices/ProactiveBulkRedemptionAdviceRequest-Edit"));
const ProactiveRedemptionAdviceRequestEdit = React.lazy(() => import("../screens/Admin/FinancialPlanning/ProactiveAdvices/ProactiveRedemptionAdviceRequest-Edit"));
const SipInvestmentAdviceRequest = React.lazy(() => import("../screens/Admin/FinancialPlanning/AdviceRequest/SipInvestmentAdviceRequest"));
// Financial Plaing Report

const FinancialPlanningReport = React.lazy(() => import("../screens/Admin/FinancialPlanning/Report/FinancialPlanningReport"));

// HR

// HR module (Phase 1) — leave configuration. Gated with <RequireRole>, unlike
// the older HR routes above, which stay unguarded so existing users keep access.
const WeeklyOff = React.lazy(() => import("../screens/Admin/HR/WeeklyOff"));
const LeaveApprovers = React.lazy(() => import("../screens/Admin/HR/LeaveApprovers"));
const ApplyLeave = React.lazy(() => import("../screens/Admin/HR/Leave/ApplyLeave"));
const MyLeaves = React.lazy(() => import("../screens/Admin/HR/Leave/MyLeaves"));
const MyLeaveBalance = React.lazy(() => import("../screens/Admin/HR/Leave/MyLeaveBalance"));
const LeaveApprovals = React.lazy(() => import("../screens/Admin/HR/Leave/LeaveApprovals"));
const LeaveBalances = React.lazy(() => import("../screens/Admin/HR/Leave/LeaveBalances"));
// HR module (Phase 2)
const CompOff = React.lazy(() => import("../screens/Admin/HR/Leave/CompOff"));
const LeaveCalendar = React.lazy(() => import("../screens/Admin/HR/Leave/LeaveCalendar"));
const LeaveCredit = React.lazy(() => import("../screens/Admin/HR/Leave/LeaveCredit"));
const LeaveDelegation = React.lazy(() => import("../screens/Admin/HR/Leave/LeaveDelegation"));
const LeaveReports = React.lazy(() => import("../screens/Admin/HR/Leave/LeaveReports"));

// HR module (Phase 3) — salary masters.
const SalaryComponents = React.lazy(() => import("../screens/Admin/HR/Salary/SalaryComponents"));
const AddSalaryComponent = React.lazy(() => import("../screens/Admin/HR/Salary/AddSalaryComponent"));
const SalaryStructures = React.lazy(() => import("../screens/Admin/HR/Salary/SalaryStructures"));
const EmployeeSalary = React.lazy(() => import("../screens/Admin/HR/Salary/EmployeeSalary"));
const SalaryApprovals = React.lazy(() => import("../screens/Admin/HR/Salary/SalaryApprovals"));

// HR module (Phase 4) — payroll.
const PayrollRuns = React.lazy(() => import("../screens/Admin/HR/Payroll/PayrollRuns"));
const PayrollRunWorkspace = React.lazy(() => import("../screens/Admin/HR/Payroll/PayrollRunWorkspace"));
const PayrollApprovals = React.lazy(() => import("../screens/Admin/HR/Payroll/PayrollApprovals"));
const MyPayslips = React.lazy(() => import("../screens/Admin/HR/Payroll/MyPayslips"));
const MySalaryStructure = React.lazy(() => import("../screens/Admin/HR/Payroll/MySalaryStructure"));
const PayrollReports = React.lazy(() => import("../screens/Admin/HR/Payroll/PayrollReports"));
const StatutorySetup = React.lazy(() => import("../screens/Admin/HR/Payroll/StatutorySetup"));

// HR module (Phase 6) — investment declaration & proofs.
const DeclarationConfig = React.lazy(() => import("../screens/Admin/HR/Declaration/DeclarationConfig"));
const MyDeclaration = React.lazy(() => import("../screens/Admin/HR/Declaration/MyDeclaration"));
const MyProofs = React.lazy(() => import("../screens/Admin/HR/Declaration/MyProofs"));
const ProofVerification = React.lazy(() => import("../screens/Admin/HR/Declaration/ProofVerification"));

// HR module (Phase 7) — Form 16.
const Form16 = React.lazy(() => import("../screens/Admin/HR/Payroll/Form16"));
const MyForm16 = React.lazy(() => import("../screens/Admin/HR/Payroll/MyForm16"));
const MyReimbursements = React.lazy(() => import("../screens/Admin/HR/Payroll/MyReimbursements"));
const Reimbursements = React.lazy(() => import("../screens/Admin/HR/Payroll/Reimbursements"));
const HrLoanTypes = React.lazy(() => import("../screens/Admin/HR/Loans/LoanTypes"));
const MyLoans = React.lazy(() => import("../screens/Admin/HR/Loans/MyLoans"));
const HrLoans = React.lazy(() => import("../screens/Admin/HR/Loans/Loans"));
const LoanSchedule = React.lazy(() => import("../screens/Admin/HR/Loans/LoanSchedule"));
const Arrears = React.lazy(() => import("../screens/Admin/HR/Payroll/Arrears"));
const FnfSettlement = React.lazy(() => import("../screens/Admin/HR/Payroll/FnfSettlement"));

const Employees = React.lazy(() => import("../screens/Admin/HR/Employee"));
const AddEmployee = React.lazy(() => import("../screens/Admin/HR/AddEmployee"));
const EditEmployee = React.lazy(() => import("../screens/Admin/HR/EditEmployee"));
const ArchivedEmployees = React.lazy(() => import("../screens/Admin/HR/ArchivedEmployee"));
const CategoryMasterEmployees = React.lazy(() => import("../screens/Admin/HR/CategoryMasterEmployees"));
const ArchivedCategoryMasterEmployees = React.lazy(() => import("../screens/Admin/HR/ArchivedCategoryMasterEmployees"));
const DraftEmployees = React.lazy(() => import("../screens/Admin/HR/DraftEmployees"));
const EmployeeOnboarding = React.lazy(() => import("../screens/Admin/HR/EmployeeOnboarding"));
const EmployeeMenu = React.lazy(() => import("../screens/Admin/HR/EmployeeMenu"));
const EmployeeMenuSelection = React.lazy(() => import("../screens/Admin/HR/EmployeeMenuSelection/EmployeeMenuSelection"));
const AddEmployeeMenuSelection = React.lazy(() => import("../screens/Admin/HR/EmployeeMenuSelection/AddEmployeeMenuSelection"));
const EmployeeSelectionByMenu = React.lazy(() => import("../screens/Admin/HR/EmployeeSelectionByMenu/EmployeeSelectionByMenu"))
const AddEmployeeSelectionByMenu = React.lazy(() => import("../screens/Admin/HR/EmployeeSelectionByMenu/AddEmployeeSelectionByMenu"));
const EmployeesEntry = React.lazy(() => import("../screens/Admin/HR/EmployeesEntry"));
const EditEmployeeEntry = React.lazy(() => import("../screens/Admin/HR/EditEmployeeEntry"));
const ArchivedEmployeeEntry = React.lazy(() => import("../screens/Admin/HR/ArchivedEmployeesEntry"));
const EmployeesExit = React.lazy(() => import("../screens/Admin/HR/EmployeesExit"));
const EditEmployeeExit = React.lazy(() => import("../screens/Admin/HR/EditEmployeeExit"));
const ArchivedEmployeeExit = React.lazy(() => import("../screens/Admin/HR/ArchivedEmployeesExit"));
const LeaveType = React.lazy(() => import("../screens/Admin/HR/LeaveType"));
const AddLeaveType = React.lazy(() => import("../screens/Admin/HR/AddLeaveType"));
const HolidayCalender = React.lazy(() => import("../screens/Admin/HR/HolidayCalender"));
const AddHoliday = React.lazy(() => import("../screens/Admin/HR/AddHoliday"));
const HolidayCalenderForEmplyoee = React.lazy(() => import("../screens/Admin/HR/HolidayCalenderForEmplyoee"));
const ClientBirthday = React.lazy(() => import("../screens/DataEntryOperator/Dashboard/ClientBirthday/ClientBirthday"));
// Masters

const Clients = React.lazy(() => import("../screens/Admin/Masters/Clients"));
const DraftClients = React.lazy(() => import("../screens/Admin/Masters/Clients/DraftClients"));
const AddNewClient = React.lazy(() => import("../screens/Admin/Masters/Clients/AddNewClient"));
const ContractDetails = React.lazy(() => import("../screens/Admin/Masters/Clients/ContractDetails"));
const ClientPaymentDetails = React.lazy(() => import("../screens/Admin/Masters/Clients/PaymentDetails"));
const Onboarding = React.lazy(() => import("../screens/Admin/Masters/Clients/Onboarding"));
const PanVarification = React.lazy(() => import("../screens/Admin/Masters/Clients/PanVarification"));
const MenuSelection = React.lazy(() => import("../screens/Admin/Masters/Clients/MenuSelection"));
const ClientCisDetails = React.lazy(() => import("../screens/Admin/Masters/Clients/CisDetails"));
const MailGroup = React.lazy(() => import("../screens/Admin/Masters/Clients/MailGroups"));
const AddClients = React.lazy(() => import("../screens/Admin/Masters/AddClients"));
const AddNewServices = React.lazy(() => import("../screens/Admin/Masters/AddNewServices"));
const AdvisorGoals = React.lazy(() => import("../screens/Admin/Masters/AdvisorGoals"));
const ArchivedClients = React.lazy(() => import("../screens/Admin/Masters/ArchivedClients"));
const Slabs = React.lazy(() => import("../screens/Admin/Masters/Slabs"));
const ArchivedSlabs = React.lazy(() => import("../screens/Admin/Masters/ArchivedSlabs"));
const AddSlab = React.lazy(() => import("../screens/Admin/Masters/AddSlab"));
const Announcements = React.lazy(() => import("../screens/Admin/Masters/Announcements"));
const AddAnnouncements = React.lazy(() => import("../screens/Admin/Masters/AddAnnouncements"));
const ArchivedAnnouncements = React.lazy(() => import("../screens/Admin/Masters/ArchivedAnnouncement"));
const Assumptions = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/Assumptions"));
const EditAssumption = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/EditAssumption"));
const ModelPortfolios = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/ModelPortfolios"));
const Comments = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/Comments"));
const AddComments = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/AddComments"));
const ArchivedComments = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/ArchivedComments"));
const DisclaimerAndDiscloser = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/DisclaimerAndDiscloser"));
const EditDisclaimerAndDiscloser = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/EditDisclaimerAndDiscloser"));
const MalingGroups = React.lazy(() => import("../screens/Admin/Masters/MalingGroups"));
const AddMailingGroup = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/AddMailingGroup"));
const GroupsUserOf = React.lazy(() => import("../screens/Admin/Masters/GroupsUserOf"));
const AddGroupUser = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/AddGroupUser"));
const AddModelPortfolios = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/AddModelPortfolios"));
const ViewModelPortfolios = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/ViewModelPortfolios"));

const GlobalParameter = React.lazy(() => import("../screens/Admin/Masters/GlobalParameter"));
const EditGlobalParameter = React.lazy(() => import("../screens/Admin/Masters/EditGlobalParameter"));
const ArchivedModelPortfolios = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/ArchivedModelPortfolio"));
const EditGlobalParameterFeeStructure = React.lazy(() => import("../screens/Admin/Masters/EditGlobalParameterFeeStructure"));
const BusinessAccreditation = React.lazy(() => import("../screens/Admin/Masters/BusinessAccreditation"));
const AddBusinessAccreditation = React.lazy(() => import("../screens/Admin/Masters/AddBusinessAccreditation"));
const MasterCompanyMaster = React.lazy(() => import("../screens/Admin/Masters/MasterCompanyMaster"));
const CompanyBankAccounts = React.lazy(() => import("../screens/Admin/Masters/CompanyBankAccounts"));
const ArchivedBusinessAccreditation = React.lazy(() => import("../screens/Admin/Masters/ArchivedBusinessAccreditation"));
const Branches = React.lazy(() => import("../screens/Admin/Masters/Branches"));
const ArchivedBranches = React.lazy(() => import("../screens/Admin/Masters/ArchivedBranches"));
const CompanySignOffDetails = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/CompanySignOffDetails"));
const EditCompanySignOffDetails = React.lazy(() => import("../screens/Admin/Masters/PlanningMaster/EditCompanySignOffDetails"));
const InsuranceProductRecommendations = React.lazy(() => import("../screens/Admin/Masters/Recommendations/InsuranceProductRecommendations"));
const SendMailtoGroup = React.lazy(() => import("../screens/Admin/Masters/SendMailtoGroup"));
const MailTemplates = React.lazy(() => import("../screens/Admin/Masters/MailTemplate/MailTemplate"));
const CreateNewTemplate = React.lazy(() => import("../screens/Admin/Masters/MailTemplate/CreateNewTemplate"));
const CreateSignature = React.lazy(() => import("../screens/Admin/Masters/MailTemplate/CreateSignature"));
const ArchivedMailTemplates = React.lazy(() => import("../screens/Admin/Masters/MailTemplate/ArchivedMailTemplate"));
const CopyRecordFromMasterTemplate = React.lazy(() => import("../screens/Admin/Masters/MailTemplate/CopyRecordFromMasterTemplate"));
const InvestmentProduct = React.lazy(() => import("../screens/Admin/Masters/Recommendations/InvestmentProduct"));
const ArchivedInvestmentProduct = React.lazy(() => import("../screens/Admin/Masters/Recommendations/ArchivedInvestmentProduct"));
const AddInvestmentProduct = React.lazy(() => import("../screens/Admin/Masters/Recommendations/AddInvestmentProduct"));
const ArchivedMailingGroup = React.lazy(() => import("../screens/Admin/Masters/ArchivedMailingGroup"));
const ArchivedAdvisors = React.lazy(() => import("../screens/SuperAdmin/Master/Advisors/ArchivedAdvisors"));
const AddBranches = React.lazy(() => import("../screens/Admin/Masters/AddBranches"));
const EditCompanyDetails = React.lazy(() => import("../screens/Admin/Masters/EditCompanyDetails"));
const DesiredAssetAllocation = React.lazy(() => import("../screens/Admin/Masters/DesiredAssetAllocation/DesiredAssetAllocation"));
const ArcheivedDesiredAssetAllocation = React.lazy(() => import("../screens/Admin/Masters/DesiredAssetAllocation/ArcheivedDesiredAssetAllocation "));
const AddDesiredAssetAllocation = React.lazy(() => import("../screens/Admin/Masters/DesiredAssetAllocation/AddDesiredAssetAllocation "));
const InvestorCharter = React.lazy(() => import("../screens/Admin/Masters/WebsiteCompliance/InvestorCharter"));
const Complaints = React.lazy(() => import("../screens/Admin/Masters/WebsiteCompliance/Complaints"));
const ArchivedComplaints = React.lazy(() => import("../screens/Admin/Masters/WebsiteCompliance/ArchivedComplaints"));
// const ComplaintsCount = React.lazy(() => import("../screens/Admin/Masters/WebsiteCompliance/ComplaintsCount")); // not using 
const AddComplaints = React.lazy(() => import("..//screens/Admin/Masters/WebsiteCompliance/AddComplaints"));
const HistoricTrend = React.lazy(() => import("..//screens/Admin/Masters/WebsiteCompliance/HistoricTrend"));


const AnnualComplianceAuditReports = React.lazy(() => import("../screens/Admin/Masters/WebsiteCompliance/AnnualComplianceAuditReports"));
const AddAnnualComplianceAuditReports = React.lazy(() => import("../screens/Admin/Masters/WebsiteCompliance/AddAnnualComplianceAuditReports"));
const GrievanceRedressalMechanisms = React.lazy(() => import("../screens/Admin/Masters/WebsiteCompliance/GrievanceRedressalMechanisms"));
const RiskProfileIntroduction = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/RiskProfileIntroduction"));
const RiskProfileDisclaimer = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/RiskProfileDisclaimer"));
const AddRiskProfileDisclaimer = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/AddRiskProfileDisclaimer"));
const ArchivedRiskProfileDisclaimer = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/ArchivedRiskProfileDisclaimer"));
const RiskProfilesTypes = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/RiskProfilesTypes"));
const RiskProfiles = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/RiskProfiles"));
const AddRiskProfiles = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/AddRiskProfiles"));
const ArchivedRiskProfiles = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/ArchivedRiskProfiles"));
const RiskProfilesQA = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/RiskProfilesQA"));
const ArchivedRiskProfilesQA = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/ArchivedRiskProfilesQA"));
const AddRiskProfilesQA = React.lazy(() => import("../screens/Admin/Masters/RiskProfile/AddRiskProfilesQA"));
const ClientMenuSelection = React.lazy(() => import("../screens/Admin/Masters/CilentMenuSelection/ClientMenuSelection"));
const AddClientMenuSelection = React.lazy(() => import("../screens/Admin/Masters/CilentMenuSelection/AddClientMenuSelection"));
const ClientMenuPackage = React.lazy(() => import("../screens/Admin/Masters/CilentMenuSelection/ClientMenuPackage"));
const AddClientMenuPackage = React.lazy(() => import("../screens/Admin/Masters/CilentMenuSelection/AddClientMenuPackage"));
const ClientSelectionByMenu = React.lazy(() => import("../screens/Admin/Masters/ClientSelectionByMenu/ClientSelectionByMenu"));
const AddClientSelectionByMenu = React.lazy(() => import("../screens/Admin/Masters/ClientSelectionByMenu/AddClientSelectionByMenu"));







// BD

const AuaSelection = React.lazy(() => import("../screens/Admin/BD/AuaSelection"));
const EditAuaSelection = React.lazy(() => import("../screens/Admin/BD/EditAuaSelection"));
const BusinessAnalytics = React.lazy(() => import("../screens/Admin/BD/BusinessAnalytics"));
const TopPerformers = React.lazy(() => import("../screens/Research/TopPerformers"));
const SchemeComparison = React.lazy(() => import("../screens/Research/SchemeComparison"));
const SchemeFactsheet = React.lazy(() => import("../screens/Research/SchemeFactsheet"));
const AnalystEstimates = React.lazy(() => import("../screens/Research/AnalystEstimates"));
const AnalystEstimatesUpload = React.lazy(() => import("../screens/Research/AnalystEstimatesUpload"));
const AnalystEstimatesHelp = React.lazy(() => import("../screens/Research/AnalystEstimatesHelp"));
const GrowthOutlook = React.lazy(() => import("../screens/Research/GrowthOutlook"));
const GrowthOutlookHelp = React.lazy(() => import("../screens/Research/GrowthOutlookHelp"));
const SingleClickRatingMaster = React.lazy(() => import("../screens/Research/SingleClickRatingMaster"));
const SingleClickRating = React.lazy(() => import("../screens/Research/SingleClickRating"));
const SingleClickRatingHelp = React.lazy(() => import("../screens/Research/SingleClickRatingHelp"));
const SchemeFlagRadar = React.lazy(() => import("../screens/Research/SchemeFlagRadar"));
const SchemeFlagRadarHelp = React.lazy(() => import("../screens/Research/SchemeFlagRadarHelp"));
const SchemeChangeReport = React.lazy(() => import("../screens/Research/SchemeChangeReport"));
const SchemeChangeReportHelp = React.lazy(() => import("../screens/Research/SchemeChangeReportHelp"));
const FundManagerActivity = React.lazy(() => import("../screens/Research/FundManagerActivity"));
const FundManagerActivityHelp = React.lazy(() => import("../screens/Research/FundManagerActivityHelp"));
const SchemesClosedSubscription = React.lazy(() => import("../screens/Research/SchemesClosedSubscription"));
const SchemesClosedSubscriptionHelp = React.lazy(() => import("../screens/Research/SchemesClosedSubscriptionHelp"));
const OpenNfos = React.lazy(() => import("../screens/Research/OpenNfos"));
const OpenNfosHelp = React.lazy(() => import("../screens/Research/OpenNfosHelp"));
const PortfolioAssessment = React.lazy(() => import("../screens/PortfolioAssessment/PortfolioAssessment"));
const PortfolioAssessmentReport = React.lazy(() => import("../screens/PortfolioAssessment/PortfolioAssessmentReport"));
const PortfolioAssessmentHelp = React.lazy(() => import("../screens/PortfolioAssessment/PortfolioAssessmentHelp"));
const PortfolioAnalysis = React.lazy(() => import("../screens/PortfolioAnalysis/PortfolioAnalysis"));
const PortfolioAnalysisHelp = React.lazy(() => import("../screens/PortfolioAnalysis/PortfolioAnalysisHelp"));

const Operations = React.lazy(() => import("../screens/Admin/Accouting/Operation/Operations"));

// Operation
const MfUnitsReconciliation = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfUnitReconcilition/MfUnitsReconciliation"));
const MfUnitsReconciliationUnmatch = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfUnitReconcilition/MfUnitsReconciliationUnmatch"));
const MfUnitsReconciliationInSystem = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfUnitReconcilition/MfUnitsReconciliationInSystem"));
const MfUnitsReconciliationNotRta = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfUnitReconcilition/MfUnitsReconciliationNotRta"));
const ImportUnitReconciliation = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfUnitReconcilition/ImportUnitReconciliation"));
const FixedIncomeTransactions = React.lazy(() => import("../screens/Admin/Accouting/Operation/FixedIncomeTransactions/FixedIncomeTransactions"));
const FilesUpload = React.lazy(() => import("../screens/Admin/Accouting/Operation/FilesUpload/TransactionFilesUpload"));
const ContractNoteReader = React.lazy(() => import("../screens/Admin/ContractNotes/ContractNoteReader"));
const ShareTransactions = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/ShareTransactions"));
const ShareSystematicTransactions = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareSystematicTransactions/Platform"));
const ShareTransactionsFuture = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/Future"));
const ShareTransactionsPlatform = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/Platform"));
const ShareTransactionInProcess = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/InProcess"));
const ShareTransactionTransactions = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/Transactions"));
const ShareTransactionError = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/Error"));
const ShareTransactionsReady = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/Ready"));
const ArchivedSips = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/ArchivedSips"));
const ShareTransactionsImport = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/ShareTransactionImport"));
const ShareTransactionsArchived = React.lazy(() => import("../screens/Admin/Accouting/Operation/ShareTransactions/ShareTransactionsArchived"));

const MfTransactions = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/MfTransactions"));
const MfTransactionsPlatform = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/MfTransactionsPlatform"));
const MfTransactionsFuture = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/MfTransactionsFuture"));
const MfTransactionsTransactions = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/Transactions"));
const MfTransactionsError = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/Error"));
const MfTransactionsDuplicate = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/Duplicate"));
const MfTransactionsRejection = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/Rejection"));
const MfTransactionsReady = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/Ready"));
const MfTransactionsArchive = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/Archived"));
const MfTransactionsArchived = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/MfTransactionsArchived"))
const MfTransactionImport = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfTransactions/ImportTransaction"))
const MfSystematicTransactions = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicTransactions"));
const MfSystematicPlatformImport = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/ImportTransaction"))
const MfSystematicArchived = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicArchived"));
const MfSystematicError = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicError"));
const MfSystematicReady = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicReady"));
const MfSystematicTransactiontab = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicTransactiontab"));
const CisDetails = React.lazy(() => import("../screens/Admin/Accouting/Operation/CisDetails/CisDetails"));
const ArcheivedCisDetails = React.lazy(() => import("../screens/Admin/Accouting/Operation/CisDetails/ArcheivedCisDetails"));
const EditCisDetails = React.lazy(() => import("../screens/Admin/Accouting/Operation/CisDetails/EditCisDetails"));
const MfSystematicFuture = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicFuture"));
const MfSystematicPlatform = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicPlatform"));
const MfSystematicPaused = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicPaused"));
const MfSystematicImport = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSystematicImport"));
const MfSysArchived = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfSystematicTransactions/MfSysArchived"));
const ClientEntry = React.lazy(() => import("../screens/Admin/Accouting/Operation/ClientEntryAndExit/ClientEntry"));
const ArchivedClientsEntry = React.lazy(() => import("../screens/Admin/Accouting/Operation/ClientEntryAndExit/ArchivedClient"));
const ClientExit = React.lazy(() => import("../screens/Admin/Accouting/Operation/ClientEntryAndExit/ClientExit"));
const EditClientExit = React.lazy(() => import("../screens/Admin/Accouting/Operation/ClientEntryAndExit/EditClientExit"));
const ArchivedClientExit = React.lazy(() => import("../screens/Admin/Accouting/Operation/ClientEntryAndExit/ArchivedClientExit"))
const EditClientEntry = React.lazy(() => import("../screens/Admin/Accouting/Operation/ClientEntryAndExit/EditClientEntry"));
const Mandates = React.lazy(() => import("../screens/Admin/Accouting/Operation/AccountOpening/Mandates"));
const AddMandates = React.lazy(() => import("../screens/Admin/Accouting/Operation/AccountOpening/AddMandates"));
const ArchivedMandates = React.lazy(() => import("../screens/Admin/Accouting/Operation/AccountOpening/ArchivedMandates"));
const MfuPlatform = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfuAccountOpen/MfuPlatform"));
const MfuPlatformArchived = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfuAccountOpen/MfuPlatformArchived"));
const MfuPlatformCompleted = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfuAccountOpen/MfuPlatformCompleted"));
const AddClientAccount = React.lazy(() => import("../screens/Admin/Accouting/Operation/MfuAccountOpen/AddClientAccount"));
const BulkImport = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/BulkImport"));
const MasterSheetTabs = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/MasterSheet/MasterSheetTabs"));
const MasterFileUpload = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/MasterSheet/BulkImportMasterFileUpload"));
const BulkImportClients = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/Clients/BulkImportClients"));
const BulkImportClientsError = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/Clients/BulkImportClientsError"));
const BulkImportClientsProcessed = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/Clients/BulkImportClientsProcessed"));
const BulkImportClientsMenu  = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/Clients/BulkImportClientsMenu"));
const BulkImportFileUpload = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/BulkImportFileUpload"));
const BulkImportEditClient =  React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/Clients/BulkImportEditClient"));
const BulkImportProcessed = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/Investors/BulkImportProcessed"));
const BulkImportInvestors = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/Investors/BulkImportInvestors"));
const BulkImportInvestorsError = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/Investors/BulkImportInvestorsError"));
const BulkImportEditInvestor = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/Investors/BulkImportEditInvestor"));
const ChangeRm = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/RM/ChangeRm"));



//Bulk Import Mfu Can
const BulkImportMfuCan = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/MfuCan/BulkImportMfuCan"));
const EditMfuCan = React.lazy(()=> import("../screens/Admin/Accouting/Operation/BulkImport/MfuCan/MfuBufffer"));

//Bulk Import Mfu Mandates
const BulkImportMfuMandates = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/MfuManadtes/BulkImportMfuMandates"));
const EditMfuMandate = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/MfuManadtes/MfuMandateBufffer"));

//Bulk Import Banks
const BulkImportBanks = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/Banks/BulkImportBanks"));
const BulkImportBanksError = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/Banks/BulkImportBanksError"));
const BulkImportEditBank =  React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/Banks/BulkImportEditBank"));

//
const BulkClientMapping = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/ClientMapping/ClientMappingManage"));
const PartiallyClientMapping = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/ClientMapping/PartiallyClientMapping"));
const FullyClientMapping = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/ClientMapping/FullyClientMapping"));
const ClientMappingRM1 = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/ClientMapping/ClientMappingRM1"));
const ClientMappingRM2 = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/ClientMapping/ClientMappingRM2"));
const ClientMappingSB1 = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/ClientMapping/ClientMappingSB1"));
const ClientMappingSB2 = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/ClientMapping/ClientMappingSB2"));
const SbCategoryMapping = React.lazy(() => import("../screens/Admin/Accouting/Operation/BulkImport/ClientMapping/SbCategoryMapping"));

// 

const MutualFundRtaCodes = React.lazy(() => import("../screens/Admin/MisReport/MutualFundRTAFund"));
const ArchivedMutualFundRtaCodes = React.lazy(() => import("../screens/Admin/MisReport/ArchivedMutualFundRTAFund.tsx"));
const EightyCReport = React.lazy(() => import("../screens/Admin/MisReport/EightyCReport"));

const Advisory = React.lazy(() => import("../screens/Admin/FinancialPlanning/Advisory"));
// Financial Plans

const FinancialPlans = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/FinancialPlans"));
const FinancialPlansHomePage = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/FinancialPlansHomePage"));
const FinancialPlanningShare = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/Share/FinancialPlanningShare"));
const FinancialPlanningMutualFund = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/MutualFunds/FinancialPlanningMutualFund"));
const FinancialPlanningUlip = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/Ulip/FinancialPlanningUlip"));
const FinancialPlanningMoneyBack = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/MoneyBack/FinancialPlanningMoneyBack"));
const FinancialPlanningFixedIncome = React.lazy(() => import('../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/FixedIncome'))
const FinancialPlanningRetirementProducts = React.lazy(() => import('../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/RetirementProducts'))
const FinancialPlanningBullion = React.lazy(() => import('../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/Bullion'))
const FinancialPlanningRealEstate = React.lazy(() => import('../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/RealEstate'))
const FinancialPlanningBankAndDMat = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlanningBankAndDmat"));
const FinancialPlanningCoverPage = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlanningCoverPage"));
const FinancialPlanningPMS = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/FinancialPlanningPMS"));
const FinancialPlanningAIF = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/FinancialPlanningAIF"));
const FinancialPlanningOthers = React.lazy(() => import("../screens/Admin/FinancialPlanning/FinancialPlans/InvestmentAnalysis/FinancialPlanningOthers"));

const FinancialPlanReport = React.lazy(() => import('../screens/DataEntryOperator/Report'))

// Incidental Advice Report
const StartIncidentalAdvice = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/StartIncidentalAdvice"));
const IncidentalAdviceReport = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceReport"));
const IncidentalAdviceCoverPage = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/IncidentalAdviceCoverPage"));
const IncidentalAdviceMutualFund = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/IncidentalAdviceMutualFund"));
const IncidentalAdviceHealthcareContingencyFund = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/IncidentalAdviceHealthcareContingencyFund"));
const IncidentalAdviceContingencyFund = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/IncidentalAdviceContingencyFund"));
const RetirementAdvice = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/RetirementAdvice"));
const AssetMappingAdvice = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/AssetMappingAdvice"));
const LumpSumCalculationAdvice = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/LumpSumCalculationAdvice"));
const SipCalculationAdvice = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/SipCalculationAdvice"));
const GoalStpAdvice = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/GoalStpAdvice"));
const GoalSwpAdvice = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/GoalSwpAdvice"));
const GoalSwitchAdvice = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/GoalSwitchAdvice"));
const IncidentalGoalComment=  React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/GoalComments"));
const InvestmentCommentsAdvice = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/InvestmentCommentsAdvice"));
const InvestmentAdvice = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/InvestmentAdvice"));
const ImmediateCashFlowPlanAdvice = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/ImmediateCashFlowPlanAdvice"));
const ProposedActionPlanAdvice = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/ProposedActionPlanAdvice"));
const IncidentalAdviceReportPage = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/IncidentalAdviceReportPage"));
const DisclaimersDisclosuresAdvice = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/DisclaimersDisclosuresAdvice"));
const SignOffAdvice = React.lazy(() => import("../screens/Admin/FinancialPlanning/IncidentalAdviceReport/IncidentalAdviceMenu/SignOffAdvice"));



//Compliance
const Compliance = React.lazy(() => import("../screens/Admin/Compliance/Compliance"));
const ContraTradeReport = React.lazy(() => import("../screens/Admin/Compliance/ContraTradeReport"));
const PublishRestrictedList = React.lazy(() => import("../screens/Admin/Compliance/RestrictedList/PublishRestrictedList"));
const RestrictedListAdd = React.lazy(() => import("../screens/Admin/Compliance/RestrictedList/RestrictedListAdd"));
const ArchivedRestrictedList = React.lazy(() => import("../screens/Admin/Compliance/RestrictedList/ArchivedRestricedList"));
const RestrictedList = React.lazy(()=> import("../screens/Admin/Compliance/RestrictedList/RestrictedList"));
const RegulatoryUpdates = React.lazy(() => import("../screens/Admin/Compliance/RegulatoryUpdates/RegulatoryUpdates"));
const TradeRequest = React.lazy(() => import("../screens/Admin/Compliance/TradeRequest/TradeRequest"));
const TradeRequestAdd = React.lazy(() => import("../screens/Admin/Compliance/TradeRequest/TradeRequestAdd"));
const TradeRequestArchived = React.lazy(() => import("../screens/Admin/Compliance/TradeRequest/TradeRequestArchived"));
const TradeApproval = React.lazy(() => import("../screens/Admin/Compliance/TradeApproval/TradeApproval"));
const ViewTradeRequest = React.lazy(() => import("../screens/Admin/Compliance/ViewTradeRequest"));
// DPDP Client Consent
const DataConsent = React.lazy(() => import("../screens/Admin/Compliance/DataConsent/DataConsent"));
const AddDataConsent = React.lazy(() => import("../screens/Admin/Compliance/DataConsent/AddDataConsent"));
const ReinitiateDataConsent = React.lazy(() => import("../screens/Admin/Compliance/DataConsent/ReinitiateDataConsent"));
const MyDataConsent = React.lazy(() => import("../screens/Client/DataConsent/MyDataConsent"));
const DataConsentApproval = React.lazy(() => import("../screens/Public/DataConsentApproval/DataConsentApproval"));
const DataConsentRevoke = React.lazy(() => import("../screens/Public/DataConsentApproval/DataConsentRevoke"));
// Super Admin

// 1) Dashboard 


// 2) Masters 

const CompanyMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/CompanyDetails/CompanyMaster")));
const AddCompanyMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/CompanyDetails/AddCompanyMaster")));
const ArchivedCompanyMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/CompanyDetails/ArchivedCompanyMaster")));
const MenuOrganizer = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/MenuOrganizer/MenuOrganizer")));
const AddMenuOrganizer = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/MenuOrganizer/AddMenuOrganizer")));
const ArchivedMenuOrganizer = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/MenuOrganizer/ArchivedMenuOrganizer")));
const Advisors = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Advisors/Advisors")));
const AddAdvisors = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Advisors/AddAdvisors")));
const RiskProfilesTypesSuperAdmin = React.lazy(() => import("../screens/SuperAdmin/Master/RiskProfile/RiskProfilesTypes"));
const LoginAccess = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/LoginAccess/LoginAccess")));

const ClientPortfolio = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductCategories/ClientPortfolio/ClientPortfolio")));
const AddClientPortfolio = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductCategories/ClientPortfolio/AddClientPortfolio")));
const ArchivedClientPortfolio = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductCategories/ClientPortfolio/ArchivedClientPortfolio")));
const ArchivedProductCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductCategories/ClientPortfolio/ArchivedProductCategories")));
const CisMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/CisMaster/CisMaster")));
const AddCisMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/CisMaster/AddCisMaster")));
const ArchivedCisMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/CisMaster/ArchivedCisMaster")));
const ClientOnboardingChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/ClientOnboardingChecklistMaster/ClientOnboardingChecklistMaster")));
const AddClientOnboardingChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/ClientOnboardingChecklistMaster/AddClientOnboardingChecklistMaster")));
const ArchivedClientOnboardingChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/ClientOnboardingChecklistMaster/ArchivedClientOnboardingChecklistMaster")));
const ClientClearanceChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/ClientClearanceChecklistMaster/ClientClearanceChecklistMaster")));
const AddClientClearanceChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/ClientClearanceChecklistMaster/AddClientClearanceChecklistMaster")));
const ArchivedClientClearanceChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/ClientClearanceChecklistMaster/ArchivedClientClearanceChecklistMaster")));
const EmployeeOnboardingChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/EmployeeOnboardingChecklistMaster/EmployeeOnboardingChecklistMaster")));
const AddEmployeeOnboardingChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/EmployeeOnboardingChecklistMaster/AddEmployeeOnboardingChecklistMaster")));
const ArchivedEmployeeOnboardingChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/EmployeeOnboardingChecklistMaster/ArchivedEmployeeOnboardingChecklistMaster")));
const EmployeeClearanceChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/EmployeeClearanceChecklistMaster/EmployeeClearanceChecklistMaster")));
const AddEmployeeClearanceChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/EmployeeClearanceChecklistMaster/AddEmployeeClearanceChecklistMaster")));
const ArchivedEmployeeClearanceChecklistMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/EmployeeClearanceChecklistMaster/ArchivedEmployeeClearanceChecklistMaster")));
const NotificationMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/NotificationMaster")));
const AddNotificationMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/AddNotificationMaster")));
const NotificationTitle = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/NotificationTitle")));
const AddNotificationTitle = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/AddNotificationTitle")));
const ArchivedNotificationTitle = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/ArchivedNotificationTitle")));
const ArchivedNotificationMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/ArchivedNotificationMaster")));
const NotificationStatus = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/NotificationStatus")));
const NotificationArchivedStatus = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/NotificationArchivedStatus")));
const NotificationReadStatus = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Notification/NotificationReadStatus")));
const TaskMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/TaskMaster/TaskMaster")));
const AddTaskMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/TaskMaster/AddTaskMaster")));
const ArchivedTaskMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/TaskMaster/ArchivedTaskMaster")))
const CompanyMenuSelection = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/CompanyMenuSelection/CompanyMenuSelection")));
const AddCompanyMenuSelection = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/CompanyMenuSelection/AddCompanyMenuSelection")));

// Upload Document 
const UploadDocument = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/UploadDocument/UploadDocument")));

//Help

const HelpMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Help/HelpMaster")));
const ClientHelpMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Help/ClientHelpMaster")));
const ArchivedClientHelpMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Help/ArchivedClientHelpMaster")));
const AdminHelpMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Help/AdminHelpMaster")));
const AdminHelpMasterAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Help/AdminHelpMasterAdd")));
const ArchivedAdminHelpMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Help/ArchivedAdminHelpMaster")));
const FinancialPlanningHelpMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Help/FinancialPlanningHelpMaster")));
const HelpWindow = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/Help/HelpWindow")));
// Document Master 

const DocumentMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/DocumentsMaster/DocumentsMaster")));
const AddDocumentMaster = React.lazy(() => import("../screens/SuperAdmin/DocumentsMaster/AddDocumentsMaster"));
const ArchivedDocumentsMaster = React.lazy(() => import("../screens/SuperAdmin/DocumentsMaster/ArchivedDocumentsMaster"));

// Role Management 

const RoleManagment = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/RoleManagment/RoleManagment")));
const RoleManagmentPermission = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/RoleManagment/RoleManagementPermission")));
const CreateRoleManagement = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/RoleManagment/CreateRoleManagement")));

// Mis Report
const AdvisorsAua = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/MisReport/AdvisorsAua")));
const MisShares = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/MisReport/MisShares")));
const MisMutualFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/MisReport/MisMutualFunds")));
const SignzyReport = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/MisReport/SignzyReport")));
//  Mail Template

const MailTemplate = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/MailTemplate/MailTemplate")));
const AddMailTemplate = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/MailTemplate/AddMailTemplate")));


//3) Assumption Master 

const AssumptionMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AssumptionMaster/AssumptionMaster")));
const AddAssumptionMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AssumptionMaster/AddAssumptionMaster")));
const ArchivedAssumptionMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AssumptionMaster/ArchivedAssumptionMaster")));

// 1) Advisor Goal Master

const GoalLiablities = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AdvisorGoalMaster/GoalLiablities/GoalLiablities")));
const AddGoalLiablities = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AdvisorGoalMaster/GoalLiablities/AddGoalLiablities")));
const ArchivedGoalLiablities = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AdvisorGoalMaster/GoalLiablities/ArchivedGoalLiablities")));

const InvestmentObjectives = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AdvisorGoalMaster/InvestmentObjectives/InvestmentObjectives")));
const AddInvestmentObjectives = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AdvisorGoalMaster/InvestmentObjectives/AddInvestmentObjectives")));

//  2) Accouting Master

const FinancialYear = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/FinancialYear")));
const EditFinancialYear = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/EditFinancialYear")));
const CostInflation = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/CostInflation")));
const AddCostInflation = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/AddCostInflation")));
const ArchivedCostInflation = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/ArchivedCostInflation")));
const GstMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/GstMaster")));
const AddGstMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/AddGstMaster")));
const ArchivedGstMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Master/AccoutingMaster/ArchivedGstMaster")));


// 3)Product Master 

const ProductCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductCategories/ProductCategories")));
const AddProductCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductCategories/AddProductCategories")));


// 1) Insurance

const InsuranceTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceTypes/InsuranceTypes")));
const AddInsuranceTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceTypes/AddInsuranceTypes")));
const InsuranceSubTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceSubTypes/InsuranceSubTypes")));
const AddInsuranceSubTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceSubTypes/AddInsuranceSubTypes")));
const BenefitsAvailable = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/BenefitsAvailable/BenefitsAvailable")));
const AddBenifitsAvailable = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/BenefitsAvailable/AddBenefitsAvailable")));
const NatureOfPolicy = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/NatureOfPolicy/NatureOfPolicy")));
const AddNatureOfPolicy = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/NatureOfPolicy/AddNatureOfPolicy")));
const Riders = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/Riders/Riders")));
const AddRiders = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/Riders/AddRiders")));
const InsuranceCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceCategories/InsuranceCategories")));
const AddInsuranceCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceCategories/AddInsuranceCategories")));
const AnnuityTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/AnnuityTypes/AnnuityTypes")));
const AddAnnuityTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/AnnuityTypes/AddAnnuityTypes")));
const TransactionType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/TransactionType/TransactionType")));
const AddTransactionType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/TransactionType/AddTransactionType")));
const ArchivedInsuranceTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceTypes/ArchivedInsuranceTypes")));
const ArchivedInsuranceSubTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceSubTypes/ArchivedSubTypes")));
const ArchivedBenefitsAvailable = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/BenefitsAvailable/ArchivedBenifitsAvailable")));
const ArchivedNatureOfPolicy = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/NatureOfPolicy/ArchivedNatureOfPolicy")));
const AddInsuranceRiders = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/Riders/AddInsuranceRiders")));
const ArchivedInsuranceRiders = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/Riders/ArchivedInsuranceRiders")));
const ArchivedInsuranceCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/InsuranceCategories/ArchivedInsuranceCategories")));
const ArchivedAnnuityTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/AnnuityTypes/ArchivedAnnuityTypes")));

// operationTransactionTypeMaster
const OperationTransactionTypeMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/TransactionTypeMaster/OperationTransactionTypeMaster")));
const AddOperationTransactionType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/TransactionTypeMaster/AddOperationTransactionType")));
const ArchivedOperationTransactionType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/TransactionTypeMaster/ArchivedOperationTransactionType")));

// 2)Mutual Funds

const Taxaction = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/Taxaction/Taxaction")));
const AddTaxaction = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/Taxaction/AddTaxaction")));
const MutualFundsCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/MutualFundsCategories/MutualFundsCategories")));
const AddMutualFundsCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/MutualFundsCategories/AddMutualFundsCategories")));
const MutualFundsSubCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/MutualFundsSubCategories/MutualFundsSubCategories")));
const AddMutualFundsSubCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/MutualFundsSubCategories/AddMutualFundsSubCategories")));
const ArchivedTransactionType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Insurance/TransactionType/ArchivedTransactionType")));
const ArchivedTaxaction = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/Taxaction/ArchivedTaxaction")));
const ArchivedMutualFundsCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/MutualFundsCategories/ArchivedMutualFundCategories")));
const ArchivedMutualFundsSubCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/MutualFunds/MutualFundsSubCategories/ArchivedMutualFundSubCategories")));

// Share Master
// 1)Market Cap
const MarketCapMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MarketCapMaster/MarketCapManage")));
const MarketCapAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MarketCapMaster/MarketCapAdd")));
const MarketCapArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MarketCapMaster/MarketCapArchived")));

// 2)Product Type
const ProductTypeMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/ProductType/ProductTypeMasterManage")));
const ProductTypeAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/ProductType/ProductTypeAdd")));
const ProductTypeArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/ProductType/ProductTypeArchived")));

// 3)Asset Class
// const AssetClassMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/AssetClass/AssetClassManage")));
// const AssetClassAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/AssetClass/AssetClassAdd")));
// const AssetClassArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/AssetClass/AssetClassArchived")));

// 4)Industry
const IndustryMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Industry/IndustryManage")));
const IndustryAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Industry/IndustryAdd")));
const IndustryArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Industry/IndustryArchived")));

// 5)Main Sector
const MainSectorMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MainSector/MainSectorManage")));
const MainSectorAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MainSector/MainSectorAdd")));
const MainSectorArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MainSector/MainSectorArchived")));

// 6)Sector
const SectorMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Sector/SectorManage")));
const SectorAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Sector/SectorAdd")));
const SectorArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Sector/SectorArchived")));


// 7)Sub Sector
const SubSectorMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/SubSector/SubSectorManage")));
const SubSectorAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/SubSector/SubSectorAdd")));
const SubSectorArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/SubSector/SubSectorArchived")));

// 8)Micro Sector
const MicroSectorMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MicroSector/MicroSectorManage")));
const MicroSectorAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MicroSector/MicroSectorAdd")));
const MicroSectorArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MicroSector/MicroSectorArchived")));

// 9)ProductAndServices
const ProductAndServicesMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/ProductAndServices/ProductAndServicesManage")));
const ProductAndServicesAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/ProductAndServices/ProductAndServicesAdd")));
const ProductAndServicesArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/ProductAndServices/ProductAndServicesArchived")));

// 10)MOAT
const MOATMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MOAT/MOATManage")));
const MOATAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MOAT/MOATAdd")));
const MOATArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/MOAT/MOATArchived")));

// 11)Model
const ModelMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Model/ModelManage")));
const ModelAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Model/ModelAdd")));
const ModelArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Model/ModelArchived")));

// 12)Cycle
const CycleMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Cycle/CycleManage")));
const CycleAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Cycle/CycleAdd")));
const CycleArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Cycle/CycleArchived")));

// 13)Profile
const ProfileMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Profile/ProfileManage")));
const ProfileAdd = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Profile/ProfileAdd")));
const ProfileArchived = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ShareMaster/Profile/ProfileArchived")));


// 3) Income

const IncomeCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Income/IncomeCategories/IncomeCtaegories")));
const AddIncomeCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Income/IncomeCategories/AddIncomeCategories")));
const IncomeHeads = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Income/IncomeHeads/IncomeHeads")));
const AddIncomeHeads = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Income/IncomeHeads/AddIncomeHeads")));
const ArchivedIncomeHeads = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Income/IncomeHeads/ArchivedIncomeHeads")));
const ArchivedIncomeCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Income/IncomeCategories/ArchivedIncomeCategories")));

// Ulip Funds 

const UlipFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/UlipFunds/UlipFunds")));
const ArchivedUlipFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/UlipFunds/ArchivedUlipFunds")));
const AddUlipFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/UlipFunds/AddUlipFunds")));

// 4) BondsAndDebentures 

const BondsAndDebentureFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/BondsAndDebentureFunds/BondsAndDebentureFunds")));
const AddBondAndDebentureFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/BondsAndDebentureFunds/AddBondAndDebentureFunds")));
const ArchivedBondsAndDebentureFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/BondsAndDebentureFunds/ArchivedBondsAndDebentureFunds")));


// 5) Real Estate

const PropertyType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/RealEstate/PropertyType/PropertyType")));
const AddPropertyType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/RealEstate/PropertyType/AddPropertyType")));
const OwnershipStatus = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/RealEstate/OwnershipStatus/OwnershipStatus")));
const AddOwnershipStatus = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/RealEstate/OwnershipStatus/AddOwnershipStatus")));
const ArchivedOwnershipStatus = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/RealEstate/OwnershipStatus/ArchivedOwnershipStatus")));
const ArchivedPropertyType = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/RealEstate/PropertyType/ArchivedPropertyType")));



// 6) Household

const HouseholdCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdCategoris/HouseholdCategories")));
const AddHouseholdCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdCategoris/AddHouseholdCategories")));
const HouseholdAssets = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdAssets/HouseholdAssets")));
const AddHouseholdAssets = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdAssets/AddHouseholdAssets")));
const HouseholdVehicles = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdsVehicles/HouseholdsVehicles")));
const AddHouseholdVehicles = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdsVehicles/AddHouseholdsVehicles")));
const SAArchivedHouseholdCategories = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdCategoris/ArchivedHouseholdCategories")));
const ArchivedHouseholdAsset = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Households/HouseholdAssets/ArchivedHouseholdAsset")));

// 7)Bank 

const LoanTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Loan Types/LoanTypes")));
const AddLoanTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Loan Types/AddLoanTypes")));
const ArchivedLoanTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Loan Types/ArchivedLoanTypes")));


// 8) Global Product Parameter 

const GlobalProductParameters = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/GlobalProductParameters/GlobalProductParameters")));
const AddGlobalProductParameters = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/GlobalProductParameters/AddGlobalProductParameters")));
const ArchivedGlobalProductParameters = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/GlobalProductParameters/ArchivedGlobalProductParameters")));


// 8) Establishments

const EstablishmentTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentTypes/EstablishmentTypes")));
const AddEstablishmentTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentTypes/AddEstablishmentTypes")));
const InsuranceCompanies = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/InsuranceCompanies/InsuranceCompanies")));
const AddInsuranceCompanies = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/InsuranceCompanies/AddInsuranceCompanies")));
const EstablishmentBank = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentBank/EstablishmentBank")));
const AddEstablishmentBank = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentBank/AddEstablishmentBank")));
const EstablishmentBranch = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentBranch/EstablishmentBranch")));
const AddEstablishmentBranch = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentBranch/AddEstablishmentBranch")));
const EstablishmentFinancialInstitution = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentFinancialInstitution/EstablishmentFinancialInstitution")));
const AddEstablishmentFinancialInstitution = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentFinancialInstitution/AddEstablishmentFinancialInstitution")));
const ArchivedEstablishmentFinancialInstitution = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentFinancialInstitution/ArchivedEstablishmentFinancialInstitution")));
const EstablishmentDepositoryParticipants = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentDepositoryParticipants/EstablishmentDepositoryParticipants")));
const AddEstablishmentDepositoryParticipants = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentDepositoryParticipants/AddEstablishmentDepositoryParticipants")));
const EstablishmentMutualFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentMutualFund/EstablishmentMutualFund")));
const AddEstablishmentMutualFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentMutualFund/AddEstablishmentMutualFund")));
const ArchivedEstablishmentTypes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentTypes/ArchivedEstablishmentTypes")));
const ArchivedInsuranceCompanies = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/InsuranceCompanies/ArchivedInsuranceCompanies")));
const ArchivedEstablishmentBank = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentBank/ArchivedEstablishmentBank")));
const ArchivedEstablishmentBranch = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentBranch/ArchivedEstablishmentBranch")));
const ArchivedEstablishmentDepositoryParticipants = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentDepositoryParticipants/ArchivedEstablishmentDepositoryParticipants")));
const ArchivedEstablishmentMutualFund = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/EstablishmentMutualFund/ArchivedEstablishmentMutualFund")));
const P2pLendingMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/P2pLendingMaster/P2pLendingMaster")));
const AddP2pLendingMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/P2pLendingMaster/AddP2pLendingMaster")));
const ArchivedP2pLendingMaster = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/Establishment/P2pLendingMaster/ArchivedP2pLendingMaster")));


// 9) Product Parameter
//const FixedReturnAndRetirementProducts = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/FixedReturns/FixedReturnAndRetirementProducts")));
const InsuranceProduct = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/InsuranceProduct/InsuranceProduct")));
const AddInsuranceProduct = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/InsuranceProduct/AddInsuranceProduct")));
const ArchivedInsuranceProduct = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/InsuranceProduct/ArchivedInsuranceProduct")));
const SuperAdminMutualFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/MutualFunds/MutulFunds")));
const SuperAdminArchivedMutualFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/MutualFunds/ArchivedMutualFunds")));
const AddMutualFunds = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/MutualFunds/AddMutualFunds")));
const MutualFundNavHistory = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/MutualFunds/MutualFundNavHistory")));
const AddMutualFundNavHistory = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/MutualFunds/AddMutualFundNavHistory")));
const MutualFundQuantitativeIndicators = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/MutualFunds/MutualFundQuantitativeIndicators")));
const AddMutualFundQuantitativeIndicators = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/MutualFunds/AddMutualFundQuantitativeIndicators")));
const SuperAdminShares = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/Shares")));
const AddSharesCompany = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/AddShareCompany")));
const SharesPriceHistory = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/SharesPriceHistory")));
const AddSharesPriceHistory = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/AddSharesPriceHistory")));
const EditSharesPriceHistory = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/EditSharesHistorylPrice")));
const QuaterlyHistoricData = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/QuaterlyHistoricData")));
const AddQuaterlyHistoricData = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/AddQuaterlyHistoricData")));
const ArchivedShares = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/ProductMaster/ProductParameter/Shares/ArchivedShares")));

// Operations
const MfTransactionsErrorsMissingSchemes = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/MfTransactionsErrors/MfTransactionsErrorsMissingSchemes")));
const MatchedScheme = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/matchedScheme")));
const SchemeMissingInSFA = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/missingSchemeInSfa")));
const SchemeMIssingInAccord = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/missingSchemeInAccord")));
const SchemeMIssingInAccordRTA = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/missingSchemeInAccordRTA")));
const SchemeMIssingInAccordAMFI = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/missingSchemeInAccordAMFI")));
const BulkSchemeVerification = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/BulkSchemeVerification")));
const BulkNotVerifiedScheme = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/BulkNotVerifiedScheme")));
const BulkMissingScheme = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/BulkMissingScheme")));
const BulkCategoryVerified = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/BulkCategoryVerified")));

const MFSchemeIsVerified = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SchemeVerification/MFSchemeIsVerified")));
const SharesMatchedScheme = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/shareMatchedScheme")));
const SharesSchemeMissing = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/SharesSchemeMissing")));
const SharesSchemeMissingNSE = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/SharesSchemeMissingNSE")));
const SharesSchemeMissingISIN = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/SharesSchemeMissingISIN")));
const SharesSchemeMissingInAccord = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/SharesSchemeMissingInAccord")));
const SharesSchemeMissingInSFA = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/SharesSchemeMissingInSFA")));
const SharesSchemeIsVerified = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/SharesSchemeIsVerified")));
const SharesSchemeMarketCap = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/SharesSchemeMarketCap")));
const MarketCapImport = React.lazy(() => import("../screens/SuperAdmin/Operations/SharesVerification/MarketCapImport"));
const SharesIsSecDetailsFilled = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/SharesIsSecDetailsFilled")));
const MissingShares = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/SharesVerification/MissingShares")));
const MfTransactionsErrorSchemeMapping = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/MfTransactionsErrors/MfTransactionsErrorSchemeMapping")));
const MfTransactionsErrors = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/MfTransactionsErrors/MfTransactionsErrors")));
const MFSchemeVerify = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/MfTransactionsErrors/SchemeVerify")));
const ShareTransactionMissingCode = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/MfTransactionsErrors/ShareTransactionsErrors/ShareTransactionsMissingCode")));
const ShareTransactionsError = React.lazy(() => lazyRetry(() => import("../screens/SuperAdmin/Operations/MfTransactionsErrors/ShareTransactionsErrors/ShareTranssactionsError")));
const ClientMigration = React.lazy(() => import("../screens/SuperAdmin/Operations/ClientMigration/ClientMigration"));
const AddClientMigration = React.lazy(() => import("../screens/SuperAdmin/Operations/ClientMigration/AddClientMigration"));

//Superadmin Stock Actions
const CorporateActions = React.lazy(() => import("../screens/SuperAdmin/StockActions/CorporateActions"));
//Category Master
const CategoryMaster = React.lazy(() => import("../screens/Admin/Masters/CategoryMaster"));
const CategoryMasterArchived = React.lazy(() => import("../screens/Admin/Masters/CategoryMasterArchived"));
const CategoryMasterAdd = React.lazy(() => lazyRetry(() => import("../screens/Admin/Masters/CategoryMasterAdd")));

//Superadmin Fintech Actions
const FintechActions = React.lazy(() => import("../screens/SuperAdmin/FintechActions/FintechActions"));

//Pms Product Master
const PmsManage = React.lazy(() => import("../screens/SuperAdmin/ProductMaster/Pms/PmsManage"));
const PmsAdd = React.lazy(() => import("../screens/SuperAdmin/ProductMaster/Pms/PmsAdd"));
const PmsArchived = React.lazy(() => import("../screens/SuperAdmin/ProductMaster/Pms/PmsArchived"));

//Aif Product Master
const AifManage = React.lazy(() => import("../screens/SuperAdmin/ProductMaster/Aif/AifManage"));
const AifAdd = React.lazy(() => import("../screens/SuperAdmin/ProductMaster/Aif/AifAdd"));
const AifArchived = React.lazy(() => import("../screens/SuperAdmin/ProductMaster/Aif/AifArchived"));

//Pms Product Master/Establishment
const PmsEstablishmentManage = React.lazy(() => import("../screens/SuperAdmin/ProductMaster/Establishment/Pms/PmsManage"));
const PmsEstablishmentAdd = React.lazy(() => import("../screens/SuperAdmin/ProductMaster/Establishment/Pms/PmsAdd"));
const PmsEstablishmentArchived = React.lazy(() => import("../screens/SuperAdmin/ProductMaster/Establishment/Pms/PmsArchived"));

//Aif Product Master/Establishment
const AifEstablishmentManage = React.lazy(() => import("../screens/SuperAdmin/ProductMaster/Establishment/Aif/AifManage"));
const AifEstablishmentAdd = React.lazy(() => import("../screens/SuperAdmin/ProductMaster/Establishment/Aif/AifAdd"));
const AifEstablishmentArchived = React.lazy(() => import("../screens/SuperAdmin/ProductMaster/Establishment/Aif/AifArchived"));

//PMS Client Portfolio
const PmsClientPortfolioManage = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/PmsManage"));
const PmsClientPortfolioAdd = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/PmsAdd"));
const PmsClientPortfolioArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/PmsArchived"));
const PmsClientPortfolioPassbookManage = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/PmsPassbookManage"));
const PmsClientPassbookEntryAdd = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/PmsPassbookEntryAdd"));

//AIF Client Portfolio
const AIFClientPortfolioManage = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AIFClientPortfolioManage"));
const AIFClientPortfolioAdd = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AIFClientPortfolioAdd"));
const AIFClientPortfolioArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AIFClientPortfolioArchived"));
const AIFClientPortfolioPassbookManage = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AIFClientPortfolioPassbookManage"));
const AIFClientPassbookEntryAdd = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/AIFPassbookEntryAdd"));
const FilesUploadHistory = React.lazy(() => import("../screens/Admin/Accouting/Operation/FilesUpload/FilesUploadHistory"));
const BulkMfTransactions = React.lazy(() => import("../screens/SuperAdmin/Operations/BulkMfTransactions/BulkMfTransactions"));
const FilesUploadBulkMfTransactions = React.lazy(() => import("../screens/SuperAdmin/Operations/BulkMfTransactions/TransactionFilesUpload"));
const BulkMfSystematicTransactions = React.lazy(() => import("../screens/SuperAdmin/Operations/BulkMfSystematicTransactions/BulkMfSystematicTransactions"));
const FilesUploadBulkMfSystematicTransactions = React.lazy(() => import("../screens/SuperAdmin/Operations/BulkMfSystematicTransactions/TransactionFilesUpload"));


//Others Client Portfolio
const OthersClientPortfolioManage = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/OthersClientPortfolioManage"));
const OthersClientPortfolioAdd = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/OthersClientPortfolioAdd"));
const OthersClientPortfolioArchived = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/OthersClientPortfolioArchived"));
const OthersClientPortfolioPassbookManage = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/OthersClientPortfolioPassbookManage"));
const OthersClientPassbookEntryAdd = React.lazy(() => import("../screens/DataEntryOperator/Portfolio/OthersPassbookEntryAdd"));
const Mails = React.lazy(() => import("../screens/Admin/Mails/Mails"));
const DMATLedger = React.lazy(() => import("../screens/Admin/Accouting/Operation/DMATLedger/DMATLedger"));
const DMATLedgerOthers = React.lazy(() => import("../screens/Admin/Accouting/Operation/DMATLedger/DMATLedgerOthers"));
const DMATLedgerPassbookManage = React.lazy(() => import("../screens/Admin/Accouting/Operation/DMATLedger/DMATLedgerPassbookManage"));
const DMATLedgerPassbookEntryAdd = React.lazy(() => import("../screens/Admin/Accouting/Operation/DMATLedger/DMATLedgerPassbookEntryAdd"));

const SchedulerEmailReportManage = React.lazy(() => import("../screens/Admin/MisReport/Reports/ScheduleEmailReportManage"));
const SchedulerEmailReportAdd = React.lazy(() => import("../screens/Admin/MisReport/Reports/ScheduleEmailReportAdd"));
const SchedulerEmailReportArchived = React.lazy(() => import("../screens/Admin/MisReport/Reports/ScheduleEmailReportArchived"));


const RTAClientMaster = React.lazy(() => import("../screens/Admin/Accouting/Operation/RTAClientMaster/RTAClientMaster"));
const RTAClientMasterError = React.lazy(() => import("../screens/Admin/Accouting/Operation/RTAClientMaster/RTAClientMasterError"));
const RTAClientMasterArchived = React.lazy(() => import("../screens/Admin/Accouting/Operation/RTAClientMaster/RTAClientMasterArchived"));
const RTAClientMaasterUpload = React.lazy(() => import("../screens/Admin/Accouting/Operation/RTAClientMaster/RTAClientMasterUpload"));
const Navigation = () => {
  const login: any = useSelector<RootState, UserState>(
    (state: any) => state.userLogin
  );

  interface ProtectedRouteProps extends RoutesProps {
    isAuthenticated: boolean;
    authenticationPath: string;
  }

  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    isAuthenticated: localStorage.getItem("token") != null,
    authenticationPath: "/login",
  };



  return (
    <>
      <div>
        <Routes>
          <Route path="/smallcase-blank-page" element={<SmallCaseSdkBlankPage/>}/>
          {/* TEMP DESIGN PREVIEW — remove before commit */}
          <Route path="/preview/edit-company-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <div className="content-main" style={{ padding: 24 }}><EditCompanyDetails /></div>
          </Suspense>} />
          {/* TEMP DESIGN PREVIEW — remove before commit */}
          <Route path="/preview/client-investor-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <div className="content-main" style={{ padding: 24 }}>
              <ClientInvestorReport previewData={[
                { customer_basics_id: 1, self_name: "Rahul Sharma", family_members: "Sunita (Spouse), Riya (Daughter), Aarav (Son)" },
                { customer_basics_id: 2, self_name: "Priya Mehta", family_members: "Vikram (Spouse), Kabir (Son)" },
                { customer_basics_id: 3, self_name: "Anil Kapoor", family_members: "Neha (Spouse), Ramesh (Father), Kamla (Mother)" },
                { customer_basics_id: 4, self_name: "Deepa Nair", family_members: "Arjun (Spouse)" },
                { customer_basics_id: 5, self_name: "Suresh Iyer", family_members: "" },
              ]} />
            </div>
          </Suspense>} />
          <Route path="/" element={<Navigate replace to="/login" />} />
          <Route
            path="/login"
            element={
              defaultProtectedRouteProps.isAuthenticated ||
                login.loginSuccess ? (
                <Navigate replace to="/dashboard" />
              ) : (
                <Login />
              )
            }
          />
          <Route path="/forget-password" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <ForgetPassword />
          </Suspense>} />
          <Route path="/set-password" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <SetPassword />
          </Suspense>} />
          <Route path="/members" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <Members />
          </Suspense>} />
          <Route path="/add-member" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <AddMember />
          </Suspense>} />
          <Route path="/otp" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <Otp />
          </Suspense>} />
          <Route path="/welcome" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <Welcome />
          </Suspense>} />
          <Route path="/self" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <SelfInfo />
          </Suspense>} />
          <Route path="/spouse" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <SpouseInfo />
          </Suspense>} />
          <Route path="/members-list" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <MembersList />
          </Suspense>} />


          <Route path="/register-otp/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <Otp />
          </Suspense>} />

          {/* Risk Profile - Link based: public, menu-less client wizard (no app shell) */}
          <Route path="/risk-profile-invite/:token" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <RiskProfileInviteLanding />
          </Suspense>} />
          <Route path="/risk-profile-invite/questions" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <NewRiskProfileQue />
          </Suspense>} />
          <Route path="/risk-profile-invite/questions/:type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <NewRiskProfileQue />
          </Suspense>} />
          <Route path="/risk-profile-invite/disclaimers" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <NewRiskProfileDeclaimer />
          </Suspense>} />
          <Route path="/risk-profile-invite/system" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <NewRiskProfileQueSystem />
          </Suspense>} />
          <Route path="/risk-profile-invite/override" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <NewRiskProfileOverride />
          </Suspense>} />
          <Route path="/risk-profile-invite/override-disclaimer" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <OverrideDisclaimer />
          </Suspense>} />
          <Route path="/risk-profile-invite/done" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <RiskProfileInviteDone />
          </Suspense>} />

          {/* DPDP Data Consent: public, no-login approval link (no app shell) */}
          <Route path="/data-consent/:token" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <DataConsentApproval />
          </Suspense>} />
          {/* DPDP Data Consent: public, no-login revoke link (advisor-initiated) */}
          <Route path="/data-consent-revoke/:token" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <DataConsentRevoke />
          </Suspense>} />

          {/* PROTECTED ROUTES */}
          <Route path="/"
            element={
              <ProtectedRoute
                {...defaultProtectedRouteProps}
                outlet={<Main />}
              />
            }
          >

            {/* DPDP Data Consent (Compliance + client profile) */}
            <Route path="/compliance/data-consent" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DataConsent />
            </Suspense>} />
            <Route path="/compliance/data-consent/add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDataConsent />
            </Suspense>} />
            <Route path="/compliance/data-consent/reinitiate/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ReinitiateDataConsent />
            </Suspense>} />
            <Route path="/data-consent" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MyDataConsent />
            </Suspense>} />

            {/* DATA ENTRY OPERATOR */}

            {/* {HEADER} */}

            <Route path="/discrepancies" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Discrepanices />
            </Suspense>} />

            <Route path="/alerts" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Alerts />
            </Suspense>} />
            <Route path="/my-profile" element={<Suspense fallback={null}  >
              <MyProfile />
            </Suspense>} />
            <Route path="/change-password" element={<Suspense fallback={null}  >
              <ChangePassword />
            </Suspense>} />
            <Route path="/documents" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Documents />
            </Suspense>} />
            {/* 1) Dashboard Module */}




            <Route path="/review" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Review />
            </Suspense>} />
            <Route path="/review-details/:customer_basics_id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ReviewDetails />
            </Suspense>} />
            <Route path="/review-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ReviewCompleted />
            </Suspense>} />
            <Route path="/review-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ReviewCancelled />
            </Suspense>} />
            <Route path="/review-calendar" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ReviewCalendar />
            </Suspense>} />
            <Route path="/dashboard" element={<Suspense fallback={<DashboardSkeleton />}  >
              <DashBoard />
            </Suspense>} />
            <Route path="/client-notes/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientNotes />
            </Suspense>} />
            <Route path="/dashboard/new-risk-profile" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NewRiskProfile />
            </Suspense>} />
            <Route path="/dashboard/start-new-risk-profile" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NewRiskProfileQue />
            </Suspense>} />
            <Route path="/dashboard/start-new-risk-profile-manual" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NewRiskProfileQueManual />
            </Suspense>} />
            <Route path="/dashboard/start-new-risk-profile-system" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NewRiskProfileQueSystem />
            </Suspense>} />
            <Route path="/dashboard/start-new-risk-profile/:type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NewRiskProfileQue />
            </Suspense>} />
            <Route path="/dashboard/new-risk-profile-disclaimers" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NewRiskProfileDeclaimer />
            </Suspense>} />
            <Route path="/dashboard/new-risk-profile-override" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NewRiskProfileOverride />
            </Suspense>} />
            <Route path="/dashboard/override-disclaimer" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OverrideDisclaimer />
            </Suspense>} />
            <Route path="/dashboard/risk-profile-history" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RiskProfilHistory />
            </Suspense>} />
            <Route path="/operations/risk-profile-link" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RiskProfileLinkList />
            </Suspense>} />

            {/* Admin dashboard View Details */}

            <Route path="/dashboard/submit-data-view-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SubmitDataViewDetails />
            </Suspense>} />
            <Route path="/dashboard/discarded-submit-data-view-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DiscardedSubmitDataViewDetails />
            </Suspense>} />
            <Route path="/dashboard/edit-submit-data-view-details/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditSubmitDataForPlanning />
            </Suspense>} />
            <Route path="/dashboard/edit-aua-asset" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AuaAssetViewDetails />
            </Suspense>} />
            <Route path="/dashboard/asset-under-management" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminAseetUnderManagementViewDetail />
            </Suspense>} />
            <Route path="/dashboard/asset-under-management-shares" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminAuaAseetsShares />
            </Suspense>} />
            <Route path="/dashboard/client-portfolio-view-detail" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminClientPortfolioViewDetail />
            </Suspense>} />
            <Route path="/dashboard/locked-accounts" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminLockedAccountsViewDetails />
            </Suspense>} />
            <Route path="/dashboard/sip-book-view-detail" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminSipBookViewDetail />
            </Suspense>} />
            <Route path="/dashboard/expiring-systematic-plans" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminExpiringSystematicPlansViewDetails />
            </Suspense>} />
            <Route path="/asset-pending-for-mapping" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminDashBoardAssetPendingViewDetails />
            </Suspense>} />
            <Route path="/goals-pending-for-mapping" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminDashBoardGoalsPendingViewDetails />
            </Suspense>} />
            <Route path="/dashboard/aum-manage" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminAumViewDetail />
            </Suspense>} />
            {/* 2) Establishment Module */}
            <Route path="/establishment/establishment-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Establishment />
            </Suspense>} />

            {/* 2) Information Module */}
            <Route path="/information/personal/family" element={<Suspense fallback={null}  >
              <Family />
            </Suspense>} />
            <Route path="/information/personal/add-member" element={<Suspense fallback={null}  >
              <AddFamilyMember />
            </Suspense>} />
            <Route path="/information/personal/archived-family-member" element={<Suspense fallback={null}  >
              <ArchivedFamily />
            </Suspense>} />
            <Route path="/information/personal/edit-member/:id" element={<Suspense fallback={null}  >
              <AddFamilyMember />
            </Suspense>} />
            <Route path="/information/personal/edit-primary-member/:id" element={<Suspense fallback={null}  >
              <EditFamilyMember />
            </Suspense>} />
            <Route path="/information/add-bank-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBankAccount />
            </Suspense>} />
            <Route path="/information/edit-bank-account/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBankAccount />
            </Suspense>} />
            <Route path="/information/add-dmat-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDmatAccount />
            </Suspense>} />
            <Route path="/information/edit-dmat-account/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDmatAccount />
            </Suspense>} />
            <Route path="/information/add-investment-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMfCard />
            </Suspense>} />
            <Route path="/information/edit-investment-account/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMfCard />
            </Suspense>} />
            <Route path="/information/mandates/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AccountMandates />
            </Suspense>} />
            <Route path="/information/add-mandates" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAccountMandates />
            </Suspense>} />
            <Route path="/information/edit-mandates/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAccountMandates />
            </Suspense>} />
            <Route path="/information/archived-mandates/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedAccountMandates />
            </Suspense>} />
            <Route path="/information/accounts" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BankAccounts />
            </Suspense>} />
            <Route path="/information/income" element={<Suspense fallback={<IncomePageSkeleton />}  >
              <Income />
            </Suspense>} />
            <Route path="/information/add-income" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddIncome />
            </Suspense>} />
            <Route path="/information/edit-income/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddIncome />
            </Suspense>} />
            <Route path="/information/view-edit-income/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddIncome />
            </Suspense>} />
            <Route path="/information/archived-income" element={<Suspense fallback={<ArchivedIncomePageSkeleton />}  >
              <IncomeArchived />
            </Suspense>} />
            <Route path="/information/loans" element={<Suspense fallback={<> <Loader show={true} /> </>}  > <Loans />
            </Suspense>} />
            <Route path="/information/add-loan" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddLoan />
            </Suspense>} />
            <Route path="/information/edit-loan/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddLoan />
            </Suspense>} />
            <Route path="/information/archived-loan" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LoansArchived />
            </Suspense>} />
            <Route path="/information/amotization-loan/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LoansAmortization />
            </Suspense>} />
            <Route path="/information/import-amotization-loan/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ImportAmotizationLoan />
            </Suspense>} />
            <Route path="/information/generate-amotization-loan/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GenerateAmotizationLoan />
            </Suspense>} />
            <Route path="/information/personal/address" element={<Suspense fallback={<AddressPageSkeleton />}  >
              <Address />
            </Suspense>} />
            <Route path="/information/personal/add-address" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAddress />
            </Suspense>} />
            <Route path="/information/personal/edit-address/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAddress />
            </Suspense>} />
            <Route path="/information/personal/archived-address" element={<Suspense fallback={<ArchivedAddressPageSkeleton />}  >
              <AddressArchivedList />
            </Suspense>} />



            <Route path="/information/personal/health-lifestyle" element={<Suspense fallback={<HealthPageSkeleton />}  >
              <HealthLifestyle />
            </Suspense>} />
            <Route path="/information/personal/add-health-lifestyle" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHealthLifestyle />
            </Suspense>} />
            <Route path="/information/personal/edit-health-lifestyle/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHealthLifestyle />
            </Suspense>} />
            <Route path="/information/personal/occupation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Occupation />
            </Suspense>} />
            <Route path="/information/personal/add-occupation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditOccupation />
            </Suspense>} />
            <Route path="/information/personal/edit-occupation/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditOccupation />
            </Suspense>} />
            <Route path="/information/personal/view-edit-occupation/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditOccupation />
            </Suspense>} />
            <Route path="/information/personal/archived-occupation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OccupationArchived />
            </Suspense>} />

            <Route path="/information/physical-assets/vehicles" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PhysicalAssetsVehicle />
            </Suspense>} />
            <Route path="/information/physical-assets/add-vehicles" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPhysicalAssetsVehicle />
            </Suspense>} />
            <Route path="/information/physical-assets/edit-vehicles/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPhysicalAssetsVehicle />
            </Suspense>} />
            <Route path="/information/physical-assets/archived-vehicles" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PhysicalAssetsVehicleArchived />
            </Suspense>} />
            <Route path="/information/physical-assets/household" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PhysicalAssetHousehold />
            </Suspense>} />
            <Route path="/information/personal/add-household" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPhysicalAssetsHousehold />
            </Suspense>} />
            <Route path="/information/personal/edit-household/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPhysicalAssetsHousehold />
            </Suspense>} />
            <Route path="/information/personal/multiple-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MultipleAddHouseHold />
            </Suspense>} />
            <Route path="/information/personal/archived-household" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PhysicalAssetHouseholdArchivedList />
            </Suspense>} />

            {/* Planing   */}

            <Route path="/planing/life-insrance-requirement" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LifeInsuranceReq />
            </Suspense>} />
            <Route path="/planing/retirement" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RetirementPlan />
            </Suspense>} />

            {/* 3) Portfolio */}
            <Route path="/portfolio" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Portfolio />
            </Suspense>} />
            <Route path="/portfolio/add-fixed-return" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFixedReturn />
            </Suspense>} />
            <Route path="/portfolio/edit-fixed-return/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFixedReturn />
            </Suspense>} />
            <Route path="/portfolio/view-fixed-return/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFixedReturn />
            </Suspense>} />
            <Route path="/portfolio/fixed-return" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedReturn />
            </Suspense>} />
            <Route path="/portfolio/fixed-return-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedReturnArchieved />
            </Suspense>} />
            <Route path="/portfolio/fixed-return-interst-records/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedReturnInterestRecords />
            </Suspense>} />
            <Route path="/portfolio/fixed-return-passbook/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedReturnPassbook />
            </Suspense>} />
            <Route path="/portfolio/archived-fixed-return-interst-records" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedReturnInterestRecordsArchived />
            </Suspense>} />
            <Route path="/portfolio/ppf-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PpfAccount />
            </Suspense>} />
            <Route path="/portfolio/add-ppf-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPpfAccount />
            </Suspense>} />
            <Route path="/portfolio/edit-ppf-acount/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPpfAccount />
            </Suspense>} />
            <Route path="/portfolio/ppf-passbook/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PpfPassbook />
            </Suspense>} />
            <Route path="/portfolio/add-ppfpassbook-entry/:id1" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPpfPassbookEntry />
            </Suspense>} />
            <Route path="/portfolio/edit-ppfpassbook-entry/:id1/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPpfPassbookEntry />
            </Suspense>} />
            <Route path="/portfolio/ppf-archived-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PpfArchivedAccounts />
            </Suspense>} />
            <Route path="/portfolio/ssy-add-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SsyAddAccount />
            </Suspense>} />
            <Route path="/portfolio/ssy-edit-acount/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SsyAddAccount />
            </Suspense>} />
            <Route path="/portfolio/ssy-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SsyAccount />
            </Suspense>} />
            <Route path="/portfolio/ssy-archived-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SsyArchivedAccounts />
            </Suspense>} />
            <Route path="/portfolio/ssy-account-passbook/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SsyPassbook />
            </Suspense>} />
            <Route path="/portfolio/add-ssy-passbook/:id1" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSsyPassbookEntry />
            </Suspense>} />
            <Route path="/portfolio/edit-ssy-passbook/:id1/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSsyPassbookEntry />
            </Suspense>} />
            <Route path="/portfolio/bonds-debentures" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BondsAndDebentures />
            </Suspense>} />
            <Route path="/portfolio/add-bonds-debentures" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBondAndDebentures />
            </Suspense>} />
            <Route path="/portfolio/edit-bonds-debentures/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBondAndDebentures />
            </Suspense>} />
            <Route path="/portfolio/archived-bonds-debentures" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BondsAndDebenturesArchived />
            </Suspense>} />
            <Route path="/portfolio/realestate-properties" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RealEstateProperties />
            </Suspense>} />
            <Route path="/portfolio/add-realestate-properties" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRealEstate />
            </Suspense>} />
            <Route path="/portfolio/edit-realestate-properties/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRealEstate />
            </Suspense>} />
            <Route path="/portfolio/realestate-archived-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RealEstateArchivedAccounts />
            </Suspense>} />
            <Route path="/portfolio/bullion-investments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BullionInvestments />
            </Suspense>} />

            <Route path="/portfolio/archeived-bullion-sip" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArcheivedBullionSip />
            </Suspense>} />
            <Route path="/portfolio/add-bullion-sip" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBullionSip />
            </Suspense>} />
            <Route path="/portfolio/edit-bullion-sip/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBullionSip />
            </Suspense>} />

            <Route path="/portfolio/edit-bullion-investments/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditBullionInvestments />
            </Suspense>} />
            <Route path="/portfolio/add-bullion-investments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditBullionInvestments />
            </Suspense>} />
            <Route path="/portfolio/archived-bullion-investments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BullionInvestmentsArchived />
            </Suspense>} />
            <Route path="/portfolio/epf-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EpfAccount />
            </Suspense>} />
            <Route path="/portfolio/epf-archieved" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EpfArchieved />
            </Suspense>} />
            <Route path="/portfolio/add-epf-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEpfDetails />
            </Suspense>} />
            <Route path="/portfolio/edit-epf-details/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEpfDetails />
            </Suspense>} />
            <Route path="/portfolio/epf-passbook/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EpfPassbook />
            </Suspense>} />
            <Route path="/portfolio/add-epf-passbook-entry/:id1" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEpfPassbookEntry />
            </Suspense>} />
            <Route path="/portfolio/edit-epf-passbook-entry/:id1/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEpfPassbookEntry />
            </Suspense>} />
            <Route path="/portfolio/mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFunds />
            </Suspense>} />
            <Route path="/portfolio/mutual-funds-transaction/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundsTransactions />
            </Suspense>} />
            <Route path="/portfolio/update-mutualfunds-transaction/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <UpdateMutualFundTransaction />
            </Suspense>} />
            <Route path="/portfolio/update-shareetf-transaction/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <UpdateShareEtfTransaction />
            </Suspense>} />
            <Route path="/portfolio/archived-mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundsArchivedList />
            </Suspense>} />
            <Route path="/portfolio/mutual-funds-transaction-archived/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundsTransactionsArchived />
            </Suspense>} />
            <Route path="/portfolio/mutual-fund/systematic-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SystematicInvestmentArchived />
            </Suspense>} />
            <Route path="/portfolio/mutual-fund/systematic-future" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SystematicInvestmentFuture />
            </Suspense>} />
            <Route path="/portfolio/add-sip-stp-swp" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSipStpSwp />
            </Suspense>} />
            <Route path="/portfolio/edit-sip-stp-swp/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSipStpSwp />
            </Suspense>} />
            <Route path="/portfolio/nps-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NpsDetails />
            </Suspense>} />
            <Route path="/portfolio/add-nps-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddNpsDetails />
            </Suspense>} />
            <Route path="/portfolio/edit-nps-details/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddNpsDetails />
            </Suspense>} />
            <Route path="/portfolio/nps-details-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NpsDetailArchieved />
            </Suspense>} />
            <Route path="/portfolio/superannuation-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SuperannuationAcc />
            </Suspense>} />
            <Route path="/portfolio/add-superannuation-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSuperannuationDetails />
            </Suspense>} />
            <Route path="/portfolio/edit-superannuation-account/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSuperannuationDetails />
            </Suspense>} />
            <Route path="/portfolio/archived-superannuation-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SuperAnnutationArchived />
            </Suspense>} />
            <Route path="/portfolio/cash-equivalents" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CashEquivalents />
            </Suspense>} />
            <Route path="/portfolio/insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsurancePortfolio />
            </Suspense>} />
            <Route path="/portfolio/shares-etf" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareETF />
            </Suspense>} />
            <Route path="/portfolio/change-dmat" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ChangeDmat />
            </Suspense>} />
            <Route path="/portfolio/holding-archived-shares-etf" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareETFHoldingArchivedList />
            </Suspense>} />
            <Route path="/portfolio/shares-etf-transaction/:id1/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareEtfTransactions />
            </Suspense>} />
            <Route path="/portfolio/shares-etf-transaction-archived/:id1/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareEtfTransactionsArchived />
            </Suspense>} />
            <Route path="/portfolio/add-share-epf-sip" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddShareEpfSip />
            </Suspense>} />
            <Route path="/portfolio/archeived-share-sip" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArcheivedShareSip />
            </Suspense>} />
            <Route path="/portfolio/edit-share-epf-sip/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddShareEpfSip />
            </Suspense>} />

            {/* 4) Goals Module */}

            <Route path="/goals" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Goals />
            </Suspense>} />
            <Route path="goals/add-goal" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGoal />
            </Suspense>} />
            <Route path="goals/edit-goal/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGoal />
            </Suspense>} />
            <Route path="goals/view-goal/:id/:disable" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGoal />
            </Suspense>} />
            <Route path="goals/archeived-goal" element={<Suspense fallback={<ArchivedGoalsSkeleton />}  >
              <ArcheivedGoals />
            </Suspense>} />

            {/* 5) Expense Module */}

            <Route path="/expenses" element={<Suspense fallback={<ExpensesPageSkeleton />}  >
              <Expenses />
            </Suspense>} />
            <Route path="/expenses-detail" element={<Suspense fallback={<ExpensesDetailsSkeleton />}  >
              <ExpensesDetails />
            </Suspense>} />
            <Route path="/expenses-minimum" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ExpensesMinimum />
            </Suspense>} />
            <Route path="/expenses-detail-saved" element={<Suspense fallback={<ExpensesDetailsSkeleton />}  >
              <ExpensesDetailsSave />
            </Suspense>} />
            <Route path="/insurance-riders/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceRiders />
            </Suspense>} />



            {/* 6) Insurance */}

            <Route path="/insurance" element={<Suspense fallback={<InsuranceSkeleton />}  >
              <Insurance />
            </Suspense>} />
            <Route path="/insurance/add-insurance-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsurance />
            </Suspense>} />
            <Route path="/insurance/edit-insurance-details/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsurance />
            </Suspense>} />
            <Route path="/insurance/add-riders/:insurence_id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRiders />
            </Suspense>} />
            <Route path="/insurance/edit-riders/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRiders />
            </Suspense>} />
            <Route path="/insurance/archived-riders/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedRiders />
            </Suspense>} />
            <Route path="/archived-insurance" element={<Suspense fallback={<InsuranceSkeleton />}  >
              <ArchivedInsurance />
            </Suspense>} />
            <Route path="/future-insurance" element={<Suspense fallback={<InsuranceSkeleton />}  >
              <FutureInsurance />
            </Suspense>} />
            <Route path="/add-money-back-payout/:id/:type" element={<Suspense fallback={<><Loader show={true} /> </>} >
              <AddMoneyBackPayout />
            </Suspense>} />
            <Route path="/update-money-back-payout/:id/:type/:p_id" element={<Suspense fallback={<><Loader show={true} /> </>} >
              <AddMoneyBackPayout />
            </Suspense>} />

            {/* 7) Action */}

            <Route path="/actions" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Actions />
            </Suspense>} />
            <Route path="/actions/my-task" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MyTask />
            </Suspense>} />
            <Route path="/actions/client-task" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientTask />
            </Suspense>} />
            <Route path="/actions/my-task-hibernated" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Hibernated />
            </Suspense>} />
            <Route path="/actions/my-task/edit" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditTask />
            </Suspense>} />
            <Route path="/actions/assign-task" element={<Suspense fallback={null}  >
              <AssignTask />
            </Suspense>} />
            <Route path="/actions/recurring" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Recurring />
            </Suspense>} />
            <Route path="/actions/archived-recurring" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedRecurring />
            </Suspense>} />
            <Route path="/actions/my-action-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMyTask />
            </Suspense>} />
            <Route path="/actions/add-recurring" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRecurring />
            </Suspense>} />
            <Route path="/actions/edit-recurring/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRecurring />
            </Suspense>} />
            <Route path="/actions/document-tracker" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DocumentTracker />
            </Suspense>} />
            <Route path="/actions/add-document-tracker" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDocumentTracker />
            </Suspense>} />
            <Route path="/actions/edit-document-tracker/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDocumentTracker />
            </Suspense>} />
            <Route path="/actions/archived-document-tracker" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedDocumentTracker />
            </Suspense>} />

            <Route path="/actions/manager" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Manager />
            </Suspense>} />
            <Route path="/actions/unassign-manager" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <UnassignedManager />
            </Suspense>} />
            <Route path="/actions/reassign-manager" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ReassignManager />
            </Suspense>} />
            <Route path="/action/my-document" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MyDocuments />
            </Suspense>} />
            <Route path="/action/add-document" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDocument />
            </Suspense>} />
            <Route path="/action/edit-document/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDocument />
            </Suspense>} />
            <Route path="/action/archived-document" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedDocument />
            </Suspense>} />
            <Route path="/action/view-edit-document/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDocument />
            </Suspense>} />
            <Route path="/raise/advice/request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RaiseAdviceRequest />
            </Suspense>} />
            <Route path="/raise/advice/add-client-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientAdviceRequest />
            </Suspense>} />
            <Route path="/raise/advice/archeived-client-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArcheivedClientAdviceRequest />
            </Suspense>} />
            <Route path="/raise/advice/edit-Lum-sum_investment-client-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditLumSumInvestment />
            </Suspense>} />
            <Route path="/raise/advice/edit-Sip_investment-client-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditSipInvestment />
            </Suspense>} />
            <Route path="/raise/advice/edit-redemption-client-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditRedemption />
            </Suspense>} />
            <Route path="/raise/advice/edit-Sip_Cancellation-client-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditSipCancellation />
            </Suspense>} />
            <Route path="/raise/advice/edit-Sip_Pause-client-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditSipPause />
            </Suspense>} />

            {/*  */}
            <Route path="/actions/add-action" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAction />
            </Suspense>} />
            <Route path="/actions/edit-action/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAction />
            </Suspense>} />
            <Route path="/actions/edit-task/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAction />
            </Suspense>} />
            <Route path="/action/view-edit-action/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAction />
            </Suspense>} />
            <Route path="/action/view-edit-task/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAction />
            </Suspense>} />
            <Route path="/actions/archived-assigned-task" element={<Suspense fallback={null}  >
              <ArchivedAssignTask />
            </Suspense>} />
            <Route path="/actions/my-action-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMyTask />
            </Suspense>} />
            <Route path="/actions/fintech-task" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FintechTask />
            </Suspense>} />
            <Route path="/actions/fintech-assign-task" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FintechAssignTask />
            </Suspense>} />
             <Route path="/actions/fintech-my-task" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FintechMyTask />
            </Suspense>} />
             <Route path="/actions/internal-fintech-my-task" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InternalFintechMyTask />
            </Suspense>} />
             <Route path="/actions/fintech-task-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedFintechTask />
            </Suspense>} />
             <Route path="/actions/fintech-assign-task-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedFintechAssignTask />
            </Suspense>} />
             <Route path="/actions/internal-fintech-task-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InternalArchivedFintechTask />
            </Suspense>} />
            <Route path="/actions/add-fintech-task" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFintechTask />
            </Suspense>} />
            <Route path="/actions/add-fintech-assign-task" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFintechAssignTask />
            </Suspense>} />
            <Route path="/actions/edit-fintech-task/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFintechAssignTask />
            </Suspense>} />
            <Route path="/actions/edit-fintech-client-task/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFintechTask />
            </Suspense>} />
            <Route path="/action/view-fintech-task/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFintechTask />
            </Suspense>} />
            <Route path="/action/view-assign-fintech-task/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFintechAssignTask />
            </Suspense>} />
            <Route path="/action/view-edit-fintech-task/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFintechTask />
            </Suspense>} />
            {/*  */}

            <Route path="/action/minutes-of-meeting" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MinutesOfMeeting />
            </Suspense>} />
            <Route path="/action/received-for-review" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ReceivedForReview />
            </Suspense>} />
            <Route path="/action/add-minutes-of-meeting" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMoM />
            </Suspense>} />
            <Route path="/action/edit-minutes-of-meeting/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMoM />
            </Suspense>} />
            <Route path="/actions/mom-sentfor-review" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MomSentForReview />
            </Suspense>} />
            <Route path="/submitted-clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SubmittedClients />
            </Suspense>} />
            <Route path="/archived-mom" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMOM />
            </Suspense>} />
            <Route path="/information/view-minutes-of-meeting" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ViewMoM />
            </Suspense>} />

            {/* 8) MIS Report */}

            <Route path="/reports/transaction-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TransactionReport />
            </Suspense>} />
            <Route path="/reports" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Reports />
            </Suspense>} />
            <Route path="/reports/capital-gain-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CapitalGainReport />
            </Suspense>} />
            <Route path="/reports/notional-capital-gain-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NotionalCapitalGainReport />
            </Suspense>} />
            <Route path="/reports/tax" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Tax />
            </Suspense>} />
            <Route path="/reports/paid-invoices" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PaidInvoicesReport />
            </Suspense>} />
            <Route path="/reports/tax-calculation-report/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxCalculationReport />
            </Suspense>} />
            <Route path="/reports/tax-calculation-old-regime-report/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxCalculationReportOldRegim />
            </Suspense>} />
            <Route path="/reports/holding-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HoldingReport />
            </Suspense>} />
            <Route path="/reports/invoices" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InvoicesReport />
            </Suspense>} />
            <Route path="/reports/cash-flow" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ReportExpectedCashFlow />
            </Suspense>} />


            <Route path="/report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanReport />
            </Suspense>} />

            <Route path="/reports/portfolio-valuation-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PortfolioValuationReport />
            </Suspense>} />

            <Route path="/reports/client-transaction-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientTransactionReport />
            </Suspense>} />

            <Route path="/reports/client-capital-gain-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientCapitalGainReport />
            </Suspense>} />



            {/* ADMIN */}

            {/* 1)  Accouting */}

            <Route path="/accouting/expense-voucher" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ExpenseVoucher />
            </Suspense>} />
            <Route path="/accouting/add-expense-vouchers" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddExpenseVouchers />
            </Suspense>} />
            <Route path="/accouting/edit-expense-vouchers/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddExpenseVouchers />
            </Suspense>} />
            <Route path="/accouting/export-to-excel" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ExportToExcel />
            </Suspense>} />
            <Route path="/accouting/upload-invoice-bill/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <UploadInvoiceBill />
            </Suspense>} />
            <Route path="/vendorsupplier/vendor-supplier" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <VendorSuppliers />
            </Suspense>} />
            <Route path="/vendorsupplier/add-vendor-supplier" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddVendorSupplier />
            </Suspense>} />
            <Route path="/vendorsupplier/edit-vendor-supplier/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddVendorSupplier />
            </Suspense>} />
            <Route path="/vendorsupplier/archived-vendor-supplier" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedVendorsSuppliers />
            </Suspense>} />
            <Route path="/accounting/description-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DescriptionMaster />
            </Suspense>} />
            <Route path="/accounting/add-description-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDescriptionMaster />
            </Suspense>} />
            <Route path="/accounting/edit-description-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDescriptionMaster />
            </Suspense>} />
            <Route path="/accounting/archived-description-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedDescriptionMaster />
            </Suspense>} />
            <Route path="/accounting/aua-calculation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AuaCalculation />
            </Suspense>} />
            <Route path="/accounting/client-address" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientInvoiceAddress />
            </Suspense>} />
            <Route path="/accounting/edit-client-address/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditClientInvoiceAddress />
            </Suspense>} />
            <Route path="/accounting/invoice" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Invoice />
            </Suspense>} />
            <Route path="/accounting/add-invoice" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInvoice />
            </Suspense>} />
            <Route path="/accounting/edit-invoice/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInvoice />
            </Suspense>} />
              <Route path="/accounting/fixed-recurring" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
                <FixedRecurring />
              </Suspense>} />
            <Route path="/accounting/add-fixed-recurring-invoice" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFixedRecurringInvoice />
            </Suspense>} />
            <Route path="/accounting/add-fixed-recurring-invoice/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFixedRecurringInvoice />
            </Suspense>} />
            <Route path="/accounting/archived-fixed-recurring-invoice" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedFixedRecurringInvoice />
            </Suspense>} />
            <Route path="/accounting/view-invoice" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ViewInvoice />
            </Suspense>} />
            <Route path="/accounting/export-income-to-excel" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ExportIncomeToExcel />
            </Suspense>} />
            {/* <Route path="/accounting/archived-invoice" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Cancelled />
            </Suspense>} /> */}
            {/* <Route path="/accounting/submitted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Submitted />
            </Suspense>} /> */}
            {/* <Route path="/accounting/paid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Paid />
            </Suspense>} /> */}
            {/* <Route path="/accounting/future" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Future />
            </Suspense>} /> */}
            <Route path="/accounting/company-bank-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CompnayBankAccount />
            </Suspense>} />
            <Route path="/accounting/add-company-bank-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCompanyBankAccount />
            </Suspense>} />
            <Route path="/accounting/edit-company-bank-account/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCompanyBankAccount />
            </Suspense>} />

            <Route path="/accounting/company-bank-account-passbook/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CompBankAccountPassbook />
            </Suspense>} />
            <Route path="/accounting/add-company-bank-account-passbook/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCompBankPassbookEntry />
            </Suspense>} />
            <Route path="/accounting/edit-company-bank-account-passbook/:id/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCompBankPassbookEntry />
            </Suspense>} />
            <Route path="/accounting/view-company-bank-account-passbook/:id/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCompBankPassbookEntry />
            </Suspense>} />
            <Route path="/accounting/import-bank-passbook" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ImportBankPassbookDetails />
            </Suspense>} />
            <Route path="/accounting/archived-company-bank-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedCompanyBankAccount />
            </Suspense>} />
            <Route path="/accouting/fee-mandates" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FeeMandates />
            </Suspense>} />
            <Route path="/accouting/add-fee-mandates" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFeeMandates />
            </Suspense>} />
            <Route path="/accouting/edit-fee-mandates/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFeeMandates />
            </Suspense>} />
            <Route path="/accouting/archived-fee-mandates" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedFeeMandates />
            </Suspense>} />

            <Route path="/advice-request/" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdviceRequest />
            </Suspense>} />
            <Route path="/add-advice-request/" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAdviceRequest />
            </Suspense>} />
            {/* <Route path="/admin/dashboard/" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdminDashboard />
            </Suspense>} /> */}
            <Route path="/accounting/payment-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PaymentDetails />
            </Suspense>} />
            <Route path="/add-payment-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPaymentDetails />
            </Suspense>} />
            <Route path="/edit-payment-details/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPaymentDetails />
            </Suspense>} />
            <Route path="/accounting/future-payment-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FuturePaymentDetails />
            </Suspense>} />
             <Route path="/accounting/archived-payment-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedPaymentDetails />
            </Suspense>} />

            {/* \) Masters */}

            <Route path="/clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Clients />
            </Suspense>} />
            <Route path="/admin/draft-clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DraftClients />
            </Suspense>} />
            <Route path='/clients/add-clients/personal-details' element={<Suspense fallback={<><Loader show={true} /></>}>
              <AddNewClient />
            </Suspense>} />
            <Route path='/clients/add-clients/personal-details/:id' element={<Suspense fallback={<><Loader show={true} /></>}>
              <AddNewClient />
            </Suspense>} />
            <Route path='/clients/add-clients/contract-details/:id' element={<Suspense fallback={<><Loader show={true} /></>}>
              <ContractDetails />
            </Suspense>} />
             <Route path='/clients/add-clients/payment-details/:id' element={<Suspense fallback={<><Loader show={true} /></>}>
              <ClientPaymentDetails />
            </Suspense>} />
            <Route path='/clients/add-clients/onboarding-checklist/:id' element={<Suspense fallback={<><Loader show={true} /></>}>
              <Onboarding />
            </Suspense>} />
            <Route path='/clients/pan-varification' element={<Suspense fallback={<><Loader show={true} /></>}>
              <PanVarification />
            </Suspense>} />
            <Route path='/clients/add-clients/Menu-Selection/:id' element={<Suspense fallback={<><Loader show={true} /></>}>
              <MenuSelection />
            </Suspense>} />
            <Route path='/clients/add-clients/cis-details/:id' element={<Suspense fallback={<><Loader show={true} /></>}>
              <ClientCisDetails />
            </Suspense>} />
            <Route path='/clients/add-clients/mail-group/:id' element={<Suspense fallback={<><Loader show={true} /></>}>
              <MailGroup />
            </Suspense>} />
            <Route path="/add-clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClients />
            </Suspense>} />
            <Route path="/edit-clients/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClients />
            </Suspense>} />
            <Route path="/archived-clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedClients />
            </Suspense>} />
            <Route path="/add-new-services/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddNewServices />
            </Suspense>} />
            <Route path="/edit-new-services/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddNewServices />
            </Suspense>} />
            <Route path="/advisor-goals" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdvisorGoals />
            </Suspense>} />
            <Route path="/slabs" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Slabs />
            </Suspense>} />
            <Route path="/archived-slabs" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedSlabs />
            </Suspense>} />
            <Route path="/add-slabs" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSlab />
            </Suspense>} />
            <Route path="/edit-slab/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSlab />
            </Suspense>} />
            <Route path="/master/announcements" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Announcements />
            </Suspense>} />
            <Route path="/master/archived-announcements" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedAnnouncements />
            </Suspense>} />
            <Route path="/master/add-announcements" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAnnouncements />
            </Suspense>} />
            <Route path="/master/edit-announcements/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAnnouncements />
            </Suspense>} />
            <Route path="/master/planning-assumption" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Assumptions />
            </Suspense>} />
            <Route path="/master/planning-edit-assumption/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditAssumption />
            </Suspense>} />
            <Route path="/master/planning-model-portfolio" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ModelPortfolios />
            </Suspense>} />
            <Route path="/master/planning-add-model-portfolio" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddModelPortfolios />
            </Suspense>} />
            <Route path="/master/planning-edit-model-portfolio/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddModelPortfolios />
            </Suspense>} />
            <Route path="/master/planning-view-edit-model-portfolio/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddModelPortfolios />
            </Suspense>} />
            <Route path="/master/planning-view-model-portfolio/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ViewModelPortfolios />
            </Suspense>} />
            <Route path="/master/planning-comments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Comments />
            </Suspense>} />
            <Route path="/master/planning-add-comments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddComments />
            </Suspense>} />
            <Route path="/master/planning-edit-comments/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddComments />
            </Suspense>} />
            <Route path="/master/planning-archived-comments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedComments />
            </Suspense>} />
            <Route path="/master/planning-disclaimer-discloser" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DisclaimerAndDiscloser />
            </Suspense>} />
            <Route path="/master/planning-edit-disclaimer-discloser/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditDisclaimerAndDiscloser />
            </Suspense>} />
            <Route path="/master/planning-mailing-group" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MalingGroups />
            </Suspense>} />
            <Route path="/master/archived-planning-mailing-group" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMailingGroup />
            </Suspense>} />
            <Route path="/master/planning-add-mailing-group" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMailingGroup />
            </Suspense>} />
            <Route path="/master/planning-edit-mailing-group/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMailingGroup />
            </Suspense>} />
            <Route path="/master/planning-group-user-of/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GroupsUserOf />
            </Suspense>} />
            <Route path="/master/planning-send-mail-to-group/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SendMailtoGroup />
            </Suspense>} />
            <Route path="/master/planning-add-group-user-of/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGroupUser />
            </Suspense>} />
            <Route path="/master/global-parameter" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GlobalParameter />
            </Suspense>} />
            <Route path="/master/edit-global-parameter/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditGlobalParameter />
            </Suspense>} />
            <Route path="/master/archived-global-parameter" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedModelPortfolios />
            </Suspense>} />
            <Route path="/master/edit-global-parameter-fee-structure/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditGlobalParameterFeeStructure />
            </Suspense>} />
            <Route path="/master/master-company-master" element={<Suspense fallback={<MasterCompanyMasterSkeleton />}  >
              <MasterCompanyMaster />
            </Suspense>} />
            <Route path="/master/master-business-accreditation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BusinessAccreditation />
            </Suspense>} />
            <Route path="/master/master-archived-business-accreditation" element={<Suspense fallback={<ArchivedBusinessAccreditationSkeleton />}  >
              <ArchivedBusinessAccreditation />
            </Suspense>} />
            <Route path="/master/masters-add-business-accreditation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBusinessAccreditation />
            </Suspense>} />
            <Route path="/master/masters-edit-business-accreditation/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBusinessAccreditation />
            </Suspense>} />
            <Route path="/master/company-bank-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CompanyBankAccounts />
            </Suspense>} />
            <Route path="/master/edit-company-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditCompanyDetails />
            </Suspense>} />
            <Route path="/master/branches" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Branches />
            </Suspense>} />
            <Route path="/master/add-branches" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBranches />
            </Suspense>} />
            <Route path="/master/edit-branches/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBranches />
            </Suspense>} />
            <Route path="/master/archived-branches" element={<Suspense fallback={<ArchivedBranchesSkeleton />}  >
              <ArchivedBranches />
            </Suspense>} />
            <Route path="/master/planning-sign-off-details" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CompanySignOffDetails />
            </Suspense>} />
            <Route path="/master/planning-edit-sign-off-details/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditCompanySignOffDetails />
            </Suspense>} />
            <Route path="/master/insurance-product-recommendation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceProductRecommendations />
            </Suspense>} />
            <Route path="/master/mail-template" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MailTemplates />
            </Suspense>} />
            <Route path="/master/create-new-template" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CreateNewTemplate />
            </Suspense>} />
            <Route path="/master/edit-new-template/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CreateNewTemplate />
            </Suspense>} />
            <Route path="/master/view-new-template/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CreateNewTemplate />
            </Suspense>} />
            <Route path="/master/create-signature-template" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CreateSignature />
            </Suspense>} />
            <Route path="/master/archived-mail-template" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMailTemplates />
            </Suspense>} />
            <Route path="/master/copy-record-from-master-template" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CopyRecordFromMasterTemplate />
            </Suspense>} />
            <Route path="/master/recommendation-investment-product" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InvestmentProduct />
            </Suspense>} />
            <Route path="/master/add-recommendation-investment-product" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInvestmentProduct />
            </Suspense>} />
            <Route path="/master/edit-recommendation-investment-product/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInvestmentProduct />
            </Suspense>} />
            <Route path="/master/view-edit-recommendation-investment-product/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInvestmentProduct />
            </Suspense>} />
            <Route path="/master/archived-recommendation-investment-product" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInvestmentProduct />
            </Suspense>} />
            <Route path="/master/desired-asset-allocation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DesiredAssetAllocation />
            </Suspense>} />
            <Route path="/master/archeived-desired-asset-allocation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArcheivedDesiredAssetAllocation />
            </Suspense>} />
            <Route path="/master/add-desired-asset-allocation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDesiredAssetAllocation />
            </Suspense>} />
            <Route path="/master/Client-Menu-Selection" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientMenuSelection />
            </Suspense>} />
            <Route path="/master/add-Client-Menu-Selection" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientMenuSelection />
            </Suspense>} />
            <Route path="/master/edit-Client-Menu-Selection/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientMenuSelection />
            </Suspense>} />
            <Route path="/master/Client-Menu-Packages" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientMenuPackage />
            </Suspense>} />
            <Route path="/master/add-Client-Menu-Package" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientMenuPackage />
            </Suspense>} />
            <Route path="/master/edit-Client-Menu-Package/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientMenuPackage />
            </Suspense>} />
             <Route path="/client-selection-by-menu" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientSelectionByMenu />
            </Suspense>} />
            <Route path="/master/add-Client-selection-by-Menu" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientSelectionByMenu />
            </Suspense>} />
             <Route path="/master/edit-Client-selection-by-Menu/:id/:role_allowed/:type/:name" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientSelectionByMenu />
            </Suspense>} />

            {/* HR */}

            <Route path="/admin/employees" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Employees />
            </Suspense>} />
            <Route path="/admin/add-employees" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEmployee />
            </Suspense>} />
            <Route path="/admin/add-employees/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEmployee />
            </Suspense>} />
            <Route path="/admin/onboard-employees/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EmployeeOnboarding />
            </Suspense>} />
            <Route path="/admin/employee-menu/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EmployeeMenu />
            </Suspense>} />
            <Route path="/Employee-menu-selection" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EmployeeMenuSelection />
            </Suspense>} />
            <Route path="/add-employee-menu-selection" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEmployeeMenuSelection />
            </Suspense>} />
            <Route path="/edit-employee-menu-selection/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEmployeeMenuSelection />
            </Suspense>} />
            <Route path="/employee-selection-by-menu" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EmployeeSelectionByMenu />
            </Suspense>} />
            <Route path="/master/add-employee-selection-by-Menu" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEmployeeSelectionByMenu />
            </Suspense>} />
            <Route path='/master/edit-employee-selection-by-Menu/:id/:role_allowed/:type/:name' element={<Suspense fallback={<> <Loader show={true}/></>} >
            <AddEmployeeSelectionByMenu/>
            </Suspense>}/>
            <Route path="/admin/edit-employees/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditEmployee />
            </Suspense>} />
            <Route path="/admin/archived-employees" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEmployees />
            </Suspense>} />
            <Route path="/admin/category-master-employees" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CategoryMasterEmployees />
            </Suspense>} />
            <Route path="/admin/archived-category-master-employees" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedCategoryMasterEmployees />
            </Suspense>} />
            <Route path="/admin/draft-employees" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DraftEmployees />
            </Suspense>} />
            <Route path="/admin/employee-entry" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EmployeesEntry />
            </Suspense>} />
            <Route path="/admin/edit-employee-entry/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditEmployeeEntry />
            </Suspense>} />
            <Route path="/archivedEmployeeEntry" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEmployeeEntry />
            </Suspense>} />
            <Route path="/admin/employee-exit" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EmployeesExit />
            </Suspense>} />
            <Route path="/admin/edit-employee-exit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditEmployeeExit />
            </Suspense>} />
            <Route path="/archivedEmployeeExit" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEmployeeExit />
            </Suspense>} />
            <Route path="/admin/leave-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LeaveType />
            </Suspense>} />
            <Route path="/admin/add-leave-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddLeaveType />
            </Suspense>} />
            <Route path="/admin/edit-leave-type/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddLeaveType />
            </Suspense>} />

            {/* HR module (Phase 1) — leave configuration, restricted to HR roles.
                Existing HR routes are deliberately left unguarded so current
                users do not lose access; only new screens are gated. */}
            <Route path="/hr/weekly-off" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <WeeklyOff />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/hr/leave-approvers" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <LeaveApprovers />
                </Suspense>
              </RequireRole>
            } />

            {/* Employee self-service. NOT role-gated: every employee applies for
                their own leave, and the API scopes each request to the caller's
                own user_profile_id from the JWT. */}
            <Route path="/ess/apply-leave" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ApplyLeave />
            </Suspense>} />
            <Route path="/ess/my-leaves" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <MyLeaves />
            </Suspense>} />
            <Route path="/ess/my-leave-balance" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <MyLeaveBalance />
            </Suspense>} />

            {/* Approval queue. Also NOT role-gated — any employee may be somebody's
                manager without holding an HR role, and GetApprovalQueue returns an
                empty list to anyone with no team. */}
            <Route path="/hr/leave-approvals" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <LeaveApprovals />
            </Suspense>} />

            {/* Same component, HR framing: GetApprovalQueue already returns the
                whole company to an HR user and only their team to a manager. */}
            <Route path="/hr/leave-applications" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <LeaveApprovals
                    title="Leave Requests"
                    subtitle="Every leave request across the company."
                  />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/hr/leave-balances" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <LeaveBalances />
                </Suspense>
              </RequireRole>
            } />

            {/* HR module (Phase 2).
                Comp-off, the calendar and delegation are NOT role-gated: every
                employee claims their own comp-off, sees their team's calendar,
                and may delegate approvals they hold. Each API scopes by caller. */}
            <Route path="/ess/comp-off" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <CompOff />
            </Suspense>} />
            <Route path="/hr/comp-off-requests" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <CompOff />
            </Suspense>} />
            <Route path="/hr/leave-calendar" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <LeaveCalendar />
            </Suspense>} />
            <Route path="/hr/leave-delegation" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <LeaveDelegation />
            </Suspense>} />

            {/* Bulk credit and reports are HR-only. */}
            <Route path="/hr/leave-credit" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <LeaveCredit />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/hr/leave-reports" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <LeaveReports />
                </Suspense>
              </RequireRole>
            } />

            {/* HR module (Phase 3) — salary masters. Salary data is the most
                sensitive thing in the module, so every one of these routes is
                role-gated, unlike the leave ESS routes. */}
            <Route path="/hr/salary-components" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <SalaryComponents />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/hr/salary-component/add" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <AddSalaryComponent />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/hr/salary-component/edit/:id" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <AddSalaryComponent />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/hr/salary-structures" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <SalaryStructures />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/hr/employee-salary" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <EmployeeSalary />
                </Suspense>
              </RequireRole>
            } />
            {/* The checker queue is gated on the APPROVER roles, not the HR
                roles: an HR maker must not reach the screen that approves
                their own work. The API applies the same list. */}
            <Route path="/hr/salary-approvals" element={
              <RequireRole roles={HR_APPROVER_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <SalaryApprovals />
                </Suspense>
              </RequireRole>
            } />

            {/* HR module (Phase 4) — payroll. The runs and workspace are HR
                (maker); the API separately blocks a maker from approving or
                locking their own run. The approvals screen is approver-gated.
                The ESS payslip/salary routes are open to any authenticated
                employee and scoped server-side to their own data. */}
            <Route path="/hr/payroll-runs" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <PayrollRuns />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/hr/payroll-run/:id" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <PayrollRunWorkspace />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/hr/payroll-approvals" element={
              <RequireRole roles={HR_APPROVER_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <PayrollApprovals />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/ess/my-payslips" element={
              <Suspense fallback={<> <Loader show={true} /> </>}>
                <MyPayslips />
              </Suspense>
            } />
            <Route path="/ess/my-salary-structure" element={
              <Suspense fallback={<> <Loader show={true} /> </>}>
                <MySalaryStructure />
              </Suspense>
            } />

            {/* HR module (Phase 5) — statutory setup and payroll outputs. */}
            <Route path="/hr/statutory-setup" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <StatutorySetup />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/hr/payroll-reports" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <PayrollReports />
                </Suspense>
              </RequireRole>
            } />

            {/* HR module (Phase 6) — investment declaration & proofs. Config and
                verification are HR-only; the declaration and proofs are ESS,
                scoped server-side to the logged-in employee. */}
            <Route path="/hr/declaration-config" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <DeclarationConfig />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/hr/proof-verification" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <ProofVerification />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/ess/my-declaration" element={
              <Suspense fallback={<> <Loader show={true} /> </>}>
                <MyDeclaration />
              </Suspense>
            } />
            <Route path="/ess/my-proofs" element={
              <Suspense fallback={<> <Loader show={true} /> </>}>
                <MyProofs />
              </Suspense>
            } />

            {/* HR module (Phase 7) — Form 16. HR generates; the ESS route is
                open to any employee and scoped to their own certificates. */}
            <Route path="/hr/form16" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <Form16 />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/ess/my-form16" element={
              <Suspense fallback={<> <Loader show={true} /> </>}>
                <MyForm16 />
              </Suspense>
            } />

            {/* HR module (Phase 8) — reimbursements. HR approves; the ESS route
                is open to any employee and scoped to their own claims. */}
            <Route path="/hr/reimbursements" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <Reimbursements />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/ess/my-reimbursements" element={
              <Suspense fallback={<> <Loader show={true} /> </>}>
                <MyReimbursements />
              </Suspense>
            } />

            {/* HR module (Phase 8) — staff loans. HR runs the loan master and
                the approve/disburse/prepay workspace; the ESS route is open. */}
            <Route path="/hr/loan-types" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <HrLoanTypes />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/hr/loans" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <HrLoans />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/hr/loan-schedule/:id" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <LoanSchedule />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/ess/my-loans" element={
              <Suspense fallback={<> <Loader show={true} /> </>}>
                <MyLoans />
              </Suspense>
            } />
            <Route path="/hr/arrears" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <Arrears />
                </Suspense>
              </RequireRole>
            } />
            <Route path="/hr/fnf/:runId/:upid" element={
              <RequireRole roles={HR_ROLES}>
                <Suspense fallback={<> <Loader show={true} /> </>}>
                  <FnfSettlement />
                </Suspense>
              </RequireRole>
            } />

            <Route path="/admin/holiday-calender" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HolidayCalender />
            </Suspense>} />
            <Route path="/add-holiday" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHoliday />
            </Suspense>} />
            <Route path="/edit-holiday/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHoliday />
            </Suspense>} />
            {/* HR module (Phase 1) — re-enabled. This was commented out because the
                screen returned nothing: its endpoint filtered company_branch_id (an
                integer FK) against the literal string 'Pune' for every employee. The
                screen now calls GetPublishedCalendar, which resolves the caller's own
                branch. Deliberately NOT wrapped in RequireRole — every employee may
                see their own holiday calendar. */}
            <Route path="/admin/holiday-calender-emplyoee" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HolidayCalenderForEmplyoee />
            </Suspense>} />
            <Route path="/admin/client-birthday" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientBirthday />
            </Suspense>} />

            {/* Aua  Selection */}

            <Route path="/admin/aua-selection" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AuaSelection />
            </Suspense>} />
            <Route path="/admin/edit-aua-selection/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditAuaSelection />
            </Suspense>} />
            <Route path="/admin/business-analytics" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BusinessAnalytics />
            </Suspense>} />

            {/* Research */}
            <Route path="/research/top-performers" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TopPerformers />
            </Suspense>} />
            <Route path="/research/scheme-comparison" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemeComparison />
            </Suspense>} />
            <Route path="/research/scheme-factsheet/:schemecode" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemeFactsheet />
            </Suspense>} />
            <Route path="/research/analyst-estimates" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AnalystEstimates />
            </Suspense>} />
            <Route path="/research/analyst-estimates/upload" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AnalystEstimatesUpload />
            </Suspense>} />
            <Route path="/research/analyst-estimates/help" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AnalystEstimatesHelp />
            </Suspense>} />
            <Route path="/research/growth-outlook" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GrowthOutlook />
            </Suspense>} />
            <Route path="/research/growth-outlook/help" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GrowthOutlookHelp />
            </Suspense>} />
            <Route path="/research/singleclick-rating" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SingleClickRatingMaster />
            </Suspense>} />
            <Route path="/research/singleclick-rating/peers" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SingleClickRating />
            </Suspense>} />
            <Route path="/research/singleclick-rating/help" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SingleClickRatingHelp />
            </Suspense>} />
            <Route path="/research/schemes-closed-subscription" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemesClosedSubscription />
            </Suspense>} />
            <Route path="/research/schemes-closed-subscription/help" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemesClosedSubscriptionHelp />
            </Suspense>} />
            <Route path="/research/open-nfos" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OpenNfos />
            </Suspense>} />
            <Route path="/research/open-nfos/help" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OpenNfosHelp />
            </Suspense>} />
            <Route path="/research/scheme-flag-radar" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemeFlagRadar />
            </Suspense>} />
            <Route path="/research/scheme-flag-radar/help" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemeFlagRadarHelp />
            </Suspense>} />
            <Route path="/research/scheme-change-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemeChangeReport />
            </Suspense>} />
            <Route path="/research/scheme-change-report/help" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemeChangeReportHelp />
            </Suspense>} />
            <Route path="/research/fund-manager-activity" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FundManagerActivity />
            </Suspense>} />
            <Route path="/research/fund-manager-activity/help" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FundManagerActivityHelp />
            </Suspense>} />
            <Route path="/portfolio-assessment" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PortfolioAssessment />
            </Suspense>} />
            <Route path="/portfolio-assessment/report/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PortfolioAssessmentReport />
            </Suspense>} />
            <Route path="/portfolio-assessment/help" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PortfolioAssessmentHelp />
            </Suspense>} />
            <Route path="/portfolio-analysis" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PortfolioAnalysis />
            </Suspense>} />
            <Route path="/portfolio-analysis/help" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PortfolioAnalysisHelp />
            </Suspense>} />

            {/* Mis Report */}
            <Route path="/mis-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MisReport />
            </Suspense>} />
            <Route path="/mis-report/client-investor-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientInvestorReport />
            </Suspense>} />
            <Route path="/mis-report/regular-vs-direct" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RegularVsDirect />
            </Suspense>} />
            <Route path="/admin/80C-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EightyCReport />
            </Suspense>} />
            <Route path="/admin/mutual-fund-rta-codes" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundRtaCodes />
            </Suspense>} />
            <Route path="/admin/archived-mutual-fund-rta-codes" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMutualFundRtaCodes />
            </Suspense>} />
            <Route path="/admin/mf-holding-scheme-wise" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MFHoldingsSchemeWise />
            </Suspense>} />
            <Route path="/admin/share-holding-company-wise" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesHoldingCompanyWise />
            </Suspense>} />
            <Route path="/admin/share-holding-client-wise" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareHoldingClientWise />
            </Suspense>} />
            <Route path="/admin/archived-subscribed-services" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedSubscribedServices />
            </Suspense>} />
            <Route path="/admin/insurance-renewals" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceRenewal />
            </Suspense>} />
            <Route path="/admin/maturity-investments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MaturityInvestments />
            </Suspense>} />
            <Route path="/admin/investment-Account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InvestmentAccount />
            </Suspense>} />
            <Route path="/admin/share-isin" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareIsin />
            </Suspense>} />
            <Route path="/admin/risk-profile" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RiskProfileMisReport />
            </Suspense>} />
            <Route path="/admin/systematic-plans-all-clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SystematicsPlansAllClients />
            </Suspense>} />
            <Route path="/admin/mf-transaction-all-clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionReportAllClient />
            </Suspense>} />
            <Route path="/admin/share-transaction-all-clients" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionReportAllClient />
            </Suspense>} />
            <Route path="/admin/systematic-investment" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SystematicInvestments />
            </Suspense>} />
            <Route path="/admin/advice-log-book" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdviceLogBook />
            </Suspense>} />
            <Route path="/admin/advice-log-book-manual" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdviceLogBookManual />
            </Suspense>} /> 
            <Route path="/admin/advice-log-book/Archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdviceLogBookArchived />
            </Suspense>} />
            <Route path="/admin/advice-log-book-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdviceLogBookAdd />
            </Suspense>} />
            <Route path="/admin/advice-log-book-add/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdviceLogBookAdd />
            </Suspense>} />
            <Route path="/admin/advice-log-book-import" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdviceLogBookBulkImport/>
            </Suspense>} />
            <Route path="/admin/advice-transaction/:id/:advice_id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdviceTransaction />
            </Suspense>} />
            <Route path="/admin/action-plan-log" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ActionPlanLog />
            </Suspense>} />
            <Route path="/admin/mf-holding-client-wise" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfHoldingClientWise />
            </Suspense>} />
            <Route path="/admin/action-client's-tasks" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientActionTask />
            </Suspense>} />
            <Route path="/admin/admin-holding-report-client-wise" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdminHoldingReport />
            </Suspense>} />
            {/* <Route path="/admin-aua-report-client-wise" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AuAReport />
            </Suspense>} /> */}
            <Route path="/admin-aua-report-client-wise" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AuAReportGrid />
            </Suspense>} />
             <Route path="/admin-aua-report-complaints" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AuAReportComplaints />
            </Suspense>} />
            <Route path="/admin/mis-report/agreement" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Agreement />
            </Suspense>} />
            <Route path="/admin/mis-report/add-agreement" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAgreement />
            </Suspense>} />
            <Route path="/admin/mis-report/create-agreement/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAgreement />
            </Suspense>} />
            <Route path="/admin/mis-report/edit-agreement/:id/:p_id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAgreement />
            </Suspense>} />
            <Route path="/admin/mis-report/renew-agreement/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAgreement />
            </Suspense>} />
            <Route path="/admin/mis-report/archived-agreement" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedAgreement />
            </Suspense>} />
            <Route path="/admin/mis-report/upload-agreement/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AgreementUploadDocument />
            </Suspense>} />
            <Route path="/admin/fee-mandates" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MisFeeMandates />
            </Suspense>} />
            <Route path="/admin/returns" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Returns/>
            </Suspense>} />
            <Route path="/admin/bulk-import-ids" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BulkData/>
            </Suspense>} />
            <Route path="/admin/portfolio-valuation-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PortfolioValuationReport/>
            </Suspense>} />
            <Route path="/admin/send-bulk-reports-by-email" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SendBulkReportByEmail />
            </Suspense>} />
            <Route path="/admin/brokerage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdminBrokerage/>
            </Suspense>} />
            <Route path="/admin/brokerage-manage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Brokerage/>
            </Suspense>} />
            <Route path="/admin/brokerage/add-brokerage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBrokerage/>
            </Suspense>} />
            <Route path="/admin/brokerage/reconciliation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BrokerageReconciliationReport/>
            </Suspense>} />
            <Route path="/admin/brokerage/brokerage-history" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BrokerageHistoryReport/>
            </Suspense>} />
            <Route path="/admin/nav-history" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NavHistory/>
            </Suspense>} />
            <Route path="/admin/long-term-redemption" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LongTermRedemptionAvailable/>
            </Suspense>} />
            <Route path="/cashflow/with-return-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CashflowWithReturns/>
            </Suspense>} />

            <Route path="/admin/brokerage-summary" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BrokerageSummaryReport/>
            </Suspense>} />
            <Route path="/admin/monthly-brokerage-summary" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MonthlyBrokerageReport/>
            </Suspense>} />
            {/*Added on 04-Feb-2026 By Shubhangi.*/}
            <Route path="/operation-header" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Operations />
            </Suspense>} />
            {/* {Operations} */}

            <Route path="/admin/operation/unit-reconciliation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfUnitsReconciliation />
            </Suspense>} />
            <Route path="/admin/operation/unit-reconciliation-unmatched" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfUnitsReconciliationUnmatch />
            </Suspense>} />
            <Route path="/admin/operation/unit-reconciliation-in-system" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfUnitsReconciliationInSystem />
            </Suspense>} />
            <Route path="/admin/operation/unit-reconciliation-not-rta" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfUnitsReconciliationNotRta />
            </Suspense>} />
            <Route path="/admin/operation/import-unit-reconciliation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ImportUnitReconciliation />
            </Suspense>} />
            <Route path="/operations/fixed/income/transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedIncomeTransactions />
            </Suspense>} />
            <Route path="/operations/files_upload" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FilesUpload />
            </Suspense>} />
            <Route path="/operations/contract-notes" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ContractNoteReader />
            </Suspense>} />
            <Route path="/operations/share/transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactions />
            </Suspense>} />
            <Route path="/operations/share/systematic/transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareSystematicTransactions />
            </Suspense>} />
            <Route path="/operations/share/archived-transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionsArchived />
            </Suspense>} />
            <Route path="/operations/share/transaction/future" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionsFuture />
            </Suspense>} />
            <Route path="/operations/share/transaction/platform" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionsPlatform />
            </Suspense>} />
            <Route path="/operations/share/transaction/archived-sips" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedSips />
            </Suspense>} />
            <Route path="/operations/share/transaction/inProcess" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionInProcess />
            </Suspense>} />
            <Route path="/operations/share/transaction/transactions" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionTransactions />
            </Suspense>} />
            <Route path="/operations/share/transaction/error" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionError />
            </Suspense>} />
            <Route path="/operations/share/transaction/ready" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionsReady />
            </Suspense>} />
            <Route path="/operations/share/transaction/platform/import" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionsImport />
            </Suspense>} />
            <Route path="/operations/mf/transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactions />
            </Suspense>} />
            <Route path="/operations/mf/transaction/platform" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsPlatform />
            </Suspense>} />
            <Route path="/operations/mf/transaction/future" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsFuture />
            </Suspense>} />
            <Route path="/operations/mf/transaction/transactions" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsTransactions />
            </Suspense>} />
            <Route path="/operations/mf/transaction/error" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsError />
            </Suspense>} />
            <Route path="/operations/mf/transaction/ready" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsReady />
            </Suspense>} />
            <Route path="/operations/mf/transaction/archive" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsArchive />
            </Suspense>} />
            <Route path="/operations/mf/transaction/archived-mf-transactions" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsArchived />
            </Suspense>} />
            <Route path="/operation/mf/import-transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionImport />
            </Suspense>} />
            <Route path="/operations/mf/systematic/transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicTransactions />
            </Suspense>} />
            <Route path="/operations/mf/systematic/archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicArchived />
            </Suspense>} />
            <Route path="/operations/mf/systematic/error" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicError />
            </Suspense>} />
            <Route path="/operations/mf/systematic/ready" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicReady />
            </Suspense>} />
            <Route path="/operations/mf/systematic/transactiontab" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicTransactiontab />
            </Suspense>} />
            <Route path="/operations/mf/systematic/future" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicFuture />
            </Suspense>} />
            <Route path="/operations/mf/systematic/platform" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicPlatform />
            </Suspense>} />
            <Route path="/operation/mf-systematic/import-transaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicPlatformImport />
            </Suspense>} />
            <Route path="/operations/mf/systematic/paused" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicPaused />
            </Suspense>} />
            <Route path="/operations/mf/systematic/import" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSystematicImport />
            </Suspense>} />
            <Route path="/operations/mf-systematic/archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfSysArchived />
            </Suspense>} />

            <Route path="/operations/client/information" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CisDetails />
            </Suspense>} />
            <Route path="/operations/archeived-client/information" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArcheivedCisDetails />
            </Suspense>} />
            <Route path="/operations/edit-client/information/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditCisDetails />
            </Suspense>} />
            <Route path="/operations/client/entry" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientEntry />
            </Suspense>} />
            <Route path="/archivedClientsEntry" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedClientsEntry />
            </Suspense>} />
            <Route path="/operations/client/exit" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientExit />
            </Suspense>} />
            <Route path="/archivedClientClearance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedClientExit />
            </Suspense>} />
            <Route path="/admin/edit-client-exit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditClientExit />
            </Suspense>} />
            <Route path="/admin/edit-client-entry/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditClientEntry />
            </Suspense>} />
            <Route path="/operations/account-opening-mfplatform" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfuPlatform />
            </Suspense>} />
            <Route path="/operations/archived-mfu-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfuPlatformArchived />
            </Suspense>} />
            <Route path="/operations/completed-mfu-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfuPlatformCompleted />
            </Suspense>} />
            <Route path="/operations/add-client-account" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientAccount />
            </Suspense>} />
            <Route path="/operations/account-opening-mandates" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Mandates />
            </Suspense>} />
            <Route path="/mandates/add-account-mandate" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMandates />
            </Suspense>} />
            <Route path="/mandates/edit-account-mandate/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMandates />
            </Suspense>} />
            <Route path="/mandates/archived-account-mandate" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMandates />
            </Suspense>} />

            {/* bulk import Master Sheet*/}
            <Route path="/bulk-import-master" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <MasterSheetTabs/>
            </Suspense>} />
            <Route path="/bulk-import-master-upload" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <MasterFileUpload/>
            </Suspense>} />

            {/* bulk import Clients*/}
            <Route path="/bulk-import" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BulkImport />
            </Suspense>} />
            <Route path="/bulk-import-clients" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportClients/>
            </Suspense>} />
            <Route path="/bulk-import-clients-processed" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportClientsProcessed/>
            </Suspense>} />
            <Route path="/bulk-import-clients-error" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportClientsError/>
            </Suspense>} />
            <Route path="/bulk-import-clients-menu/:type" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportClientsMenu/>
            </Suspense>} />
            <Route path="/bulk-import-file-upload/:cardName" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportFileUpload/>
            </Suspense>} />
            <Route path="/bulk-import-edit-client/:id/:tabName" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportEditClient/>
            </Suspense>} />

            {/* bulk import Investors*/}
            <Route path="/bulk-import-processed" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportProcessed/>
            </Suspense>} />
            <Route path="/bulk-import-investors" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportInvestors/>
            </Suspense>} />
            <Route path="/bulk-import-investors-error" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportInvestorsError/>
            </Suspense>} />
            <Route path="/bulk-import-edit-investor/:id/:tabName" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportEditInvestor/>
            </Suspense>} />

            {/* bulk import Rm change */}
            <Route path="/bulk-import-changerm" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <ChangeRm/>
            </Suspense>} />


            {/* bulk import mfu can*/}
            <Route path="/bulk-import-mfu-can" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportMfuCan/>
            </Suspense>} />
            <Route path="/edit-mfu-buffer/:id" element={<Suspense fallback={<> <Loader show={true}/> </>} >
              <EditMfuCan/>
            </Suspense>} />

            {/* bulk import mfu mandate */}
              <Route path="/bulk-import-mfu-mandates" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportMfuMandates/>
            </Suspense>} />
            <Route path="/edit-mfu-mandate-buffer/:id" element={<Suspense fallback={<> <Loader show={true}/> </>} >
              <EditMfuMandate/>
            </Suspense>} />


            {/* bulk import Banks*/}
            <Route path="/bulk-import-bank-accounts" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportBanks/>
            </Suspense>} />
            <Route path="/bulk-import-bank-error" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportBanksError/>
            </Suspense>} />
            <Route path="/bulk-import-edit-bank/:id/:tabName" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkImportEditBank/>
             </Suspense>} />

            {/* bulk Client Mapping*/}
            <Route path="/bulk-client-mapping" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <BulkClientMapping/>
            </Suspense>} />
            <Route path="/bulk-client-partially-mapping" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <PartiallyClientMapping/>
            </Suspense>} />
            <Route path="/bulk-client-fully-mapping" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <FullyClientMapping/>
            </Suspense>} />
            <Route path="/bulk-client-rm_1-mapping" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <ClientMappingRM1/>
            </Suspense>} />
            <Route path="/bulk-client-rm_2-mapping" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <ClientMappingRM2/>
            </Suspense>} />
            <Route path="/bulk-client-sb_1-mapping" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <ClientMappingSB1/>
            </Suspense>} />
            <Route path="/bulk-client-sb_2-mapping" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <ClientMappingSB2/>
            </Suspense>} />
            <Route path="/bulk-sb-category-mapping" element={<Suspense fallback={<> <Loader show={true}/> </>} >
            <SbCategoryMapping/>
            </Suspense>} />

            {/* Super Admin */}

            {/* Product Master */}

            <Route path="/information/product-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProductCategories />
            </Suspense>} />
            <Route path="/information/archived-product-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedProductCategories />
            </Suspense>} />
            <Route path="/information/add-product-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddProductCategories />
            </Suspense>} />
            <Route path="/information/edit-product-categories/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddProductCategories />
            </Suspense>} />
            <Route path="/information/edit-product-categories/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddProductCategories />
            </Suspense>} />
            <Route path="/product-master/client-portfolio" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientPortfolio />
            </Suspense>} />
            <Route path="/product-master/add-client-portfolio" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientPortfolio />
            </Suspense>} />
            <Route path="/product-master/edit-client-portfolio/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientPortfolio />
            </Suspense>} />
            <Route path="/product-master/archived-client-portfolio" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedClientPortfolio />
            </Suspense>} />

            {/* Mis Report */}
            <Route path="/mis-report/Advisor-aua" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdvisorsAua />
            </Suspense>} />
            <Route path="/mis-report/signzy-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SignzyReport />
            </Suspense>} />
            <Route path="/mis-report/shares" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MisShares />
            </Suspense>} />
            <Route path="/mis-report/mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MisMutualFunds />
            </Suspense>} />
            <Route path="/mis-report/agreement-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AgreementReport />
            </Suspense>} />


            {/* Help */}

            <Route path="/sa-help-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HelpMaster />
            </Suspense>} />
            {/* <Route path="/sa-client-help-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientHelpMaster />
            </Suspense>} /> */}
            <Route path="/information/add-client-help" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientHelpMaster />
            </Suspense>} />
            <Route path="/information/edit-client-help/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientHelpMaster />
            </Suspense>} />
            <Route path="/information/archived-client-help" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedClientHelpMaster />
            </Suspense>} />
            <Route path="/sa-admin-help-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdminHelpMaster />
            </Suspense>} />
            <Route path="/information/add-admin-help" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdminHelpMasterAdd />
            </Suspense>} />
            <Route path="/information/edit-admin-help/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AdminHelpMasterAdd />
            </Suspense>} />
            <Route path="/information/archived-admin-help" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedAdminHelpMaster />
            </Suspense>} />
            <Route path="/sa-financial-planning-help-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningHelpMaster />
            </Suspense>} />
            <Route path="/help-window" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HelpWindow />
            </Suspense>} />


            {/* Document Master */}

            <Route path="/sa-upload-documents-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DocumentMaster />
            </Suspense>} />
            <Route path="/add-upload-documents-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDocumentMaster />
            </Suspense>} />
            <Route path="/actions/edit-document-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddDocumentMaster />
            </Suspense>} />
            <Route path="/archived-documents-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedDocumentsMaster />
            </Suspense>} />


            {/* Insurance */}

            <Route path="/insurance/types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceTypes />
            </Suspense>} />
            <Route path="/insurance/add-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceTypes />
            </Suspense>} />
            <Route path="/insurance/edit-types/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceTypes />
            </Suspense>} />
            <Route path="/insurance/archived-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInsuranceTypes />
            </Suspense>} />
            <Route path="/insurance/subTypes" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceSubTypes />
            </Suspense>} />
            <Route path="/insurance/add-subTypes" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceSubTypes />
            </Suspense>} />
            <Route path="/insurance/edit-subTypes/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceSubTypes />
            </Suspense>} />
            <Route path="/insurance/archived-subTypes" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInsuranceSubTypes />
            </Suspense>} />
            <Route path="/insurance/benifits-available" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BenefitsAvailable />
            </Suspense>} />
            <Route path="/insurance/add-benifits-available" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBenifitsAvailable />
            </Suspense>} />
            <Route path="/insurance/edit-benifits-available/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBenifitsAvailable />
            </Suspense>} />
            <Route path="/insurance/archived-benifits-available" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedBenefitsAvailable />
            </Suspense>} />
            <Route path="/insurance/natureof-policy" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NatureOfPolicy />
            </Suspense>} />
            <Route path="/insurance/add-natureof-policy" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddNatureOfPolicy />
            </Suspense>} />
            <Route path="/insurance/edit-natureof-policy/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddNatureOfPolicy />
            </Suspense>} />
            <Route path="/insurance/archived-natureof-policy" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedNatureOfPolicy />
            </Suspense>} />
            <Route path="/insurance/riders" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Riders />
            </Suspense>} />
            <Route path="/insurance/add-insurance-riders" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceRiders />
            </Suspense>} />
            <Route path="/insurance/edit-insurance-riders/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceRiders />
            </Suspense>} />
            <Route path="/insurance/archived-insurance-riders" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInsuranceRiders />
            </Suspense>} />

            <Route path="/insurance/categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceCategories />
            </Suspense>} />
            <Route path="/insurance/add-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceCategories />
            </Suspense>} />
            <Route path="/insurance/edit-categories/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceCategories />
            </Suspense>} />
            <Route path="/insurance/archived-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInsuranceCategories />
            </Suspense>} />
            <Route path="/insurance/annuity-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AnnuityTypes />
            </Suspense>} />
            <Route path="/insurance/add-annuity-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAnnuityTypes />
            </Suspense>} />
            <Route path="/insurance/edit-annuity-types/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAnnuityTypes />
            </Suspense>} />
            <Route path="/insurance/archived-annuity-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedAnnuityTypes />
            </Suspense>} />

            {/* Transaction Type */}

            <Route path="/insurance/transactions-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TransactionType />
            </Suspense>} />
            <Route path="/insurance/archived-transactions-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedTransactionType />
            </Suspense>} />
            <Route path="/insurance/add-transactions-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddTransactionType />
            </Suspense>} />
            <Route path="/insurance/edit-transactions-type/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddTransactionType />
            </Suspense>} />
            {/* Operation Transaction Type Master  */}
            <Route path="/operationTransactionTypeMaster/transactions-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OperationTransactionTypeMaster />
            </Suspense>} />
            <Route path="/operation-Transaction-Type-Master/add-transactions-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddOperationTransactionType />
            </Suspense>} />
            <Route path="/operation-Transaction-Type-Master/edit-transactions-type/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddOperationTransactionType />
            </Suspense>} />
            <Route path="/operation-Transaction-Type-Master/archived-transactions-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedOperationTransactionType />
            </Suspense>} />

            {/* Mutual Funds */}

            <Route path="/mutualfunds/taxaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Taxaction />
            </Suspense>} />
            <Route path="/mutualfunds/archived-taxaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedTaxaction />
            </Suspense>} />
            <Route path="/mutualfunds/add-taxaction" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddTaxaction />
            </Suspense>} />
            <Route path="/mutualfunds/edit-taxaction/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddTaxaction />
            </Suspense>} />
            <Route path="/mutualfunds/categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundsCategories />
            </Suspense>} />
            <Route path="/mutualfunds/add-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFundsCategories />
            </Suspense>} />
            <Route path="/mutualfunds/edit-categories/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFundsCategories />
            </Suspense>} />
            <Route path="/mutualfunds/archived-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMutualFundsCategories />
            </Suspense>} />
            <Route path="/mutualfunds/sub-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundsSubCategories />
            </Suspense>} />
            <Route path="/mutualfunds/add-sub-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFundsSubCategories />
            </Suspense>} />
            <Route path="/mutualfunds/edit-sub-categories/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFundsSubCategories />
            </Suspense>} />
            <Route path="/mutualfunds/archived-sub-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMutualFundsSubCategories />
            </Suspense>} />

            {/* Share Master */}

            {/* Market Cap */}
            <Route path="/share-master/market-cap" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapMaster />
            </Suspense>} />
            <Route path="/share-master/add-market-cap" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapAdd />
            </Suspense>} />
            <Route path="/share-master/edit-market-cap/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapAdd />
            </Suspense>} />
            <Route path="/share-master/market-cap-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapArchived />
            </Suspense>} />

            {/* Product Type */}
            <Route path="/share-master/share-product-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProductTypeMaster />
            </Suspense>} />
            <Route path="/share-master/add-product-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProductTypeAdd />
            </Suspense>} />
            <Route path="/share-master/edit-product-type/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProductTypeAdd />
            </Suspense>} />
            <Route path="/share-master/product-type-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProductTypeArchived />
            </Suspense>} />

            {/* Asset Class */}
            {/* <Route path="/share-master/asset-class" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AssetClassMaster />
            </Suspense>} />
            <Route path="/share-master/add-asset-class" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AssetClassAdd />
            </Suspense>} />
            <Route path="/share-master/edit-asset-class/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AssetClassAdd />
            </Suspense>} />
            <Route path="/share-master/asset-class-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AssetClassArchived />
            </Suspense>} /> */}

            {/* Industry */}
            <Route path="/share-master/industry" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IndustryMaster />
            </Suspense>} />
            <Route path="/share-master/add-industry" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IndustryAdd />
            </Suspense>} />
            <Route path="/share-master/edit-industry/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IndustryAdd />
            </Suspense>} />
            <Route path="/share-master/industry-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IndustryArchived />
            </Suspense>} />

            {/* Sector */}
            <Route path="/share-master/sector" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SectorMaster />
            </Suspense>} />
            <Route path="/share-master/add-sector" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SectorAdd />
            </Suspense>} />
            <Route path="/share-master/edit-sector/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SectorAdd />
            </Suspense>} />
            <Route path="/share-master/sector-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SectorArchived />
            </Suspense>} />

            {/* Main Sector */}
            <Route path="/share-master/main-sector" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MainSectorMaster />
            </Suspense>} />
            <Route path="/share-master/add-main-sector" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MainSectorAdd />
            </Suspense>} />
            <Route path="/share-master/edit-main-sector/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MainSectorAdd />
            </Suspense>} />
            <Route path="/share-master/main-sector-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MainSectorArchived />
            </Suspense>} />

            {/* Sub Sector */}
            <Route path="/share-master/sub-sector" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SubSectorMaster />
            </Suspense>} />
            <Route path="/share-master/add-sub-sector" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SubSectorAdd />
            </Suspense>} />
            <Route path="/share-master/edit-sub-sector/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SubSectorAdd />
            </Suspense>} />
            <Route path="/share-master/sub-sector-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SubSectorArchived />
            </Suspense>} />

            {/* Micro Sector */}
            <Route path="/share-master/micro-sector" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MicroSectorMaster />
            </Suspense>} />
            <Route path="/share-master/add-micro-sector" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MicroSectorAdd />
            </Suspense>} />
            <Route path="/share-master/edit-micro-sector/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MicroSectorAdd />
            </Suspense>} />
            <Route path="/share-master/micro-sector-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MicroSectorArchived />
            </Suspense>} />

            {/* Product/Services */}
            <Route path="/share-master/product-services" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProductAndServicesMaster />
            </Suspense>} />
            <Route path="/share-master/add-product-services" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProductAndServicesAdd />
            </Suspense>} />
            <Route path="/share-master/edit-product-services/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProductAndServicesAdd />
            </Suspense>} />
            <Route path="/share-master/product-services-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProductAndServicesArchived />
            </Suspense>} />

            {/* MOAT */}
            <Route path="/share-master/moat-manage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MOATMaster />
            </Suspense>} />
            <Route path="/share-master/add-moat" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MOATAdd />
            </Suspense>} />
            <Route path="/share-master/edit-moat/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MOATAdd />
            </Suspense>} />
            <Route path="/share-master/moat-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MOATArchived />
            </Suspense>} />

            {/* Model */}
            <Route path="/share-master/share-model" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ModelMaster />
            </Suspense>} />
            <Route path="/share-master/add-model" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ModelAdd />
            </Suspense>} />
            <Route path="/share-master/edit-model/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ModelAdd />
            </Suspense>} />
            <Route path="/share-master/model-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ModelArchived />
            </Suspense>} />

            {/* Cycle */}
            <Route path="/share-master/cycle" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CycleMaster />
            </Suspense>} />
            <Route path="/share-master/add-cycle" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CycleAdd />
            </Suspense>} />
            <Route path="/share-master/edit-cycle/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CycleAdd />
            </Suspense>} />
            <Route path="/share-master/cycle-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CycleArchived />
            </Suspense>} />

            {/* Profile */}
            <Route path="/share-master/share-profile" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProfileMaster />
            </Suspense>} />
            <Route path="/share-master/add-profile" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProfileAdd />
            </Suspense>} />
            <Route path="/share-master/edit-profile/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProfileAdd />
            </Suspense>} />
            <Route path="/share-master/profile-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProfileArchived />
            </Suspense>} />

            {/* Income */}

            <Route path="/income/income-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IncomeCategories />
            </Suspense>} />
            <Route path="/income/archived-income-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedIncomeCategories />
            </Suspense>} />
            <Route path="/income/add-income-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddIncomeCategories />
            </Suspense>} />
            <Route path="/income/edit-income-categories/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddIncomeCategories />
            </Suspense>} />
            <Route path="/income/income-heads" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IncomeHeads />
            </Suspense>} />
            <Route path="/income/archived-income-heads" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedIncomeHeads />
            </Suspense>} />
            <Route path="/income/add-income-heads" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddIncomeHeads />
            </Suspense>} />
            <Route path="/income/edit-income-heads/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddIncomeHeads />
            </Suspense>} />

            {/* Income */}


            {/* {Ulip Funds} */}

            <Route path="/product-master/ulip-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <UlipFunds />
            </Suspense>} />
            <Route path="/product-master/archived-ulip-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedUlipFunds />
            </Suspense>} />
            <Route path="/product-master/add-ulip-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddUlipFunds />
            </Suspense>} />
            <Route path="/product-master/edit-ulip-funds/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddUlipFunds />
            </Suspense>} />

            {/* Bonds & Debenture Funds */}

            <Route path="/bonds-debenture" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BondsAndDebentureFunds />
            </Suspense>} />
            <Route path="/archived-bonds-debenture" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedBondsAndDebentureFunds />
            </Suspense>} />
            <Route path="/add-bonds-debenture" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBondAndDebentureFunds />
            </Suspense>} />
            <Route path="/edit-bonds-debenture/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddBondAndDebentureFunds />
            </Suspense>} />

            {/* Real Estate */}

            <Route path="/realstate/ownership-status" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OwnershipStatus />
            </Suspense>} />
            <Route path="/realstate/archived-ownership-status" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedOwnershipStatus />
            </Suspense>} />
            <Route path="/realestate/add-ownership-status" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddOwnershipStatus />
            </Suspense>} />
            <Route path="/realestate/edit-ownership-status/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddOwnershipStatus />
            </Suspense>} />
            <Route path="/realstate/property-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PropertyType />
            </Suspense>} />
            <Route path="/realstate/archived-property-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedPropertyType />
            </Suspense>} />
            <Route path="/realstate/add-property-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPropertyType />
            </Suspense>} />
            <Route path="/realstate/edit-property-type/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddPropertyType />
            </Suspense>} />

            {/* Household */}

            <Route path="/household/household-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HouseholdCategories />
            </Suspense>} />
            <Route path="/household/archived-household-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SAArchivedHouseholdCategories />
            </Suspense>} />
            <Route path="/household/add-household-categories" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHouseholdCategories />
            </Suspense>} />
            <Route path="/household/edit-household-categories/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHouseholdCategories />
            </Suspense>} />
            <Route path="/household/household-assets" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HouseholdAssets />
            </Suspense>} />
            <Route path="/household/archived-household-assets" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedHouseholdAsset />
            </Suspense>} />
            <Route path="/household/add-household-assets" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHouseholdAssets />
            </Suspense>} />
            <Route path="/household/edit-household-assets/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHouseholdAssets />
            </Suspense>} />
            <Route path="/household/household-vehicles" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HouseholdVehicles />
            </Suspense>} />
            <Route path="/household/add-household-vehicles" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHouseholdVehicles />
            </Suspense>} />
            <Route path="/household/edit-household-vehicles/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddHouseholdVehicles />
            </Suspense>} />

            {/*Bank */}

            <Route path="/bank/loan-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  > <LoanTypes />
            </Suspense>} />
            <Route path="/bank/archived-loan-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedLoanTypes />
            </Suspense>} />
            <Route path="/bank/add-loan-type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddLoanTypes />
            </Suspense>} />
            <Route path="/bank/edit-loan-type/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddLoanTypes />
            </Suspense>} />

            {/*Global Product parameters */}

            <Route path="/product-master/global-product-parameter" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GlobalProductParameters />
            </Suspense>} />
            <Route path="/product-master/archived-global-product-parameter" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedGlobalProductParameters />
            </Suspense>} />
            <Route path="/product-master/add-global-product-parameter" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGlobalProductParameters />
            </Suspense>} />
            <Route path="/product-master/edit-global-product-parameter/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGlobalProductParameters />
            </Suspense>} />


            {/*Establishment*/}

            <Route path="/establishment/establishment-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EstablishmentTypes />
            </Suspense>} />
            <Route path="/establishment/archived-establishment-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEstablishmentTypes />
            </Suspense>} />
            <Route path="/establishment/add-establishment-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentTypes />
            </Suspense>} />
            <Route path="/establishment/edit-establishment-types/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentTypes />
            </Suspense>} />
            <Route path="/establishment/insurance-companies" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceCompanies />
            </Suspense>} />
            <Route path="/establishment/archived-insurance-companies" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInsuranceCompanies />
            </Suspense>} />
            <Route path="/establishment/add-insurance-companies" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceCompanies />
            </Suspense>} />
            <Route path="/establishment/edit-insurance-companies/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceCompanies />
            </Suspense>} />
            <Route path="/establishment/establishment-bank" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EstablishmentBank />
            </Suspense>} />
            <Route path="/establishment/archived-establishment-bank" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEstablishmentBank />
            </Suspense>} />
            <Route path="/establishment/add-establishment-bank" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentBank />
            </Suspense>} />
            <Route path="/establishment/edit-establishment-bank/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentBank />
            </Suspense>} />
            <Route path="/establishment/establishment-branch" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EstablishmentBranch />
            </Suspense>} />
            <Route path="/establishment/archived-establishment-branch" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEstablishmentBranch />
            </Suspense>} />
            <Route path="/establishment/add-establishment-branch" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentBranch />
            </Suspense>} />
            <Route path="/establishment/edit-establishment-branch/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentBranch />
            </Suspense>} />
            <Route path="/establishment/establishment-financial-institution" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EstablishmentFinancialInstitution />
            </Suspense>} />
            <Route path="/establishment/add-establishment-financial-institution" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentFinancialInstitution />
            </Suspense>} />
            <Route path="/establishment/edit-establishment-financial-institution/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentFinancialInstitution />
            </Suspense>} />
            <Route path="/establishment/archived-establishment-financial-institution" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEstablishmentFinancialInstitution />
            </Suspense>} />
            <Route path="/establishment/establishment-depository-participants" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EstablishmentDepositoryParticipants />
            </Suspense>} />
            <Route path="/establishment/archived-establishment-depository-participants" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEstablishmentDepositoryParticipants />
            </Suspense>} />
            <Route path="/establishment/add-establishment-depository-participants" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentDepositoryParticipants />
            </Suspense>} />
            <Route path="/establishment/edit-establishment-depository-participants/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentDepositoryParticipants />
            </Suspense>} />
            <Route path="/establishment/mutual-fund" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EstablishmentMutualFunds />
            </Suspense>} />
            <Route path="/establishment/archived-mutual-fund" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedEstablishmentMutualFund />
            </Suspense>} />
            <Route path="/establishment/add-mutual-fund" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentMutualFunds />
            </Suspense>} />
            <Route path="/establishment/edit-mutual-fund/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddEstablishmentMutualFunds />
            </Suspense>} />
            <Route path="/establishment/p2p-lending" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <P2pLendingMaster />
            </Suspense>} />
            <Route path="/establishment/add-p2p-lending" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddP2pLendingMaster />
            </Suspense>} />
            <Route path="/establishment/edit-p2p-lending/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddP2pLendingMaster />
            </Suspense>} />
            <Route path="/establishment/archived-p2p-lending" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedP2pLendingMaster />
            </Suspense>} />


            {/* Product Parameters */}

            {/* <Route path="/product-parameter/fixed-return-&-retirement" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedReturnAndRetirementProducts />
            </Suspense>} /> */}
            <Route path="/product-parameter/insurance-product" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsuranceProduct />
            </Suspense>} />
            <Route path="/product-parameter/add-insurance-product" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceProduct />
            </Suspense>} />
            <Route path="/product-parameter/edit-insurance-product/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInsuranceProduct />
            </Suspense>} />
            <Route path="/product-parameter/archived-insurance-product" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedInsuranceProduct />
            </Suspense>} />
            <Route path="/product-parameter/mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SuperAdminMutualFunds />
            </Suspense>} />
            <Route path="/product-parameter/archived-mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SuperAdminArchivedMutualFunds />
            </Suspense>} />
            <Route path="/product-parameter/add-mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFunds />
            </Suspense>} />
            <Route path="/product-parameter/edit-mutual-funds/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFunds />
            </Suspense>} />
            <Route path="/product-parameter/nav-history-mutual-funds/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundNavHistory />
            </Suspense>} />
            <Route path="/product-parameter/add-nav-history-mutual-funds/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFundNavHistory />
            </Suspense>} />
            <Route path="/product-parameter/quantitative-indicators-mutual-funds/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MutualFundQuantitativeIndicators />
            </Suspense>} />
            <Route path="/product-parameter/add-quantitative-indicators-mutual-funds/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMutualFundQuantitativeIndicators />
            </Suspense>} />
            <Route path="/product-parameter/shares" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SuperAdminShares />
            </Suspense>} />
            <Route path="/product-parameter/archived-shares" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedShares />
            </Suspense>} />
            <Route path="/product-parameter/add-shares" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSharesCompany />
            </Suspense>} />
            <Route path="/product-parameter/edit-shares/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSharesCompany />
            </Suspense>} />
            <Route path="/product-parameter/shares-history-Price/:id/:id2/:id3/:id4" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesPriceHistory />
            </Suspense>} />
            <Route path="/product-parameter/add-shares-history-Price/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddSharesPriceHistory />
            </Suspense>} />
            <Route path="/product-parameter/edit-shares-history-Price/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditSharesPriceHistory />
            </Suspense>} />
            <Route path="/product-parameter/shares-quaterly-historic/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <QuaterlyHistoricData />
            </Suspense>} />
            <Route path="/product-parameter/add-shares-quaterly-historic/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddQuaterlyHistoricData />
            </Suspense>} />
            <Route path="/Product-parameters/Fixed-return-and-retirement-products" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FixedReturnandRetirementProducts />
            </Suspense>} />
            <Route path="/Product-parameters/add-fixed-return-and-retirement-products" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFixedReturnandRetirementProducts />
            </Suspense>} />
            <Route path="/Product-parameters/edit-fixed-return-and-retirement-products/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddFixedReturnandRetirementProducts />
            </Suspense>} />
            <Route path="/Product-parameters/archived-fixed-return-and-retirement-products" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedFixedReturnandRetirementProducts />
            </Suspense>} />


            {/* Advisor Goal Master */}

            <Route path="/goalliablities/goal-liablities" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GoalLiablities />
            </Suspense>} />
            <Route path="/goalliablities/add-goal-liablities" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGoalLiablities />
            </Suspense>} />
            <Route path="/goalliablities/edit-goal-liablities/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGoalLiablities />
            </Suspense>} />
            <Route path="/goalliablities/archived-goal-liablities" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedGoalLiablities />
            </Suspense>} />



            <Route path="/investmentobjective/investment-objective" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InvestmentObjectives />
            </Suspense>} />
            <Route path="/investmentobjective/add-investment-objective" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInvestmentObjectives />
            </Suspense>} />
            <Route path="/investmentobjective/edit-investment-objective/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddInvestmentObjectives />
            </Suspense>} />

            {/* Master */}

            {/* Accouting Master */}

            <Route path="/accouting-master/financial-year" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialYear />
            </Suspense>} />
            <Route path="/accouting-master/add-financial-year" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditFinancialYear />
            </Suspense>} />
            <Route path="/accouting-master/edit-financial-year/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EditFinancialYear />
            </Suspense>} />
            <Route path="/master/menu-organizer" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MenuOrganizer />
            </Suspense>} />
            <Route path="/master/add-menu-organizer" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMenuOrganizer />
            </Suspense>} />
            <Route path="/master/edit-menu-organizer/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMenuOrganizer />
            </Suspense>} />
            <Route path="/master/archived-menu-organizer" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedMenuOrganizer />
            </Suspense>} />

            <Route path="/accouting-master/cost-Inflation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CostInflation />
            </Suspense>} />
            <Route path="/accouting-master/add-cost-Inflation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCostInflation />
            </Suspense>} />
            <Route path="/accouting-master/edit-cost-Inflation/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCostInflation />
            </Suspense>} />
            <Route path="/accouting-master/archived-cost-Inflation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedCostInflation />
            </Suspense>} />
            <Route path="/accouting-master/gst-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GstMaster />
            </Suspense>} />
            <Route path="/accouting-master/add-gst-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGstMaster />
            </Suspense>} />
            <Route path="/accouting-master/edit-gst-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddGstMaster />
            </Suspense>} />
            <Route path="/accouting-master/archived-gst-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedGstMaster />
            </Suspense>} />

            {/* Cis Master  -> Newly Added Module */}

            <Route path="/master/cis-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CisMaster />
            </Suspense>} />
            <Route path="/master/add-cis-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCisMaster />
            </Suspense>} />
            <Route path="/master/edit-cis-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCisMaster />
            </Suspense>} />
            <Route path="/master/archived-cis-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedCisMaster />
            </Suspense>} />

            {/* Client onboarding checklist master  -> Newly Added Module */}

            <Route path="/master/client-onboarding-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientOnboardingChecklistMaster />
            </Suspense>} />
            <Route path="/master/add-client-onboarding-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientOnboardingChecklistMaster />
            </Suspense>} />
            <Route path="/master/edit-client-onboarding-checklist-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientOnboardingChecklistMaster />
            </Suspense>} />
            <Route path="/master/archived-client-onboarding-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedClientOnboardingChecklistMaster />
            </Suspense>} />

            {/* Client Clearance ChecklistMaster */}

            <Route path="/master/client-clearance-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ClientClearanceChecklistMaster />
            </Suspense>} />
            <Route path="/master/add-client-clearance-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddClientClearanceChecklistMaster />
            </Suspense>} />
            <Route path="/master/edit-client-clearance-checklist-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddClientClearanceChecklistMaster />
            </Suspense>} />
            <Route path="/master/archived-client-clearance-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ArchivedClientClearanceChecklistMaster />
            </Suspense>} />

            {/* Employee Onboarding Checklist Master */}

            <Route path="/master/employee-onboarding-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <EmployeeOnboardingChecklistMaster />
            </Suspense>} />
            <Route path="/master/add-employee-onboarding-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddEmployeeOnboardingChecklistMaster />
            </Suspense>} />
            <Route path="/master/edit-employee-onboarding-checklist-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddEmployeeOnboardingChecklistMaster />
            </Suspense>} />
            <Route path="/master/archived-employee-onboarding-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ArchivedEmployeeOnboardingChecklistMaster />
            </Suspense>} />

            {/* Employee Clearance Checklist Master */}

            <Route path="/master/employee-clearance-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <EmployeeClearanceChecklistMaster />
            </Suspense>} />
            <Route path="/master/add-employee-clearance-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddEmployeeClearanceChecklistMaster />
            </Suspense>} />
            <Route path="/master/edit-employee-clearance-checklist-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddEmployeeClearanceChecklistMaster />
            </Suspense>} />
            <Route path="/master/archived-employee-clearance-checklist-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ArchivedEmployeeClearanceChecklistMaster />
            </Suspense>} />

            {/* Notification Master */}

            <Route path="/master/notification-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <NotificationMaster />
            </Suspense>} />
            <Route path="/master/add-notification-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddNotificationMaster />
            </Suspense>} />
            <Route path="/master/edit-notification-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddNotificationMaster />
            </Suspense>} />
            <Route path="/master/archived-notification-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedNotificationMaster />
            </Suspense>} />

            {/* Task Master */}

            <Route path="/master/task-master" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <TaskMaster />
            </Suspense>} />
            <Route path="/add-task-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddTaskMaster />
            </Suspense>} />
            <Route path="/edit-task-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddTaskMaster />
            </Suspense>} />
            <Route path="/archived-task-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedTaskMaster />
            </Suspense>} />

            {/*Company Menu Selection */}

            <Route path="/master/Company-Menu-Selection" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CompanyMenuSelection />
            </Suspense>} />
            <Route path="/edit/company-Menu-Selection/" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCompanyMenuSelection />
            </Suspense>} />
            <Route path="/edit/company-Menu-Selection/:type/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCompanyMenuSelection />
            </Suspense>} />

            {/* Notification Title */}
            <Route path="/master/notification-title" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <NotificationTitle />
            </Suspense>} />
            <Route path="/master/add-notification-title" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddNotificationTitle />
            </Suspense>} />
            <Route path="/master/edit-notification-title/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddNotificationTitle />
            </Suspense>} />
            <Route path="/master/archived-notification-title" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedNotificationTitle />
            </Suspense>} />

            {/* Notification Status */}
            <Route path="/master/notification-status" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <NotificationStatus />
            </Suspense>} />
            <Route path="/master/archived-notification-status" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NotificationArchivedStatus />
            </Suspense>} />
            <Route path="/master/read-notification-status" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <NotificationReadStatus />
            </Suspense>} />

            {/* Website Compliance */}
            <Route path="/master/website-compliance/investor-charter" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <InvestorCharter />
            </Suspense>} />
            <Route path="/master/website-compliance/Complaints" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <Complaints />
            </Suspense>} />
             <Route path="/master/website-compliance/archived-Complaints" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ArchivedComplaints />
            </Suspense>} />
            <Route path="/master/website-compliance/histroic-trend" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <HistoricTrend />
            </Suspense>} />
            {/* <Route path="/Complaints-count/:month" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ComplaintsCount />
            </Suspense>} /> */}
            <Route path="/add-complaint" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddComplaints />
            </Suspense>} />
            <Route path="/edit-complaint/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddComplaints />
            </Suspense>} />
            <Route path="/edit-complaint/:id/:disable" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddComplaints />
            </Suspense>} />
            <Route path="/master/website-compliance/annual-compliance-audit-reports" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AnnualComplianceAuditReports />
            </Suspense>} />
            <Route path="/add-annual-compliance" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddAnnualComplianceAuditReports />
            </Suspense>} />
            <Route path="/edit-annual-compliance/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddAnnualComplianceAuditReports />
            </Suspense>} />
            <Route path="/master/website-compliance/grievance-redressal-mechanisms" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <GrievanceRedressalMechanisms />
            </Suspense>} />

            {/* Risk Profile Master */}
            <Route path="/master/risk-profile-introduction" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <RiskProfileIntroduction />
            </Suspense>} />
            <Route path="/master/risk-profile-disclaimer" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <RiskProfileDisclaimer />
            </Suspense>} />
            <Route path="/master/risk-profile-disclaimer-add" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddRiskProfileDisclaimer />
            </Suspense>} />
            <Route path="/master/risk-profile-disclaimer-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ArchivedRiskProfileDisclaimer />
            </Suspense>} />
            <Route path="/master/risk-profile-disclaimer-edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRiskProfileDisclaimer />
            </Suspense>} />
            <Route path="/master/risk-profile-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RiskProfilesTypes />
            </Suspense>} />
            <Route path="/master/risk-profile-types/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RiskProfiles />
            </Suspense>} />
            <Route path="/risk-profile-types" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RiskProfilesTypesSuperAdmin />
            </Suspense>} />
            <Route path="/master/add-risk-profile-type" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <AddRiskProfiles />
            </Suspense>} />
            <Route path="/master/archived-risk-profile-type" element={<Suspense fallback={<> <Loader show={true} /> </>}>
              <ArchivedRiskProfiles />
            </Suspense>} />
            <Route path="/master/risk-profile-edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRiskProfiles />
            </Suspense>} />
            <Route path="/master/risk-profile-Q&A" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RiskProfilesQA />
            </Suspense>} />
            <Route path="/master/archived-risk-profile-Q&A" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedRiskProfilesQA />
            </Suspense>} />
            <Route path="/master/add-risk-profile-Q&A" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRiskProfilesQA />
            </Suspense>} />
            <Route path="/master/edit-risk-profile-Q&A/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddRiskProfilesQA />
            </Suspense>} />
            <Route path="/advisor-login-access" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LoginAccess />
            </Suspense>} />
            <Route path="/client-login-access" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LoginAccess />
            </Suspense>} />

            {/* Company Details */}

            <Route path="/company-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CompanyMaster />
            </Suspense>} />
            <Route path="/edit-company-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddCompanyMaster />
            </Suspense>} />
            <Route path="/archived-company-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedCompanyMaster />
            </Suspense>} />
            <Route path="/master/adviosr" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Advisors />
            </Suspense>} />
            <Route path="/master/archived-adviosr" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedAdvisors />
            </Suspense>} />
            <Route path="/master/add-adviosr" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAdvisors />
            </Suspense>} />
            <Route path="/master/edit-adviosr/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAdvisors />
            </Suspense>} />

            {/* Assumption Master */}


            <Route path="/assumption-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AssumptionMaster />
            </Suspense>} />
            <Route path="/add-assumption-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAssumptionMaster />
            </Suspense>} />
            <Route path="/edit-assumption-master/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddAssumptionMaster />
            </Suspense>} />
            <Route path="/archived-assumption-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedAssumptionMaster />
            </Suspense>} />

            {/* Role Management */}

            <Route path="/role-management" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RoleManagment />
            </Suspense>} />
            <Route path="/create-role-management" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CreateRoleManagement />
            </Suspense>} />
            <Route path="/edit-role-management/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CreateRoleManagement />
            </Suspense>} />
            <Route path="/role-management-permission" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RoleManagmentPermission />
            </Suspense>} />

            {/* Uplaod Document */}

            <Route path="/sa-documents-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <UploadDocument />
            </Suspense>} />

            {/* Operations */}


            <Route path="/operations/mftransactionsErrors/mftransactions-mising-schemes" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsErrorsMissingSchemes />
            </Suspense>} />
            <Route path="/operations/SchemeVerification/matched" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MatchedScheme />
            </Suspense>} />
            <Route path="/operations/SchemeVerification/missingInSfa" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemeMissingInSFA />
            </Suspense>} />
            <Route path="/operations/SchemeVerification/missingInAccord" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemeMIssingInAccord />
            </Suspense>} />
            <Route path="/operations/SchemeVerification/missingInAccordRTA" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemeMIssingInAccordRTA />
            </Suspense>} />
            <Route path="/operations/SchemeVerification/missingInAccordAMFI" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchemeMIssingInAccordAMFI />
            </Suspense>} />
            <Route path="/operations/SchemeVerification/isVerified" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MFSchemeIsVerified />
            </Suspense>} />
            <Route path="/operations/ShareVerification/matched" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesMatchedScheme />
            </Suspense>} />
            <Route path="/operations/ShareVerification/missing" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesSchemeMissing />
            </Suspense>} />
            <Route path="/operations/ShareVerification/missing-nse" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesSchemeMissingNSE />
            </Suspense>} />
            <Route path="/operations/ShareVerification/missing-isin" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesSchemeMissingISIN />
            </Suspense>} />
            <Route path="/operations/ShareVerification/missingInAccord" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesSchemeMissingInAccord />
            </Suspense>} />
            <Route path="/operations/ShareVerification/missingInSfa" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesSchemeMissingInSFA />
            </Suspense>} />
            <Route path="/operations/ShareVerification/isVerified" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesSchemeIsVerified />
            </Suspense>} />
            <Route path="/operations/ShareVerification/marketCap" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesSchemeMarketCap />
            </Suspense>} />
            <Route path="/operations/ShareVerification/market-cap-import" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MarketCapImport />
            </Suspense>} />
            <Route path="/operations/ShareVerification/isSecDetailsFilled" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SharesIsSecDetailsFilled />
            </Suspense>} />
            <Route path="/operations/ShareVerification/missingShare" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MissingShares />
            </Suspense>} />
            <Route path="/operations/mftransactionsErrors/mftransactions-scheme-mapping" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsErrorSchemeMapping />
            </Suspense>} />
            <Route path="/operations/mftransactionsErrors/mftransactions-errors" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsErrors />
            </Suspense>} />
            <Route path="/operations/shareTransaction/sharetransaction-missing-code" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionMissingCode />
            </Suspense>} />
            <Route path="/operations/shareTransaction/sharetransaction-error" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ShareTransactionsError />
            </Suspense>} />
            <Route path="/operations/clientMigration" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientMigration />
            </Suspense>} />
            <Route path="/operations/add-clientMigration" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddClientMigration />
            </Suspense>} />
            <Route path="/operations/mftransactionsErrors/scheme-verify" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MFSchemeVerify />
            </Suspense>} />
            <Route path="/operations/bulk/scheme-verification" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BulkSchemeVerification />
            </Suspense>} />
            <Route path="/operations/bulk/not-verified-scheme" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BulkNotVerifiedScheme />
            </Suspense>} />
            <Route path="/operations/bulk/missing-scheme" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BulkMissingScheme />
            </Suspense>} />
            <Route path="/operations/bulk/category-verified-scheme" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BulkCategoryVerified />
            </Suspense>} />

            {/* Mail Template */}

            <Route path="/mail-template" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MailTemplate />
            </Suspense>} />
            <Route path="/add-mail-template" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMailTemplate />
            </Suspense>} />
            <Route path="/edit-mail-template/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AddMailTemplate />
            </Suspense>} />




            <Route path="/insurance/payout-details/:id/:type" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InsurancePayoutDetails />
            </Suspense>} />


            {/*Added on 04-Feb-2026 By Sourabh.*/}
            <Route path="/advisory-header" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Advisory />
            </Suspense>} />
            {/* Financial Planning */}

            {/* Incidental Advice Report */}
            <Route path="/incidental-advice-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IncidentalAdviceReport />
            </Suspense>} />
            <Route path="/incidental-advice-report-homePage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <StartIncidentalAdvice />
            </Suspense>} />
            {/* financial plans */}
            <Route path="/financial-plans" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlans />
            </Suspense>} />
            <Route path="/financial-plans-bank-and-dmat" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningBankAndDMat />
            </Suspense>} />
            <Route path="/financial-plans-homePage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              {/*<FinancialPlansHomePage />*/}
              <StartPlanning />
            </Suspense>} />
            <Route path="/financial-plans-cover-page" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningCoverPage />
            </Suspense>} />
            <Route path="/financial-plans-share" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningShare />
            </Suspense>} />
            <Route path="/financial-plans-mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningMutualFund />
            </Suspense>} />
            <Route path="/financial-plans-pms" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningPMS />
            </Suspense>} />
            <Route path="/financial-plans-aif" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningAIF />
            </Suspense>} />
            <Route path="/financial-plans-ulip" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningUlip />
            </Suspense>} />
            <Route path="/financial-plans-moneyback" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningMoneyBack />
            </Suspense>} />
            <Route path="/financial-plans-fixed-income" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningFixedIncome />
            </Suspense>} />
            <Route path="/financial-plans-retirement-products" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningRetirementProducts />
            </Suspense>} />
            <Route path="/financial-plans-bullion" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningBullion />
            </Suspense>} />
            <Route path="/financial-plans-realestate" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningRealEstate />
            </Suspense>} />
            <Route path="/financial-planing" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FanancialPlaning />
            </Suspense>} />
            <Route path="/financial-planing/life-insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LifeInsurance />
            </Suspense>} />
            <Route path="/financial-planing/retirement-planning" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RetirementPlanning />
            </Suspense>} />
            <Route path="/financial-planing/householders-insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HouseholdersInsurance />
            </Suspense>} />
            <Route path="/financial-planing/vehicle-insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <VehicleInsurance />
            </Suspense>} />
            <Route path="/financial-planing/accident-insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AccidentInsurance />
            </Suspense>} />
            <Route path="/financial-planing/healthcare-contingency-fund" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HealthcareContingencyFund />
            </Suspense>} />
            <Route path="/financial-planing/contingency" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Contingency />
            </Suspense>} />
            <Route path="/financial-planing/life-insurance-expenses" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LifeInsuranceExpenses />
            </Suspense>} />
            <Route path="/financial-planing/lump-sum-calculation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LumpSumCalculation />
            </Suspense>} />
            <Route path="/financial-planing/tax-planning" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxPlanning />
            </Suspense>} />
            <Route path="/financial-planing/tax-planning-new-regime-self/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxPlanningNewRegimeSelf />
            </Suspense>} />

            <Route path="/reports/client/tax-calculation-report/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientTaxPlanningNewRegime />
            </Suspense>} />

            <Route path="/reports/client/tax-calculation-old-regime-report/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientTaxPlanningOldRegime />
            </Suspense>} />
            <Route path="/financial-planing/tax-planning-old-regime-self/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxPlanningOldRegimeSelf />
            </Suspense>} />
            <Route path="/financial-planing/tax-planning-new-regime-spouse/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxPlanningNewRegimeSpouse />
            </Suspense>} />
            <Route path="/financial-planing/tax-planning-old-regime-spouse/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxPlanningOldRegimeSpouse />
            </Suspense>} />
            <Route path="/financial-planing/asset-mapping" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AssetMapping />
            </Suspense>} />
            <Route path="/tax-plans" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TaxPlans />
            </Suspense>} />
            <Route path="/financial/plan/advice/request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageAdviceRequest />
            </Suspense>} />
            <Route path="/financial/plan/advice/request-sent-for-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageAdviceRequestSentForApproval />
            </Suspense>} />
            <Route path="/financial/plan/advice/request-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageAdviceRequestCompleted />
            </Suspense>} />
            <Route path="/financial/plan/advice/request-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageAdviceRequestDeleted />
            </Suspense>} />
            <Route path="/financial/plan/redemption/purpose" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageRedemptionPurpose />
            </Suspense>} />
            <Route path="/financial/plan/redemption/purpose/share" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageRedemptionPurposeShare />
            </Suspense>} />
            <Route path="/financial/plan/redemption/purpose/historical-data" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageRedemptionPurposeHistoricalData />
            </Suspense>} />
            <Route path="/financial/plan/redemption/purpose/historical-data-share" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageRedemptionPurposeHistoricalDataShare />
            </Suspense>} />
            <Route path="/financial/plan/redemption/purpose-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageRedemptionPurposeCompleted />
            </Suspense>} />
            <Route path="/financial/plan/redemption/purpose-share-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageRedemptionPurposeShareCompleted />
            </Suspense>} />
            <Route path="/financial/plan/investment/purpose" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageInvestmentPurpose />
            </Suspense>} />
            <Route path="/financial/plan/investment/purpose/share" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageInvestmentPurposeShare />
            </Suspense>} />
            <Route path="/financial/plan/investment/purpose-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageInvestmentPurposeCompleted />
            </Suspense>} />
            <Route path="/financial/plan/investment/purpose-share-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageInvestmentPurposeShareCompleted />
            </Suspense>} />
            <Route path="/financial/plan/investment/purpose/historical-data" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageInvestmentPurposeHistoricalData />
            </Suspense>} />
            <Route path="/financial/plan/investment/purpose/historical-data-share" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ManageInvestmentPurposeHistoricalDataShare />
            </Suspense>} />
            
            <Route path="/financial/plan/advice/lumpSum/:id/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LumpsumAdviceRequest />
            </Suspense>} />
            <Route path="/financial/plan/advice/sip-investment/:id/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SipInvestmentAdviceRequest />
            </Suspense>} />
            <Route path="/financial/plan/advice/sip-cancellation/:id/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SipCancellationAdviceRequest />
            </Suspense>} />
            <Route path="/financial/plan/advice/sip-pause/:id/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SipPauseAdviceRequest />
            </Suspense>} />
            <Route path="/financial/plan/advice/redemption/:id/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RedemptionAdviceRequest />
            </Suspense>} />
            <Route path="/financial/plan/proactive/add-proactive-redemption-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveRedemptionAdviceRequestAdd />
            </Suspense>} />
            <Route path="/financial/plan/proactive/add-proactive-investment-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveBulkInvestmentAdviceRequestAdd />
            </Suspense>} />
            <Route path="/financial/plan/proactive/edit-proactive-bulk-investment-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveBulkInvestmentAdviceRequestAdd />
            </Suspense>} />
            <Route path="/financial/plan/proactive/add-proactive-bulk-redemption-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveBulkRedemptionAdviceRequestAdd />
            </Suspense>} />
            <Route path="/financial/plan/proactive/edit-proactive-bulk-redemption-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveBulkRedemptionAdviceRequestAdd />
              {/* <ProactiveBulkRedemptionAdviceRequestEdit /> */}
            </Suspense>} />
            <Route path="/financial/plan/proactive/edit-proactive-redemption-request/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveRedemptionAdviceRequestEdit />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-cancellation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvices />
            </Suspense>} />
            <Route path="/financial/plan/proactive/add-investment-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesInvestments />
            </Suspense>} />
            <Route path="/financial/plan/proactive/add-switch-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesSwitchs />
            </Suspense>} />
            <Route path="/financial/plan/proactive/add-stp-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesStps />
            </Suspense>} />
            <Route path="/financial/plan/proactive/edit-proactive-stp-request/:proactiveId/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <ProactiveAdvicesStps />
            </Suspense>} />
            <Route path="/financial/plan/proactive/edit-proactive-swp-request/:proactiveId/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <ProactiveAdvicesSwps />
            </Suspense>} />
            <Route path="/financial/plan/proactive/add-swp-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesSwps />
            </Suspense>} />
            <Route path="/financial/plan/proactive/edit-proactive-switch-request/:proactiveId/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
            <ProactiveAdvicesSwitchs />
            </Suspense>} />
            <Route path="/financial/plan/proactive/edit-proactive-investment-request/:proactiveId/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesInvestments />
              {/* <ProactiveAdvicesInvestmentsEdit /> */}
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-cancellation-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesCancellation />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-redemption" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesRedemption />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-redemption" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesBulkRedemption />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-investment" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesBulkInvestment />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-investment-send-for-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveRequestBulkInvestmentSentForApproval />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-investment-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveRequestBulkInvestmentCompleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-investment-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveRequestBulkInvestmentDeleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-investment-approval-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveRequestBulkInvestmentApprovalDeleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-redemption-approval-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveRequestBulkRedemptionApprovalDeleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-redemption-send-for-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesRedemptionSendForApproval />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-redemption-send-for-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveBulkAdvicesRedemptionSendForApproval />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-redemption-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveBulkAdvicesRedemptionCompleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-bulk-redemption-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveBulkAdvicesRedemptionDeleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-redemption-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesRedemptionCompleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-redemption-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesRedemptionDeleted />
            </Suspense>} />

            <Route path="/financial/plan/proactive/advice-investment" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesInvestment />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-switch" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesSwitch />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-stp" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesStp />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-stp-send-for-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesStpSentForApproval />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-stp-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesStpCompleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-stp-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdviceStpArchived />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-swp" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesSwp />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-swp-send-for-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesSwpSendForApproval />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-swp-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesSwpCompleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-swp-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdviceRequestSwpDeleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-switch-send-for-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesSwitchSendForApproval />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-switch-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesSwitchCompleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-switch-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesSwitchDeleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-investment-send-for-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesInvestmentSendForApproval />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-investment-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesInvestmentCompleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-investment-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesInvestmentDeleted />
            </Suspense>} />
            {/* Shares/ETFs Portfolio Rebalancing */}
            <Route path="/financial/plan/proactive/rebalancing" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RebalancingManage />
            </Suspense>} />
            <Route path="/financial/plan/proactive/rebalancing-send-for-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RebalancingSentForApproval />
            </Suspense>} />
            <Route path="/financial/plan/proactive/rebalancing-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RebalancingCompleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/rebalancing-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RebalancingDeleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/add-rebalancing-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RebalancingRequestAdd />
            </Suspense>} />
            <Route path="/financial/plan/proactive/edit-rebalancing-request/:proactiveId/:cbid" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RebalancingRequestAdd />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-activesplit" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesActiveSplit />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-completed" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesCompleted />
            </Suspense>} />
            <Route path="/financial/plan/proactive/advice-deleted" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProactiveAdvicesDeleted />
            </Suspense>} />
            <Route path="/financial-planing/loans" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanLoans />
            </Suspense>} />
            {/* <Route path="/financial-planing/insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CapitalAllocationInsurance />
            </Suspense>} /> */}
            <Route path="/financial-planing/sip-calculation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SipCalculation />
            </Suspense>} />
            <Route path="/financial-planing/stp" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GoalStp />
            </Suspense>} />
            <Route path="/financial-planing/swp" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GoalSwp />
            </Suspense>} />
            <Route path="/financial-planing/switch" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GoalSwitch />
            </Suspense>} />
            <Route path="/financial-planing/goal-comments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GoalComments />
            </Suspense>} />
            <Route path="/financial-planing/investment" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Investment />
            </Suspense>} />
            <Route path="/financial-planing/investment-comments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InvestmentComments />
            </Suspense>} />
            <Route path="/financial-planing/immediate-cashflow-plan" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ImmediateCashFlowPlan />
            </Suspense>} />
            <Route path="/financial-planing/annual-spendings" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AnnualSpendings />
            </Suspense>} />
            <Route path="/financial-planing/estate-planning" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EstatePlanning />
            </Suspense>} />
            <Route path="/financial-planing/proposed-action-plan" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProposedActionPlan />
            </Suspense>} />
            <Route path="/financial-planing/evaluation-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <EvaluationReport />
            </Suspense>} />
            <Route path="/financial-planing/disclaimers-disclosurest" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DisclaimersDisclosures />
            </Suspense>} />
            <Route path="/financial-planing/signoff" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SignOff />
            </Suspense>} />
            <Route path="/financial-planing/close-plan" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClosePlan />
            </Suspense>} />
            <Route path="/financial-planing/start-planning" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <StartPlanning />
            </Suspense>} />
            <Route path="/financial-planing/health-insurance" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <HealthInsurance />
            </Suspense>} />


            {/* Finaancial Planning Report */}

            <Route path="/financial-planing/report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningReport />
            </Suspense>} />

            {/*Incidental Advice */}
            <Route path="/incidental-advice/start-advice" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <StartIncidentalAdvice />
            </Suspense>} />
            <Route path="/incidental-advice/cover-page" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IncidentalAdviceCoverPage />
            </Suspense>} />
            <Route path="/incidental-advice/mutual-funds" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IncidentalAdviceMutualFund />
            </Suspense>} />
            <Route path="/incidental-advice/healthcare-contingency-fund" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IncidentalAdviceHealthcareContingencyFund />
            </Suspense>} />
            <Route path="/incidental-advice/contingency" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IncidentalAdviceContingencyFund />
            </Suspense>} />
            <Route path="/incidental-advice/retirement-planning" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RetirementAdvice />
            </Suspense>} />
            <Route path="/incidental-advice/asset-mapping" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AssetMappingAdvice />
            </Suspense>} />
            <Route path="/incidental-advice/lump-sum-calculation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <LumpSumCalculationAdvice />
            </Suspense>} />
            <Route path="/incidental-advice/sip-calculation" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SipCalculationAdvice />
            </Suspense>} />
            <Route path="/incidental-advice/stp" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GoalStpAdvice />
            </Suspense>} />
            <Route path="/incidental-advice/swp" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GoalSwpAdvice />
            </Suspense>} />
            <Route path="/incidental-advice/switch" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <GoalSwitchAdvice />
            </Suspense>} />
            <Route path="/incidental-advice/goal-comments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IncidentalGoalComment />
            </Suspense>} />
            <Route path="/incidental-advice/investment-comments" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InvestmentCommentsAdvice />
            </Suspense>} />
            <Route path="/incidental-advice/investment" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <InvestmentAdvice />
            </Suspense>} />
            <Route path="/incidental-advice/immediate-cashflow-plan" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ImmediateCashFlowPlanAdvice />
            </Suspense>} />
            <Route path="/incidental-advice/proposed-action-plan" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ProposedActionPlanAdvice />
            </Suspense>} />
            <Route path="/incidental-advice/report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <IncidentalAdviceReportPage />
            </Suspense>} />
            <Route path="/incidental-advice/disclaimers" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DisclaimersDisclosuresAdvice />
            </Suspense>} />
            <Route path="/incidental-advice/signoff" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SignOffAdvice />
            </Suspense>} />
            
          {/* PMSProductMaster */}          
          <Route path="/product-masters/pms-providers-manage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsManage />
            </Suspense>} />
          <Route path="/product-masters/pms-providers-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsAdd />
            </Suspense>} />
          <Route path="/product-masters/pms-providers-edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsAdd />
            </Suspense>} />
          <Route path="/product-masters/pms-providers-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsArchived />
            </Suspense>} />

            {/* AIF */}          
          <Route path="/product-masters/Aif-providers-manage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AifManage />
            </Suspense>} />
          <Route path="/product-masters/Aif-providers-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AifAdd />
            </Suspense>} />
          <Route path="/product-masters/Aif-providers-edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AifAdd />
            </Suspense>} />
          <Route path="/product-masters/Aif-providers-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AifArchived />
            </Suspense>} />

            {/* PMSestablishment */}          
          <Route path="/establishment/pms-providers-manage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsEstablishmentManage />
            </Suspense>} />
          <Route path="/establishment/pms-providers-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsEstablishmentAdd />
            </Suspense>} />
          <Route path="/establishment/pms-providers-edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsEstablishmentAdd />
            </Suspense>} />
          <Route path="/establishment/pms-providers-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsEstablishmentArchived />
            </Suspense>} />

            {/* AIF */}          
          <Route path="/establishment/Aif-providers-manage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AifEstablishmentManage />
            </Suspense>} />
          <Route path="/establishment/Aif-providers-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AifEstablishmentAdd />
            </Suspense>} />
          <Route path="/establishment/Aif-providers-edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AifEstablishmentAdd />
            </Suspense>} />
          <Route path="/establishment/Aif-providers-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AifEstablishmentArchived />
            </Suspense>} />

            {/*Client Portfolio*/}
            <Route path="/portfolio/pms-portfolio-manage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsClientPortfolioManage />
            </Suspense>} />
            <Route path="/portfolio/pms-portfolio-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsClientPortfolioAdd />
            </Suspense>} />
            <Route path="/portfolio/pms-portfolio-edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsClientPortfolioAdd />
            </Suspense>} />
            <Route path="/portfolio/pms-portfolio-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsClientPortfolioArchived />
            </Suspense>} />
            <Route path="/portfolio/pmspassbook-entry-manage/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsClientPortfolioPassbookManage />
            </Suspense>} />
            <Route path="/portfolio/pmspassbook-entry-add/:id1" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsClientPassbookEntryAdd />
            </Suspense>} />
            <Route path="/portfolio/pmspassbook-entry-edit/:id1/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PmsClientPassbookEntryAdd />
            </Suspense>} />
            <Route path="/portfolio/ppf-archived-acount" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PpfArchivedAccounts />
            </Suspense>} />
          
            {/*Client Portfolio AIF*/}
            <Route path="/portfolio/aif-portfolio-manage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AIFClientPortfolioManage />
            </Suspense>} />
            <Route path="/portfolio/aif-portfolio-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AIFClientPortfolioAdd />
            </Suspense>} />
            <Route path="/portfolio/aif-portfolio-edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AIFClientPortfolioAdd />
            </Suspense>} />
            <Route path="/portfolio/aif-portfolio-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AIFClientPortfolioArchived />
            </Suspense>} />
            <Route path="/portfolio/aifpassbook-entry-manage/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AIFClientPortfolioPassbookManage />
            </Suspense>} />
            <Route path="/portfolio/aifpassbook-entry-add/:id1" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AIFClientPassbookEntryAdd />
            </Suspense>} />
            <Route path="/portfolio/aifpassbook-entry-edit/:id1/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AIFClientPassbookEntryAdd />
            </Suspense>} />

            {/*Other Portfolio Others*/}
            <Route path="/portfolio/others" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OthersClientPortfolioManage />
            </Suspense>} />
            <Route path="/portfolio/others-portfolio-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OthersClientPortfolioAdd />
            </Suspense>} />
             <Route path="/portfolio/others-portfolio-edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OthersClientPortfolioAdd />
            </Suspense>} />
            <Route path="/portfolio/others-portfolio-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OthersClientPortfolioArchived />
            </Suspense>} />
            <Route path="/portfolio/otherspassbook-entry-manage/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OthersClientPortfolioPassbookManage />
            </Suspense>} />
            <Route path="/portfolio/otherspassbook-entry-add/:id1" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OthersClientPassbookEntryAdd />
            </Suspense>} />
            <Route path="/portfolio/otherspassbook-entry-edit/:id1/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <OthersClientPassbookEntryAdd />
            </Suspense>} />


            {/* Client Portfolio */}

            <Route path="/financial-planing/client-portfolio" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FpClientPortfolio />
            </Suspense>} />
            <Route path="/financial-planing/client-portfolio-passbook/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ClientPortfolioPassbook />
            </Suspense>} />
            <Route path="/Corpevents/GetCorpevents" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CorporateActions />
            </Suspense>} />

            {/* Fintech Actions */}
            <Route path="fintech-actions-task" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FintechActions />
            </Suspense>} />
            

            {/* Category Master */}
            <Route path="/category-master" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CategoryMaster />
            </Suspense>} />
            <Route path="/master/category-master-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CategoryMasterArchived />
            </Suspense>} />
            <Route path="/master/category-master-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CategoryMasterAdd />
            </Suspense>} />
            <Route path="/master/category-master-edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <CategoryMasterAdd />
            </Suspense>} />
            {/*Compliance*/}
            <Route path="/compliance-header" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Compliance />
            </Suspense>} />
            <Route path="/regulatory-updates" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RegulatoryUpdates />
            </Suspense>} />
            <Route path="/contra-trade-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ContraTradeReport />
            </Suspense>} />
            <Route path="/publish-restricted-list" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <PublishRestrictedList />
            </Suspense>} />
            <Route path="/publish-restricted-list/add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RestrictedListAdd />
            </Suspense>} />
            <Route path="/publish-restricted-list/edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RestrictedListAdd />
            </Suspense>} />
            <Route path="/archived-restricted-list" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ArchivedRestrictedList />
            </Suspense>} />
            <Route path="/restricted-list" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <RestrictedList />
            </Suspense>} />
            <Route path="/trade-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TradeRequest />
            </Suspense>} />
            <Route path="/trade-request-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TradeRequestAdd />
            </Suspense>} />
            <Route path="/trade-request-edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TradeRequestAdd />
            </Suspense>} />
            <Route path="/trade-request-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TradeRequestArchived />
            </Suspense>} />
            <Route path="/trade-approval" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <TradeApproval />
            </Suspense>} />
            <Route path="/view-trade-request" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <ViewTradeRequest />
            </Suspense>} />
            {/*Mail*/}
            <Route path="/mails" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <Mails />
            </Suspense>} />
            {/*Operations DMAT ledger*/}
            <Route path="/operations/dmat-ledger" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DMATLedger />
            </Suspense>} />
            <Route path="/financial-plans-others" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FinancialPlanningOthers />
            </Suspense>} />
            <Route path="/operations/dmat-ledger/passbook-entry-manage/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DMATLedgerPassbookManage />
            </Suspense>} />
            <Route path="/operations/dmat-ledger-others" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DMATLedgerOthers />
            </Suspense>} />
            <Route path="/operations/dmat-ledger/passbook-entry-add/:id1" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DMATLedgerPassbookEntryAdd />
            </Suspense>} />
             <Route path="/operations/dmat-ledger/passbook-entry-edit/:id1/:id2" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <DMATLedgerPassbookEntryAdd />
            </Suspense>} />
            <Route path="/operations/mf/transaction/duplicate" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsDuplicate />
            </Suspense>} />
            <Route path="/operations/mf/transaction/rejection" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <MfTransactionsRejection />
            </Suspense>} />
            <Route path="/operations/files_upload_history" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FilesUploadHistory />
            </Suspense>} />
            <Route path="/operations/bulkMfTransactions" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BulkMfTransactions />
            </Suspense>} />
            <Route path="/operations/files-upload-bulk-mf-transactions" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FilesUploadBulkMfTransactions />
            </Suspense>} />

              {/*MIS Report Scheduler Report */}
            <Route path="/reports/schedule-manage" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchedulerEmailReportManage />
            </Suspense>} />
            <Route path="/reports/schedule-add" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchedulerEmailReportAdd />
            </Suspense>} />
            <Route path="/reports/schedule-edit/:id" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchedulerEmailReportAdd />
            </Suspense>} />
            <Route path="/reports/schedule-archived" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <SchedulerEmailReportArchived />
            </Suspense>} />
            <Route path="/operations/bulkMfSystematicTransactions" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <BulkMfSystematicTransactions />
            </Suspense>} />
            <Route path="/operations/files-upload-bulk-mf-systematic-transactions" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <FilesUploadBulkMfSystematicTransactions />
            </Suspense>} />
            <Route path="/admin/expiring-systematic-plans" element={<Suspense fallback={<><Loader show={true} /></>}>
              <AdminExpiringSystematicPlansViewDetails />
            </Suspense>} />
            <Route path="/admin/aum-report" element={<Suspense fallback={<> <Loader show={true} /> </>}  >
              <AUMReport/>
            </Suspense>} />


            {/*RTA Client Master*/}
            <Route path="/rta-client-master" element={<Suspense fallback={<> <Loader show={true}/> </>} >
              <RTAClientMaster/>
            </Suspense>} />
            <Route path="/rta-client-master-upload" element={<Suspense fallback={<> <Loader show={true}/> </>} >
              <RTAClientMaasterUpload/>
            </Suspense>} />
            <Route path="/rta-client-master-error" element={<Suspense fallback={<> <Loader show={true}/> </>} >
              <RTAClientMasterError/>
            </Suspense>} />
            <Route path="/rta-client-master-archived" element={<Suspense fallback={<> <Loader show={true}/> </>} >
              <RTAClientMasterArchived/>
            </Suspense>} />
            
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default Navigation;
